import { GraphQLClient, RequestOptions } from 'graphql-request';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: { input: string; output: string; }
  Long: { input: number; output: number; }
  /** The `Milliseconds` scalar type represents a period of time represented as the total number of milliseconds in range [-922337203685477, 922337203685477]. */
  Milliseconds: { input: number; output: number; }
  /** The `Period` scalar type represents a period of time. `Period` expects periods to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  Period: { input: string; output: string; }
  UInt: { input: number; output: number; }
  ULong: { input: number; output: number; }
  Uri: { input: string; output: string; }
};

export type GqlAcceptFactoryInvitationInput = {
  /** The ID of the Invitation to accept */
  invitationId: Scalars['ID']['input'];
};

export type GqlAcceptFactoryInvitationPayload = {
  __typename?: 'AcceptFactoryInvitationPayload';
  /** The accepted invitation */
  invitation: GqlFactoryInvitation;
};

export type GqlActivateModelInput = {
  /** The named training configuration to use */
  configurationName?: GqlModelConfigurationName;
  /** The ID of the Model */
  id: Scalars['ID']['input'];
};

export type GqlActivateModelPayload = {
  __typename?: 'ActivateModelPayload';
  /** The updated model */
  model: GqlModel;
};

/** The active model credit usage for a factory */
export type GqlActiveModelCreditsUsage = {
  __typename?: 'ActiveModelCreditsUsage';
  /** Active model credits usage by batch models */
  batch: GqlActiveModelTypeCreditsUsage;
  /** Active model credits usage by streaming models */
  streaming: GqlActiveModelTypeCreditsUsage;
  /** The total active model credits used */
  total: Scalars['Int']['output'];
};

export const GqlActiveModelType = {
  Batch: 'BATCH',
  Streaming: 'STREAMING'
} as const;

export type GqlActiveModelType = typeof GqlActiveModelType[keyof typeof GqlActiveModelType];
/** The active model credit usage for a specific model activation type */
export type GqlActiveModelTypeCreditsUsage = {
  __typename?: 'ActiveModelTypeCreditsUsage';
  /** The number of credits used for each active model of this type */
  creditsPerModel: Scalars['Int']['output'];
  /** The number of active models of this type */
  models: Scalars['Int']['output'];
  /** The total credits used by models of this type */
  total: Scalars['Int']['output'];
  /** The type of active model credit */
  type: GqlActiveModelType;
};

export type GqlAddAnomalyCommentInput = {
  /** The ID of the Anomaly */
  anomalyId: Scalars['ID']['input'];
  /** The comment text to add */
  comment: Scalars['String']['input'];
};

export type GqlAddAnomalyCommentPayload = {
  __typename?: 'AddAnomalyCommentPayload';
  /** The added comment */
  comment: GqlAnomalyComment;
};

export type GqlAddInputTagsToModelInput = {
  /** The ID of the Model */
  id: Scalars['ID']['input'];
  /** The ID of the tags to add as inputs */
  tagIds: Array<Scalars['ID']['input']>;
};

export type GqlAddInputTagsToModelPayload = {
  __typename?: 'AddInputTagsToModelPayload';
  /** The updated model */
  model: GqlModel;
};

export type GqlAddStarInput = {
  /** The Starrable ID to star. */
  starrableId: Scalars['ID']['input'];
};

export type GqlAddStarPayload = {
  __typename?: 'AddStarPayload';
  /** The starrable. */
  starrable?: Maybe<GqlStarrable>;
};

export type GqlAddUserInput = {
  /** The ID of the Customer to add the user to */
  customerId: Scalars['ID']['input'];
  /** The user's email address */
  email: Scalars['String']['input'];
  /** The factory roles to assign to the user. Must contain at least one. */
  factoryRoles: Array<GqlFactoryRoleInput>;
  /** The user's name */
  name: Scalars['String']['input'];
  /** The role to assign the user in the customer */
  role?: GqlCustomerRole;
};

export type GqlAddUserPayload = {
  __typename?: 'AddUserPayload';
  /** The added user. */
  user: GqlUser;
};

/** An agent */
export type GqlAgent = GqlNode & {
  __typename?: 'Agent';
  createdOn: Scalars['DateTime']['output'];
  hostname?: Maybe<Scalars['String']['output']>;
  /** Global node Id */
  id: Scalars['ID']['output'];
  lastPing?: Maybe<Scalars['DateTime']['output']>;
  listCertificates: GqlAgentCertificatesResponse;
  opcConnections?: Maybe<GqlOpcConnectionConnection>;
  opcSubscriptions?: Maybe<GqlOpcSubscriptionConnection>;
  ping: GqlAgentResponse;
  serverEndpoints: GqlAgentOpcEndpointDescriptionsResponse;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  validateOpcConnection: GqlValidateOpcConnectionResponse;
  version?: Maybe<Scalars['String']['output']>;
};


/** An agent */
export type GqlAgentListCertificatesArgs = {
  timeout?: Scalars['Milliseconds']['input'];
};


/** An agent */
export type GqlAgentOpcConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An agent */
export type GqlAgentOpcSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An agent */
export type GqlAgentPingArgs = {
  timeout?: Scalars['Milliseconds']['input'];
};


/** An agent */
export type GqlAgentServerEndpointsArgs = {
  timeout?: Scalars['Milliseconds']['input'];
  url: Scalars['String']['input'];
};


/** An agent */
export type GqlAgentValidateOpcConnectionArgs = {
  connection: GqlValidateOpcConnectionInput;
  timeout?: Scalars['Milliseconds']['input'];
};

/** Agent Certificate */
export type GqlAgentCertificate = {
  __typename?: 'AgentCertificate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  path: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  thumbprint: Scalars['String']['output'];
};

/** Agent RPC Certificates Response */
export type GqlAgentCertificatesResponse = {
  __typename?: 'AgentCertificatesResponse';
  certificates?: Maybe<Array<GqlAgentCertificate>>;
  error?: Maybe<Scalars['String']['output']>;
};

/** A connection from an object to a list of objects of type `Agent`. */
export type GqlAgentConnection = {
  __typename?: 'AgentConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlAgentEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlAgent>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Agent`. */
export type GqlAgentEdge = {
  __typename?: 'AgentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlAgent>;
};

/** Agent RPC OPC Endpoint Descriptions Response */
export type GqlAgentOpcEndpointDescriptionsResponse = {
  __typename?: 'AgentOpcEndpointDescriptionsResponse';
  endpoints?: Maybe<Array<GqlOpcEndpointDescription>>;
  error?: Maybe<Scalars['String']['output']>;
};

/** An agent release */
export type GqlAgentRelease = {
  __typename?: 'AgentRelease';
  arch: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fullDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isBeta: Scalars['Boolean']['output'];
  os: Scalars['String']['output'];
  release: Scalars['DateTime']['output'];
  semver: Scalars['String']['output'];
  sha256Hash: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  /** The signed URL for downloading the agent release from the storage account. Generated dynamically. */
  url: Scalars['Uri']['output'];
};

/** A connection from an object to a list of objects of type `AgentRelease`. */
export type GqlAgentReleaseConnection = {
  __typename?: 'AgentReleaseConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlAgentReleaseEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlAgentRelease>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `AgentRelease`. */
export type GqlAgentReleaseEdge = {
  __typename?: 'AgentReleaseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlAgentRelease>;
};

/** Agent RPC Response */
export type GqlAgentResponse = {
  __typename?: 'AgentResponse';
  error?: Maybe<Scalars['String']['output']>;
};

/** A data aggregation period. */
export const GqlAggregationPeriod = {
  Day: 'DAY',
  Hour: 'HOUR'
} as const;

export type GqlAggregationPeriod = typeof GqlAggregationPeriod[keyof typeof GqlAggregationPeriod];
/** An anomaly */
export type GqlAnomaly = GqlNode & {
  __typename?: 'Anomaly';
  comments: Array<GqlAnomalyComment>;
  end?: Maybe<Scalars['DateTime']['output']>;
  /** Global node Id */
  id: Scalars['ID']['output'];
  inProgress: Scalars['Boolean']['output'];
  model: GqlAnomalyModel;
  next?: Maybe<GqlAnomaly>;
  previous?: Maybe<GqlAnomaly>;
  restId: Scalars['Int']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  start: Scalars['DateTime']['output'];
  state: GqlAnomalyState;
  /** @deprecated This field is no longer in use and will always return SHORT */
  type: GqlAnomalyType;
};

/** An anomaly comment */
export type GqlAnomalyComment = GqlNode & {
  __typename?: 'AnomalyComment';
  /** The anomaly for this comment */
  anomaly: GqlAnomaly;
  at: Scalars['DateTime']['output'];
  by: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  /** Global node Id */
  id: Scalars['ID']['output'];
};

export type GqlAnomalyCondition = {
  __typename?: 'AnomalyCondition';
  /** The error score to use when evaluating the anomaly condition */
  errorScore: GqlErrorScore;
  /** The value of the threshold */
  threshold: Scalars['Float']['output'];
  /** What kind of threshold */
  thresholdKind: GqlThresholdKind;
};

export type GqlAnomalyConditionInput = {
  /** The kind of error score to use */
  errorScoreKind: GqlErrorScoreKind;
  /** The value of the threshold */
  threshold: Scalars['Float']['input'];
  /** What kind of threshold */
  thresholdKind: GqlThresholdKind;
  /** The transform to apply to the error score */
  transform: GqlTransform;
};

/** A connection from an object to a list of objects of type `Anomaly`. */
export type GqlAnomalyConnection = {
  __typename?: 'AnomalyConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlAnomalyEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlAnomaly>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Anomaly`. */
export type GqlAnomalyEdge = {
  __typename?: 'AnomalyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlAnomaly>;
};

/** An anomaly model definition for a factory */
export type GqlAnomalyModel = GqlModel & GqlNode & GqlStarrable & {
  __typename?: 'AnomalyModel';
  activated?: Maybe<Scalars['DateTime']['output']>;
  activeTrainedModel?: Maybe<GqlTrainedModel>;
  anomalies: Array<GqlAnomaly>;
  anomalyConditions: Array<GqlAnomalyCondition>;
  /** The filter used in anomaly generation */
  anomalyGenerationFilter?: Maybe<Scalars['String']['output']>;
  availableErrorScores: Array<GqlErrorScore>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<GqlUser>;
  description: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use errorScore2 */
  errorScore: GqlTimeSeries;
  errorScore2: GqlTimeSeries;
  /** Global node Id */
  id: Scalars['ID']['output'];
  initialInferenceEnd?: Maybe<Scalars['DateTime']['output']>;
  initialInferenceStart?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use modelInputTags */
  inputTags: Array<GqlTag>;
  lastStateChange: Scalars['DateTime']['output'];
  latestAnomaly?: Maybe<GqlAnomaly>;
  method: GqlModelMethod;
  methodId: Scalars['ID']['output'];
  /** The input tags for this model */
  modelInputTags?: Maybe<GqlModelInputTagConnection>;
  name: Scalars['String']['output'];
  prediction: GqlTimeSeries;
  /**
   * The threshold for short anomalies
   * @deprecated Use anomalyConditions
   */
  shortAnomalyThreshold?: Maybe<Scalars['Float']['output']>;
  /**
   * The threshold for spike anomalies
   * @deprecated Use anomalyConditions
   */
  spikeAnomalyThreshold?: Maybe<Scalars['Float']['output']>;
  state: GqlModelState;
  tag: GqlTag;
  tagId: Scalars['ID']['output'];
  trainedModels: Array<GqlTrainedModel>;
  trainingEnd?: Maybe<Scalars['DateTime']['output']>;
  trainingPeriod?: Maybe<Scalars['Period']['output']>;
  trainingPeriodExclusions: Array<GqlModelTrainingPeriodExclusion>;
  trainingStart?: Maybe<Scalars['DateTime']['output']>;
  type: GqlModelType;
  typeId: Scalars['ID']['output'];
  /** Whether this model uses robust anomaly error scores */
  useRobustAnomalyScores?: Maybe<Scalars['Boolean']['output']>;
  viewerHasStarred: Scalars['Boolean']['output'];
};


/** An anomaly model definition for a factory */
export type GqlAnomalyModelErrorScoreArgs = {
  anomalyType?: InputMaybe<GqlAnomalyType>;
  from: Scalars['DateTime']['input'];
  interval: Scalars['Int']['input'];
  to: Scalars['DateTime']['input'];
};


/** An anomaly model definition for a factory */
export type GqlAnomalyModelErrorScore2Args = {
  errorScoreKind: GqlErrorScoreKind;
  from: Scalars['DateTime']['input'];
  interval: Scalars['Int']['input'];
  to: Scalars['DateTime']['input'];
  transform: GqlTransform;
};


/** An anomaly model definition for a factory */
export type GqlAnomalyModelModelInputTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An anomaly model definition for a factory */
export type GqlAnomalyModelPredictionArgs = {
  from: Scalars['DateTime']['input'];
  interval: Scalars['Int']['input'];
  to: Scalars['DateTime']['input'];
};

export const GqlAnomalyState = {
  Anomaly: 'ANOMALY',
  New: 'NEW',
  NotAnomaly: 'NOT_ANOMALY',
  Uncertain: 'UNCERTAIN'
} as const;

export type GqlAnomalyState = typeof GqlAnomalyState[keyof typeof GqlAnomalyState];
export type GqlAnomalyStateCount = {
  __typename?: 'AnomalyStateCount';
  /** The count of anomalies in that state */
  count: Scalars['Int']['output'];
  /** The anomaly state */
  state: GqlAnomalyState;
};

export const GqlAnomalyType = {
  Short: 'SHORT',
  Spike: 'SPIKE'
} as const;

export type GqlAnomalyType = typeof GqlAnomalyType[keyof typeof GqlAnomalyType];
export type GqlArchiveModelInput = {
  /** The ID of the Model */
  id: Scalars['ID']['input'];
};

export type GqlArchiveModelPayload = {
  __typename?: 'ArchiveModelPayload';
  /** Archived model */
  model: GqlModel;
};

/** An asset in the customer's factory */
export type GqlAsset = GqlNode & {
  __typename?: 'Asset';
  alias?: Maybe<Scalars['String']['output']>;
  hierarchyAsset?: Maybe<GqlHierarchyAsset>;
  /** Global node Id */
  id: Scalars['ID']['output'];
  key: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


/** An asset in the customer's factory */
export type GqlAssetHierarchyAssetArgs = {
  view?: InputMaybe<GqlAssetViewType>;
};

/** A connection from an object to a list of objects of type `Asset`. */
export type GqlAssetConnection = {
  __typename?: 'AssetConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlAssetEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlAsset>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Asset`. */
export type GqlAssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlAsset>;
};

export const GqlAssetViewType = {
  Deployment: 'DEPLOYMENT',
  Model: 'MODEL'
} as const;

export type GqlAssetViewType = typeof GqlAssetViewType[keyof typeof GqlAssetViewType];
export type GqlCancelFactoryInvitationInput = {
  /** The ID of the Invitation to cancel */
  invitationId: Scalars['ID']['input'];
};

export type GqlCancelFactoryInvitationPayload = {
  __typename?: 'CancelFactoryInvitationPayload';
  /** The cancelled invitation */
  invitation: GqlFactoryInvitation;
};

export type GqlCopyModelInput = {
  /** The description of the new model */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the new model */
  name: Scalars['String']['input'];
  /** The ID of the Model to copy */
  sourceId: Scalars['ID']['input'];
};

export type GqlCopyModelPayload = {
  __typename?: 'CopyModelPayload';
  model: GqlModel;
};

export type GqlCreateAssetInput = {
  /** An alias for the new asset */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the factory to create the asset in */
  factoryId: Scalars['ID']['input'];
  /** The name of the new asset */
  name: Scalars['String']['input'];
};

export type GqlCreateAssetPayload = {
  __typename?: 'CreateAssetPayload';
  /** The new asset */
  asset: GqlAsset;
};

export type GqlCreateModelInput = {
  /** A description of the model */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the factory to create the model in */
  factoryId: Scalars['ID']['input'];
  /** The forecast horizon in seconds. Only used in forecast models */
  forecastHorizon?: InputMaybe<Scalars['Int']['input']>;
  /** The IDs of the model's input Tags */
  inputTagIds: Array<Scalars['ID']['input']>;
  /** The ID of the ModelMethod */
  methodId: Scalars['ID']['input'];
  /** The name of the new model */
  name: Scalars['String']['input'];
  /** The ID of the model's output Tag */
  tagId: Scalars['ID']['input'];
  trainingEnd?: InputMaybe<Scalars['DateTime']['input']>;
  trainingPeriod?: InputMaybe<Scalars['Period']['input']>;
  trainingStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** The ID of the ModelType */
  typeId: Scalars['ID']['input'];
};

export type GqlCreateModelPayload = {
  __typename?: 'CreateModelPayload';
  model: GqlModel;
};

export type GqlCreateOpcConnectionInput = {
  /** The ID of the Agent */
  agentId: Scalars['ID']['input'];
  /** The endpoint credentials */
  credentials?: InputMaybe<GqlOpcCredentialsInput>;
  /** The endpoint URL for the connection */
  endpoint: Scalars['Uri']['input'];
  /** Whether to override the endpoint addresses returned by the server */
  ignoreServerEndpoint: Scalars['Boolean']['input'];
  /** The name of the connection */
  name: Scalars['String']['input'];
  /** The endpoint security mode */
  securityMode?: InputMaybe<GqlOpcSecurityMode>;
  /** The endpoint security policy */
  securityPolicy?: InputMaybe<GqlOpcSecurityPolicy>;
  /** The thumbprint of the agent certificate to use for connections */
  x509Thumbprint?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCreateOpcConnectionPayload = {
  __typename?: 'CreateOpcConnectionPayload';
  /** The created connection */
  connection: GqlOpcConnection;
};

export type GqlCreateOpcSyncJobInput = {
  /** The timeout for each node browse request in the OPC-UA Sync. */
  browseTimeout?: InputMaybe<Scalars['Milliseconds']['input']>;
  /** The ID of the OPC-UA Sync Job Definiton to update. */
  connectionId: Scalars['ID']['input'];
  /** The cron schedule Nomad should use for job orchestration. */
  cronSchedule: Scalars['String']['input'];
  /** The starting node for an OPC-UA Sync. */
  startNode?: InputMaybe<Scalars['String']['input']>;
  /** Enable or disable the periodic schedule. */
  syncEnabled: Scalars['Boolean']['input'];
  /** The timeout before the OPC-UA Job Orchestrator will stop a sync that hasn't been updated. */
  syncTimeout?: InputMaybe<Scalars['Milliseconds']['input']>;
};

export type GqlCreatePrescriptiveModelInput = {
  /** A description of the model */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the factory to create the model in */
  factoryId: Scalars['ID']['input'];
  /** The input Tags */
  inputTags: Array<GqlPrescriptiveModelTagInput>;
  /** The name of the new model */
  name: Scalars['String']['input'];
  /** The ID of the target Tag */
  targetTagId: Scalars['ID']['input'];
  /** The target value for the target Tag */
  targetValue: Scalars['Float']['input'];
};

export type GqlCreatePrescriptiveModelPayload = {
  __typename?: 'CreatePrescriptiveModelPayload';
  model: GqlPrescriptiveModel;
};

export type GqlCreateTrendViewInput = {
  /** The configuration for the TrendView */
  data: Scalars['String']['input'];
  /** The ID of the factory to create the asset in */
  factoryId: Scalars['ID']['input'];
  /** The name of the new TrendView */
  name: Scalars['String']['input'];
  /** If the TrendView should be shared within the factory */
  shared: Scalars['Boolean']['input'];
};

export type GqlCreateTrendViewPayload = {
  __typename?: 'CreateTrendViewPayload';
  /** The new TrendView */
  trendView: GqlTrendView;
};

/** An Intelecy customer */
export type GqlCustomer = GqlNode & {
  __typename?: 'Customer';
  factories?: Maybe<GqlFactoryConnection>;
  factoryCount: Scalars['Int']['output'];
  /** Global node Id */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Lists all users that are not part of this customer but have been granted access to one of the customer's factories */
  outsideCollaborators?: Maybe<GqlUserConnection>;
  userCount: Scalars['Int']['output'];
  /** Lists all member of this customer */
  users?: Maybe<GqlCustomerUserConnection>;
  viewerRole?: Maybe<GqlCustomerRole>;
};


/** An Intelecy customer */
export type GqlCustomerFactoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Intelecy customer */
export type GqlCustomerOutsideCollaboratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Intelecy customer */
export type GqlCustomerUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<GqlUserStatus>;
};

export const GqlCustomerRole = {
  Admin: 'ADMIN',
  Member: 'MEMBER'
} as const;

export type GqlCustomerRole = typeof GqlCustomerRole[keyof typeof GqlCustomerRole];
/** A connection from an object to a list of objects of type `User`. */
export type GqlCustomerUserConnection = {
  __typename?: 'CustomerUserConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlCustomerUserEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlUser>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection from an object to another object of type `User`. */
export type GqlCustomerUserEdge = {
  __typename?: 'CustomerUserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlUser>;
  /** The user's role in the customer */
  role: GqlCustomerRole;
};

/** Dashboard data for a tag */
export type GqlDashboardData = {
  __typename?: 'DashboardData';
  /** Timestamps for the dashboard data values. They are the start time of the aggregation period for the requested timezone, but are returned in UTC. */
  timestamps: Array<Scalars['DateTime']['output']>;
  /** Values corresponding the to timestamps. */
  values: Array<Scalars['Float']['output']>;
};

export type GqlDeclineFactoryInvitationInput = {
  /** The ID of the Invitation to decline */
  invitationId: Scalars['ID']['input'];
};

export type GqlDeclineFactoryInvitationPayload = {
  __typename?: 'DeclineFactoryInvitationPayload';
  /** The declined invitation */
  invitation: GqlFactoryInvitation;
};

export type GqlDeleteAssetInput = {
  /** The ID of the asset to delete */
  id: Scalars['ID']['input'];
};

export type GqlDeleteAssetPayload = {
  __typename?: 'DeleteAssetPayload';
  /** The ID of the deleted Asset */
  id: Scalars['ID']['output'];
};

export type GqlDeleteModelInput = {
  /** The ID of the Model */
  id: Scalars['ID']['input'];
};

export type GqlDeleteModelPayload = {
  __typename?: 'DeleteModelPayload';
  /** Deleted model */
  model: GqlModel;
};

export type GqlDeleteTrendViewInput = {
  /** The ID of the TrendView to update */
  trendViewId: Scalars['ID']['input'];
};

export type GqlDeleteTrendViewPayload = {
  __typename?: 'DeleteTrendViewPayload';
  /** The deleted TrendView */
  trendView: GqlTrendView;
};

export type GqlDisableUserInput = {
  /** The ID of the User */
  id: Scalars['ID']['input'];
};

export type GqlDisableUserPayload = {
  __typename?: 'DisableUserPayload';
  /** The updated user. */
  user: GqlUser;
};

/** Information for constructing a documentation URL */
export type GqlDocumentationUrl = {
  __typename?: 'DocumentationUrl';
  expiry: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GqlEnableUserInput = {
  /** The ID of the User */
  id: Scalars['ID']['input'];
};

export type GqlEnableUserPayload = {
  __typename?: 'EnableUserPayload';
  /** The updated user. */
  user: GqlUser;
};

/** An anomaly error score */
export type GqlErrorScore = {
  __typename?: 'ErrorScore';
  /** The error score kind */
  kind: GqlErrorScoreKind;
  /** Is the error score robust to outliers */
  robust: Scalars['Boolean']['output'];
  /** The series name for the error score */
  seriesName: Scalars['String']['output'];
  /** The transform to apply to the error score */
  transform: GqlTransform;
};

export const GqlErrorScoreKind = {
  Absolute: 'ABSOLUTE',
  Signed: 'SIGNED'
} as const;

export type GqlErrorScoreKind = typeof GqlErrorScoreKind[keyof typeof GqlErrorScoreKind];
/** An intelecy factory */
export type GqlFactory = GqlNode & {
  __typename?: 'Factory';
  activeModelCreditsUsage?: Maybe<GqlActiveModelCreditsUsage>;
  /** @deprecated Use the node query */
  agent?: Maybe<GqlAgent>;
  agents?: Maybe<GqlAgentConnection>;
  /** Return the anomalies across all models in the factory */
  anomalies?: Maybe<GqlAnomalyConnection>;
  /**
   * Retrieve a single anomaly from the Factory
   * @deprecated Use the node query
   */
  anomaly?: Maybe<GqlAnomaly>;
  anomalyCountByState: Array<GqlAnomalyStateCount>;
  assets?: Maybe<GqlAssetConnection>;
  /** The customer this factory belongs to */
  customer: GqlCustomer;
  dexAccess: Scalars['Boolean']['output'];
  hierarchy: GqlHierarchy;
  /** Global node Id */
  id: Scalars['ID']['output'];
  /** All of the users invited to the factory */
  invitations?: Maybe<GqlFactoryInvitationConnection>;
  latestAnomalyComments: Array<GqlAnomalyComment>;
  /** @deprecated Use the node query */
  model?: Maybe<GqlModel>;
  models?: Maybe<GqlModelInterfaceConnection>;
  name: Scalars['String']['output'];
  tagByName?: Maybe<GqlTag>;
  tags?: Maybe<GqlTagConnection>;
  tagsByName: Array<Maybe<GqlTag>>;
  /** Return the available trend views in this factory */
  trendViews?: Maybe<GqlTrendViewConnection>;
  userCount: Scalars['Int']['output'];
  /** All of the users associated with the factory */
  users?: Maybe<GqlFactoryUserConnection>;
  /** The role of the viewing user within this factory */
  viewerRole?: Maybe<GqlFactoryRole>;
};


/** An intelecy factory */
export type GqlFactoryAgentArgs = {
  id: Scalars['ID']['input'];
};


/** An intelecy factory */
export type GqlFactoryAgentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An intelecy factory */
export type GqlFactoryAnomaliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


/** An intelecy factory */
export type GqlFactoryAnomalyArgs = {
  id: Scalars['ID']['input'];
};


/** An intelecy factory */
export type GqlFactoryAnomalyCountByStateArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


/** An intelecy factory */
export type GqlFactoryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** An intelecy factory */
export type GqlFactoryHierarchyArgs = {
  view: GqlAssetViewType;
};


/** An intelecy factory */
export type GqlFactoryInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An intelecy factory */
export type GqlFactoryLatestAnomalyCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** An intelecy factory */
export type GqlFactoryModelArgs = {
  id: Scalars['ID']['input'];
};


/** An intelecy factory */
export type GqlFactoryModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  methodId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<GqlModelState>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
};


/** An intelecy factory */
export type GqlFactoryTagByNameArgs = {
  tagname: Scalars['String']['input'];
};


/** An intelecy factory */
export type GqlFactoryTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An intelecy factory */
export type GqlFactoryTagsByNameArgs = {
  tagnames: Array<Scalars['String']['input']>;
};


/** An intelecy factory */
export type GqlFactoryTrendViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An intelecy factory */
export type GqlFactoryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<GqlUserStatus>;
};

/** A connection from an object to a list of objects of type `Factory`. */
export type GqlFactoryConnection = {
  __typename?: 'FactoryConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlFactoryEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlFactory>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection from an object to another object of type `Factory`. */
export type GqlFactoryEdge = {
  __typename?: 'FactoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlFactory>;
};

/** An invitation to join a factory */
export type GqlFactoryInvitation = GqlNode & {
  __typename?: 'FactoryInvitation';
  /** The date and time when the invitation was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date and time when the invitation was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The factory the invitation is for. */
  factory: GqlFactory;
  /** Global node Id */
  id: Scalars['ID']['output'];
  /** The user who was invited to the factory. */
  invitee: GqlUser;
  /** The user who created the invitation. */
  inviter: GqlUser;
  /** The invitee's pending role in the factory. */
  role: GqlFactoryRole;
  /** The state of the invitation */
  state: GqlInvitationState;
  /** The date and time when the invitation expires. */
  validUntil: Scalars['DateTime']['output'];
};

/** A connection from an object to a list of objects of type `FactoryInvitation`. */
export type GqlFactoryInvitationConnection = {
  __typename?: 'FactoryInvitationConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlFactoryInvitationEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlFactoryInvitation>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `FactoryInvitation`. */
export type GqlFactoryInvitationEdge = {
  __typename?: 'FactoryInvitationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlFactoryInvitation>;
};

export const GqlFactoryRole = {
  Admin: 'ADMIN',
  Reader: 'READER',
  Writer: 'WRITER'
} as const;

export type GqlFactoryRole = typeof GqlFactoryRole[keyof typeof GqlFactoryRole];
export type GqlFactoryRoleInput = {
  /** The ID of the Factory to give the user access to */
  factoryId: Scalars['ID']['input'];
  /** The role to assign the user in the factory */
  role: GqlFactoryRole;
};

/** A connection from an object to a list of objects of type `User`. */
export type GqlFactoryUserConnection = {
  __typename?: 'FactoryUserConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlFactoryUserEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlUser>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection from an object to another object of type `User`. */
export type GqlFactoryUserEdge = {
  __typename?: 'FactoryUserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlUser>;
  /** The user's role in the factory */
  role: GqlFactoryRole;
};

/** A forecast model definition for a factory */
export type GqlForecastModel = GqlModel & GqlNode & GqlStarrable & {
  __typename?: 'ForecastModel';
  activated?: Maybe<Scalars['DateTime']['output']>;
  activeTrainedModel?: Maybe<GqlTrainedModel>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<GqlUser>;
  description: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The forecast horizon in seconds */
  forecastHorizon?: Maybe<Scalars['Int']['output']>;
  /** Returns the historical forecast values for a given model */
  historicalForecast: GqlTimeSeries;
  /** Global node Id */
  id: Scalars['ID']['output'];
  initialInferenceEnd?: Maybe<Scalars['DateTime']['output']>;
  initialInferenceStart?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use modelInputTags */
  inputTags: Array<GqlTag>;
  lastStateChange: Scalars['DateTime']['output'];
  method: GqlModelMethod;
  methodId: Scalars['ID']['output'];
  /** The input tags for this model */
  modelInputTags?: Maybe<GqlModelInputTagConnection>;
  name: Scalars['String']['output'];
  state: GqlModelState;
  tag: GqlTag;
  tagId: Scalars['ID']['output'];
  trainedModels: Array<GqlTrainedModel>;
  trainingEnd?: Maybe<Scalars['DateTime']['output']>;
  trainingPeriod?: Maybe<Scalars['Period']['output']>;
  trainingPeriodExclusions: Array<GqlModelTrainingPeriodExclusion>;
  trainingStart?: Maybe<Scalars['DateTime']['output']>;
  type: GqlModelType;
  typeId: Scalars['ID']['output'];
  viewerHasStarred: Scalars['Boolean']['output'];
};


/** A forecast model definition for a factory */
export type GqlForecastModelHistoricalForecastArgs = {
  from: Scalars['DateTime']['input'];
  offset: Scalars['Milliseconds']['input'];
  to: Scalars['DateTime']['input'];
};


/** A forecast model definition for a factory */
export type GqlForecastModelModelInputTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A point in a forecast */
export type GqlForecastPoint = {
  __typename?: 'ForecastPoint';
  /** The lower bound for the forecast range at this time */
  intervalLower?: Maybe<Scalars['Float']['output']>;
  /** The upper bound for the forecast range at this time */
  intervalUpper?: Maybe<Scalars['Float']['output']>;
  /** The time for this point */
  timestamp: Scalars['DateTime']['output'];
  /** The forecasted value at this time */
  value: Scalars['Float']['output'];
};

export const GqlHealth = {
  Green: 'GREEN',
  Red: 'RED',
  Yellow: 'YELLOW'
} as const;

export type GqlHealth = typeof GqlHealth[keyof typeof GqlHealth];
/** A hierarchy of assets and tags */
export type GqlHierarchy = {
  __typename?: 'Hierarchy';
  assets?: Maybe<GqlHierarchyAssetConnection>;
  tags?: Maybe<GqlHierarchyTagConnection>;
  view: GqlAssetViewType;
};


/** A hierarchy of assets and tags */
export type GqlHierarchyAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** A hierarchy of assets and tags */
export type GqlHierarchyTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** An asset in the asset hierarchy */
export type GqlHierarchyAsset = GqlNode & {
  __typename?: 'HierarchyAsset';
  asset: GqlAsset;
  assetId: Scalars['ID']['output'];
  /** Global node Id */
  id: Scalars['ID']['output'];
  parentAsset?: Maybe<GqlAsset>;
  parentAssetId?: Maybe<Scalars['ID']['output']>;
  viewType: GqlAssetViewType;
};

/** A connection from an object to a list of objects of type `HierarchyAsset`. */
export type GqlHierarchyAssetConnection = {
  __typename?: 'HierarchyAssetConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlHierarchyAssetEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlHierarchyAsset>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `HierarchyAsset`. */
export type GqlHierarchyAssetEdge = {
  __typename?: 'HierarchyAssetEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlHierarchyAsset>;
};

/** A tag in the asset hierarchy */
export type GqlHierarchyTag = GqlNode & {
  __typename?: 'HierarchyTag';
  asset: GqlAsset;
  assetId: Scalars['ID']['output'];
  /** Global node Id */
  id: Scalars['ID']['output'];
  tag: GqlTag;
  tagId: Scalars['ID']['output'];
  viewType: GqlAssetViewType;
};

/** A connection from an object to a list of objects of type `HierarchyTag`. */
export type GqlHierarchyTagConnection = {
  __typename?: 'HierarchyTagConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlHierarchyTagEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlHierarchyTag>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `HierarchyTag`. */
export type GqlHierarchyTagEdge = {
  __typename?: 'HierarchyTagEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlHierarchyTag>;
};

export const GqlInvitationState = {
  Accepted: 'ACCEPTED',
  Active: 'ACTIVE',
  Cancelled: 'CANCELLED',
  Declined: 'DECLINED',
  Expired: 'EXPIRED'
} as const;

export type GqlInvitationState = typeof GqlInvitationState[keyof typeof GqlInvitationState];
export type GqlInviteFactoryUserInput = {
  /** The user's email address */
  email: Scalars['String']['input'];
  /** The ID of the Factory to give the user access to */
  factoryId: Scalars['ID']['input'];
  /** The role to assign the user in the factory */
  role: GqlFactoryRole;
};

export type GqlInviteFactoryUserPayload = {
  __typename?: 'InviteFactoryUserPayload';
  /** The invitation */
  invitation: GqlFactoryInvitation;
};

/** A model definition for a factory */
export type GqlModel = {
  activated?: Maybe<Scalars['DateTime']['output']>;
  activeTrainedModel?: Maybe<GqlTrainedModel>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<GqlUser>;
  description: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Global node Id */
  id: Scalars['ID']['output'];
  initialInferenceEnd?: Maybe<Scalars['DateTime']['output']>;
  initialInferenceStart?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use modelInputTags */
  inputTags?: Maybe<Array<Maybe<GqlTag>>>;
  lastStateChange: Scalars['DateTime']['output'];
  method?: Maybe<GqlModelMethod>;
  methodId: Scalars['ID']['output'];
  modelInputTags?: Maybe<GqlModelInputTagConnection>;
  name: Scalars['String']['output'];
  state: GqlModelState;
  tag?: Maybe<GqlTag>;
  tagId: Scalars['ID']['output'];
  trainedModels?: Maybe<Array<Maybe<GqlTrainedModel>>>;
  trainingEnd?: Maybe<Scalars['DateTime']['output']>;
  trainingPeriod?: Maybe<Scalars['Period']['output']>;
  trainingPeriodExclusions: Array<GqlModelTrainingPeriodExclusion>;
  trainingStart?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<GqlModelType>;
  typeId: Scalars['ID']['output'];
  viewerHasStarred: Scalars['Boolean']['output'];
};


/** A model definition for a factory */
export type GqlModelModelInputTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A named model configuration. */
export const GqlModelConfigurationName = {
  Default: 'DEFAULT',
  Lemur: 'LEMUR',
  Lizard: 'LIZARD'
} as const;

export type GqlModelConfigurationName = typeof GqlModelConfigurationName[keyof typeof GqlModelConfigurationName];
/** A connection from an object to a list of objects of type `Tag`. */
export type GqlModelInputTagConnection = {
  __typename?: 'ModelInputTagConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlModelInputTagEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlTag>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Tag`. */
export type GqlModelInputTagEdge = {
  __typename?: 'ModelInputTagEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** Is this a controllable tag */
  isControllable: Scalars['Boolean']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlTag>;
};

/** A connection from an object to a list of objects of type `ModelInterface`. */
export type GqlModelInterfaceConnection = {
  __typename?: 'ModelInterfaceConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlModelInterfaceEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlModel>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ModelInterface`. */
export type GqlModelInterfaceEdge = {
  __typename?: 'ModelInterfaceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlModel>;
};

/** The method to use when executing the model */
export type GqlModelMethod = GqlNode & {
  __typename?: 'ModelMethod';
  /** Global node Id */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export const GqlModelState = {
  Archived: 'ARCHIVED',
  AwaitingAnomalyAnalysis: 'AWAITING_ANOMALY_ANALYSIS',
  Deleted: 'DELETED',
  Error: 'ERROR',
  InitialAnomalyDetection: 'INITIAL_ANOMALY_DETECTION',
  InitialInference: 'INITIAL_INFERENCE',
  New: 'NEW',
  NotRunning: 'NOT_RUNNING',
  Running: 'RUNNING',
  Streaming: 'STREAMING',
  Training: 'TRAINING'
} as const;

export type GqlModelState = typeof GqlModelState[keyof typeof GqlModelState];
/** A time period for exclusion from model training */
export type GqlModelTrainingPeriodExclusion = {
  __typename?: 'ModelTrainingPeriodExclusion';
  end: Scalars['DateTime']['output'];
  modelId: Scalars['ID']['output'];
  start: Scalars['DateTime']['output'];
};

/** A type of model */
export type GqlModelType = GqlNode & {
  __typename?: 'ModelType';
  defaultMethod: GqlModelMethod;
  defaultMethodId: Scalars['ID']['output'];
  /** Global node Id */
  id: Scalars['ID']['output'];
  methods: Array<GqlModelMethod>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlMutation = {
  __typename?: 'Mutation';
  /** Accept an invitation to join a factory. Can only be called by the Invitee. */
  acceptFactoryInvitation?: Maybe<GqlAcceptFactoryInvitationPayload>;
  /** Activate the model and trigger training. No changes can be made to the model after this point. */
  activateModel?: Maybe<GqlActivateModelPayload>;
  addAnomalyComment?: Maybe<GqlAddAnomalyCommentPayload>;
  addInputTagsToModel?: Maybe<GqlAddInputTagsToModelPayload>;
  addStar?: Maybe<GqlAddStarPayload>;
  /** Adds a new user to a customer */
  addUser?: Maybe<GqlAddUserPayload>;
  archiveModel?: Maybe<GqlArchiveModelPayload>;
  /** Cancel an invitation to join a factory */
  cancelFactoryInvitation?: Maybe<GqlCancelFactoryInvitationPayload>;
  copyModel?: Maybe<GqlCopyModelPayload>;
  createAsset?: Maybe<GqlCreateAssetPayload>;
  createModel?: Maybe<GqlCreateModelPayload>;
  /** Create a new OPC-UA connection for an Agent */
  createOpcConnection?: Maybe<GqlCreateOpcConnectionPayload>;
  /** Create a new OPC-UA Sync Job for an OpcConnection */
  createOpcUaJobDefinition?: Maybe<GqlCreateOpcConnectionPayload>;
  createPrescriptiveModel?: Maybe<GqlCreatePrescriptiveModelPayload>;
  createTrendView?: Maybe<GqlCreateTrendViewPayload>;
  /** Decline an invitation to join a factory. Can only be called by the Invitee. */
  declineFactoryInvitation?: Maybe<GqlDeclineFactoryInvitationPayload>;
  deleteAsset?: Maybe<GqlDeleteAssetPayload>;
  deleteModel?: Maybe<GqlDeleteModelPayload>;
  deleteTrendView?: Maybe<GqlDeleteTrendViewPayload>;
  disableUser?: Maybe<GqlDisableUserPayload>;
  enableUser?: Maybe<GqlEnableUserPayload>;
  /** Invites an existing user to join a factory */
  inviteFactoryUser?: Maybe<GqlInviteFactoryUserPayload>;
  /** Removes a user's access to a customer */
  removeCustomerUser?: Maybe<GqlRemoveCustomerUserPayload>;
  /** Removes a user's access to a factory */
  removeFactoryUser?: Maybe<GqlRemoveFactoryUserPayload>;
  removeInputTagsFromModel?: Maybe<GqlRemoveInputTagsFromModelPayload>;
  removeStar?: Maybe<GqlRemoveStarPayload>;
  runAnomalyDetection?: Maybe<GqlRunAnomalyDetectionPayload>;
  setAnomalyState?: Maybe<GqlSetAnomalyStatePayload>;
  setAssetParent?: Maybe<GqlSetAssetParentPayload>;
  /** Creates or updates a user's role in a factory */
  setCustomerUserRole?: Maybe<GqlSetCustomerUserRolePayload>;
  /** Creates or updates a user's role in a factory */
  setFactoryUserRole?: Maybe<GqlSetFactoryUserRolePayload>;
  /** Sets the training configuration for a model */
  setModelTrainingConfiguration?: Maybe<GqlSetModelTrainingConfigurationPayload>;
  setTagsParent?: Maybe<GqlSetTagsParentPayload>;
  startModel?: Maybe<GqlStartModelPayload>;
  stopModel?: Maybe<GqlStopModelPayload>;
  /** Sends a stop request to the running sync task */
  stopSyncTask?: Maybe<GqlStopSyncTaskPayload>;
  updateAsset?: Maybe<GqlUpdateAssetPayload>;
  updateModel?: Maybe<GqlUpdateModelPayload>;
  updateModelAnomalyAnalysisComplete?: Maybe<GqlUpdateModelAnomalyAnalysisCompletePayload>;
  updateModelAnomalyConditions?: Maybe<GqlUpdateModelAnomalyConditionsPayload>;
  updateModelFilter?: Maybe<GqlUpdateModelFilterPayload>;
  updateModelInitialAnomalyDetectionComplete?: Maybe<GqlUpdateModelInitialAnomalyDetectionCompletePayload>;
  updateModelInitialInferenceComplete?: Maybe<GqlUpdateModelInitialInferenceCompletePayload>;
  /** @deprecated Use updateModelAnomalyConditions */
  updateModelThresholds?: Maybe<GqlUpdateModelThresholdsPayload>;
  /** Update an OPC-UA connection for an Agent */
  updateOpcConnection?: Maybe<GqlUpdateOpcConnectionPayload>;
  /** Update an OPC-UA job definition */
  updateOpcUaJobDefinition?: Maybe<GqlUpdateOpcUaJobDefinitionPayload>;
  updatePrescriptiveModelTags?: Maybe<GqlUpdatePrescriptiveModelTagsPayload>;
  /** Used for subscribing and unsubscribing to OPC-UA nodes for a subscription. */
  updateSubscribedNodes?: Maybe<GqlUpdateSubscribedNodesPayload>;
  updateTag?: Maybe<GqlUpdateTagPayload>;
  updateTrainedModel?: Maybe<GqlUpdateTrainedModelPayload>;
  updateTrainingTask?: Maybe<GqlUpdateTrainingTaskPayload>;
  updateTrendView?: Maybe<GqlUpdateTrendViewPayload>;
  updateUserConsent?: Maybe<GqlUpdateUserConsentPayload>;
  updateUserDefaultFactory?: Maybe<GqlUpdateUserDefaultFactoryPayload>;
  updateUserName?: Maybe<GqlUpdateUserNamePayload>;
};


export type GqlMutationAcceptFactoryInvitationArgs = {
  input: GqlAcceptFactoryInvitationInput;
};


export type GqlMutationActivateModelArgs = {
  input: GqlActivateModelInput;
};


export type GqlMutationAddAnomalyCommentArgs = {
  input: GqlAddAnomalyCommentInput;
};


export type GqlMutationAddInputTagsToModelArgs = {
  input: GqlAddInputTagsToModelInput;
};


export type GqlMutationAddStarArgs = {
  input: GqlAddStarInput;
};


export type GqlMutationAddUserArgs = {
  input: GqlAddUserInput;
};


export type GqlMutationArchiveModelArgs = {
  input: GqlArchiveModelInput;
};


export type GqlMutationCancelFactoryInvitationArgs = {
  input: GqlCancelFactoryInvitationInput;
};


export type GqlMutationCopyModelArgs = {
  input: GqlCopyModelInput;
};


export type GqlMutationCreateAssetArgs = {
  input: GqlCreateAssetInput;
};


export type GqlMutationCreateModelArgs = {
  input: GqlCreateModelInput;
};


export type GqlMutationCreateOpcConnectionArgs = {
  input: GqlCreateOpcConnectionInput;
};


export type GqlMutationCreateOpcUaJobDefinitionArgs = {
  input: GqlCreateOpcSyncJobInput;
};


export type GqlMutationCreatePrescriptiveModelArgs = {
  input: GqlCreatePrescriptiveModelInput;
};


export type GqlMutationCreateTrendViewArgs = {
  input: GqlCreateTrendViewInput;
};


export type GqlMutationDeclineFactoryInvitationArgs = {
  input: GqlDeclineFactoryInvitationInput;
};


export type GqlMutationDeleteAssetArgs = {
  input: GqlDeleteAssetInput;
};


export type GqlMutationDeleteModelArgs = {
  input: GqlDeleteModelInput;
};


export type GqlMutationDeleteTrendViewArgs = {
  input: GqlDeleteTrendViewInput;
};


export type GqlMutationDisableUserArgs = {
  input: GqlDisableUserInput;
};


export type GqlMutationEnableUserArgs = {
  input: GqlEnableUserInput;
};


export type GqlMutationInviteFactoryUserArgs = {
  input: GqlInviteFactoryUserInput;
};


export type GqlMutationRemoveCustomerUserArgs = {
  input: GqlRemoveCustomerUserInput;
};


export type GqlMutationRemoveFactoryUserArgs = {
  input: GqlRemoveFactoryUserInput;
};


export type GqlMutationRemoveInputTagsFromModelArgs = {
  input: GqlRemoveInputTagsFromModelInput;
};


export type GqlMutationRemoveStarArgs = {
  input: GqlRemoveStarInput;
};


export type GqlMutationRunAnomalyDetectionArgs = {
  input: GqlRunAnomalyDetectionInput;
};


export type GqlMutationSetAnomalyStateArgs = {
  input: GqlSetAnomalyStateInput;
};


export type GqlMutationSetAssetParentArgs = {
  input: GqlSetAssetParentInput;
};


export type GqlMutationSetCustomerUserRoleArgs = {
  input: GqlSetCustomerUserRoleInput;
};


export type GqlMutationSetFactoryUserRoleArgs = {
  input: GqlSetFactoryUserRoleInput;
};


export type GqlMutationSetModelTrainingConfigurationArgs = {
  input: GqlSetModelTrainingConfigurationInput;
};


export type GqlMutationSetTagsParentArgs = {
  input: GqlSetTagsParentInput;
};


export type GqlMutationStartModelArgs = {
  input: GqlStartModelInput;
};


export type GqlMutationStopModelArgs = {
  input: GqlStopModelInput;
};


export type GqlMutationStopSyncTaskArgs = {
  input: GqlStopSyncTaskInput;
};


export type GqlMutationUpdateAssetArgs = {
  input: GqlUpdateAssetInput;
};


export type GqlMutationUpdateModelArgs = {
  input: GqlUpdateModelInput;
};


export type GqlMutationUpdateModelAnomalyAnalysisCompleteArgs = {
  input: GqlUpdateModelAnomalyAnalysisCompleteInput;
};


export type GqlMutationUpdateModelAnomalyConditionsArgs = {
  input: GqlUpdateModelAnomalyConditionsInput;
};


export type GqlMutationUpdateModelFilterArgs = {
  input: GqlUpdateModelFilterInput;
};


export type GqlMutationUpdateModelInitialAnomalyDetectionCompleteArgs = {
  input: GqlUpdateModelInitialAnomalyDetectionCompleteInput;
};


export type GqlMutationUpdateModelInitialInferenceCompleteArgs = {
  input: GqlUpdateModelInitialInferenceCompleteInput;
};


export type GqlMutationUpdateModelThresholdsArgs = {
  input: GqlUpdateModelThresholdsInput;
};


export type GqlMutationUpdateOpcConnectionArgs = {
  input: GqlUpdateOpcConnectionInput;
};


export type GqlMutationUpdateOpcUaJobDefinitionArgs = {
  input: GqlUpdateOpcUaJobDefinitionInput;
};


export type GqlMutationUpdatePrescriptiveModelTagsArgs = {
  input: GqlUpdatePrescriptiveModelTagsInput;
};


export type GqlMutationUpdateSubscribedNodesArgs = {
  input: GqlUpdateSubscribedNodesInput;
};


export type GqlMutationUpdateTagArgs = {
  input: GqlUpdateTagInput;
};


export type GqlMutationUpdateTrainedModelArgs = {
  input: GqlUpdateTrainedModelInput;
};


export type GqlMutationUpdateTrainingTaskArgs = {
  input: GqlUpdateTrainingTaskInput;
};


export type GqlMutationUpdateTrendViewArgs = {
  input: GqlUpdateTrendViewInput;
};


export type GqlMutationUpdateUserConsentArgs = {
  input: GqlUpdateUserConsentInput;
};


export type GqlMutationUpdateUserDefaultFactoryArgs = {
  input: GqlUpdateUserDefaultFactoryInput;
};


export type GqlMutationUpdateUserNameArgs = {
  input: GqlUpdateUserNameInput;
};

export type GqlNode = {
  /** Global node Id */
  id: Scalars['ID']['output'];
};

export type GqlObjectOpcNode = GqlOpcNode & {
  __typename?: 'ObjectOpcNode';
  browseName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
};

/** Agent RPC OPC Application Description */
export type GqlOpcApplicationDescription = {
  __typename?: 'OpcApplicationDescription';
  applicationName: Scalars['String']['output'];
  applicationType: Scalars['String']['output'];
  applicationURI: Scalars['String']['output'];
  discoveryProfileURI: Scalars['String']['output'];
  discoveryUrls: Array<Scalars['String']['output']>;
  gatewayServerURI: Scalars['String']['output'];
  productURI: Scalars['String']['output'];
};

/** Agent RPC OPC Browse Response */
export type GqlOpcBrowseResponse = {
  __typename?: 'OpcBrowseResponse';
  children: Array<GqlOpcNode>;
  node: GqlOpcNode;
};

export type GqlOpcBuildInfoResult = {
  __typename?: 'OpcBuildInfoResult';
  buildDate?: Maybe<Scalars['DateTime']['output']>;
  buildNumber?: Maybe<Scalars['String']['output']>;
  isAvevaServer: Scalars['Boolean']['output'];
  manufacturerName?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productUri?: Maybe<Scalars['String']['output']>;
  softwareVersion?: Maybe<Scalars['String']['output']>;
};

/** An OPC-UA connection for an agent */
export type GqlOpcConnection = GqlNode & {
  __typename?: 'OpcConnection';
  agentId: Scalars['ID']['output'];
  browse: GqlOpcBrowseResponse;
  /** Gets the server and build info for the OpcConnection */
  buildInfo: GqlOpcBuildInfoResult;
  configurationState: GqlOpcConnectionConfigurationState;
  endpoint: Scalars['Uri']['output'];
  factoryId: Scalars['ID']['output'];
  /** Global node Id */
  id: Scalars['ID']['output'];
  ignoreServerEndpoint: Scalars['Boolean']['output'];
  lastHierarchySyncTask?: Maybe<GqlOpcUaSyncTask>;
  lastSuccessfulHierarchySyncTask?: Maybe<GqlOpcUaSyncTask>;
  name: Scalars['String']['output'];
  readValues: Array<GqlOpcReadResult>;
  securityMode?: Maybe<GqlOpcSecurityMode>;
  securityPolicy?: Maybe<GqlOpcSecurityPolicy>;
  syncJobDefinition?: Maybe<GqlOpcUaSyncJobDefinition>;
  username?: Maybe<Scalars['String']['output']>;
  x509Thumbprint?: Maybe<Scalars['String']['output']>;
};


/** An OPC-UA connection for an agent */
export type GqlOpcConnectionBrowseArgs = {
  nodeId: Scalars['String']['input'];
  timeout?: Scalars['Milliseconds']['input'];
};


/** An OPC-UA connection for an agent */
export type GqlOpcConnectionReadValuesArgs = {
  nodeIds: Array<Scalars['String']['input']>;
  timeout?: Scalars['Milliseconds']['input'];
};

export const GqlOpcConnectionConfigurationState = {
  Complete: 'COMPLETE',
  Incomplete: 'INCOMPLETE'
} as const;

export type GqlOpcConnectionConfigurationState = typeof GqlOpcConnectionConfigurationState[keyof typeof GqlOpcConnectionConfigurationState];
/** A connection from an object to a list of objects of type `OpcConnection`. */
export type GqlOpcConnectionConnection = {
  __typename?: 'OpcConnectionConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlOpcConnectionEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlOpcConnection>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `OpcConnection`. */
export type GqlOpcConnectionEdge = {
  __typename?: 'OpcConnectionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlOpcConnection>;
};

export type GqlOpcCredentialsInput = {
  /** The password to use */
  password: Scalars['String']['input'];
  /** The username to use */
  username: Scalars['String']['input'];
};

/** The value of an OPC read */
export type GqlOpcDataValue = {
  __typename?: 'OpcDataValue';
  provenance: Scalars['String']['output'];
  serverTimestamp?: Maybe<Scalars['DateTime']['output']>;
  sourceTimestamp?: Maybe<Scalars['DateTime']['output']>;
  status: GqlOpcStatus;
  value: GqlOpcValue;
};

/** Agent RPC OPC endpoint description */
export type GqlOpcEndpointDescription = {
  __typename?: 'OpcEndpointDescription';
  securityMode: GqlOpcSecurityMode;
  securityPolicy: GqlOpcSecurityPolicy;
  server?: Maybe<GqlOpcApplicationDescription>;
  serverThumbprint: Scalars['String']['output'];
  url: Scalars['String']['output'];
  userIdentityTokens: Array<GqlOpcUserIdentityToken>;
};

/** A node in the OPC hierarchy */
export type GqlOpcNode = {
  browseName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
};

export type GqlOpcReadResult = {
  __typename?: 'OpcReadResult';
  nodeId: Scalars['String']['output'];
  value?: Maybe<GqlOpcDataValue>;
};

export const GqlOpcSecurityMode = {
  Invalid: 'INVALID',
  None: 'NONE',
  Sign: 'SIGN',
  SignAndEncrypt: 'SIGN_AND_ENCRYPT'
} as const;

export type GqlOpcSecurityMode = typeof GqlOpcSecurityMode[keyof typeof GqlOpcSecurityMode];
export const GqlOpcSecurityPolicy = {
  Aes_128Sha_256RsaOaep: 'AES_128_SHA_256_RSA_OAEP',
  Aes_256Sha_256RsaPss: 'AES_256_SHA_256_RSA_PSS',
  Basic_128Rsa_15: 'BASIC_128_RSA_15',
  Basic_256: 'BASIC_256',
  Basic_256Sha_256: 'BASIC_256_SHA_256',
  None: 'NONE'
} as const;

export type GqlOpcSecurityPolicy = typeof GqlOpcSecurityPolicy[keyof typeof GqlOpcSecurityPolicy];
/** The status value for the OPC operation */
export type GqlOpcStatus = {
  __typename?: 'OpcStatus';
  severity: GqlOpcStatusSeverity;
  value: Scalars['UInt']['output'];
};

export const GqlOpcStatusSeverity = {
  Bad: 'BAD',
  Good: 'GOOD',
  Uncertain: 'UNCERTAIN'
} as const;

export type GqlOpcStatusSeverity = typeof GqlOpcStatusSeverity[keyof typeof GqlOpcStatusSeverity];
/** An OPC-UA data subscription */
export type GqlOpcSubscription = GqlNode & {
  __typename?: 'OpcSubscription';
  /** The agent where this subscription will run */
  agent: GqlAgent;
  agentId: Scalars['ID']['output'];
  autoStart: Scalars['Boolean']['output'];
  batchInterval: Scalars['Milliseconds']['output'];
  heartbeatInterval: Scalars['Milliseconds']['output'];
  heartbeatNode: Scalars['String']['output'];
  /** Global node Id */
  id: Scalars['ID']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  /** The subscribed OPC-UA nodes */
  nodes?: Maybe<GqlOpcSubscriptionNodeConnection>;
  /** The OPC Connection used by this subscription */
  opcConnection: GqlOpcConnection;
  opcConnectionId: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
};


/** An OPC-UA data subscription */
export type GqlOpcSubscriptionNodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection from an object to a list of objects of type `OpcSubscription`. */
export type GqlOpcSubscriptionConnection = {
  __typename?: 'OpcSubscriptionConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlOpcSubscriptionEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlOpcSubscription>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `OpcSubscription`. */
export type GqlOpcSubscriptionEdge = {
  __typename?: 'OpcSubscriptionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlOpcSubscription>;
};

/** A node in an OPC-UA subscription */
export type GqlOpcSubscriptionNode = {
  __typename?: 'OpcSubscriptionNode';
  nodeId: Scalars['String']['output'];
};

/** A connection from an object to a list of objects of type `OpcSubscriptionNode`. */
export type GqlOpcSubscriptionNodeConnection = {
  __typename?: 'OpcSubscriptionNodeConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlOpcSubscriptionNodeEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlOpcSubscriptionNode>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `OpcSubscriptionNode`. */
export type GqlOpcSubscriptionNodeEdge = {
  __typename?: 'OpcSubscriptionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlOpcSubscriptionNode>;
};

/** An OPC-UA hierarchy synchronization job definition */
export type GqlOpcUaSyncJobDefinition = GqlNode & {
  __typename?: 'OpcUaSyncJobDefinition';
  /** The gateway used for the sync task */
  agentId: Scalars['ID']['output'];
  /** The OPC-UA browse timeout used for the sync task */
  browseTimeout: Scalars['Milliseconds']['output'];
  /** The cron schedule for running the job periodically in Nomad */
  cronSchedule: Scalars['String']['output'];
  factoryId: Scalars['ID']['output'];
  /** Global node Id */
  id: Scalars['ID']['output'];
  /** The OPC-UA connection used for the sync task */
  opcConnectionId: Scalars['ID']['output'];
  /** The OPC-UA node from which the sync started */
  startNode: Scalars['String']['output'];
  /** Determines if the schedule is enabled */
  syncEnabled: Scalars['Boolean']['output'];
  /** The Nomad job timeout used for the sync task */
  syncTimeout: Scalars['Milliseconds']['output'];
};

/** An OPC-UA hierarchy synchronization task */
export type GqlOpcUaSyncTask = GqlNode & {
  __typename?: 'OpcUaSyncTask';
  /** The gateway used for the sync task */
  agentId: Scalars['ID']['output'];
  /** The signed URL for downloading the nodes file from the storage account. Only available for successful tasks. */
  arrowUriNodes?: Maybe<Scalars['Uri']['output']>;
  /** The signed URL for downloading the references file from the storage account. Only available for successful tasks. */
  arrowUriReferences?: Maybe<Scalars['Uri']['output']>;
  /** Number of nodes that returned an error when browsed */
  browseErrors: Scalars['Int']['output'];
  /** The OPC-UA browse timeout used for the sync task */
  browseTimeout: Scalars['Milliseconds']['output'];
  /** If the task has completed, the timestamp of completion */
  endTime?: Maybe<Scalars['DateTime']['output']>;
  /** An error that prevented the task from running */
  error?: Maybe<Scalars['String']['output']>;
  factoryId: Scalars['ID']['output'];
  /** Global node Id */
  id: Scalars['ID']['output'];
  /** When the task stats were last updated */
  lastUpdate: Scalars['DateTime']['output'];
  /** How many of the nodes seen have been browsed by this task */
  nodesBrowsed: Scalars['Int']['output'];
  /** Number of nodes queued to browse */
  nodesQueued: Scalars['Int']['output'];
  /** The number of nodes seen by this task */
  nodesSeen: Scalars['Int']['output'];
  /** The OPC-UA connection used for the sync task */
  opcConnectionId: Scalars['ID']['output'];
  /** The number of references seen by this task */
  referencesSeen: Scalars['Int']['output'];
  /** The OPC-UA node from which the sync started */
  startNode: Scalars['String']['output'];
  /** The start time of the task */
  startTime: Scalars['DateTime']['output'];
  /** The current state of the task */
  state: GqlOpcUaSyncTaskState;
  /** The user stopped the task */
  stopRequested: Scalars['Boolean']['output'];
};

export const GqlOpcUaSyncTaskState = {
  Failed: 'FAILED',
  Running: 'RUNNING',
  Stopped: 'STOPPED',
  Successful: 'SUCCESSFUL'
} as const;

export type GqlOpcUaSyncTaskState = typeof GqlOpcUaSyncTaskState[keyof typeof GqlOpcUaSyncTaskState];
/** Agent RPC OPC User Identity Token */
export type GqlOpcUserIdentityToken = {
  __typename?: 'OpcUserIdentityToken';
  issuedTokenType: Scalars['String']['output'];
  issuerEndpointUrl: Scalars['String']['output'];
  policyId: Scalars['String']['output'];
  /** Overrides the securityPolicy of the OpcEndpointDescription */
  securityPolicy?: Maybe<GqlOpcSecurityPolicy>;
  userTokenType: GqlOpcUserTokenType;
};

export const GqlOpcUserTokenType = {
  Anonymous: 'ANONYMOUS',
  Certificate: 'CERTIFICATE',
  IssuedToken: 'ISSUED_TOKEN',
  UserName: 'USER_NAME'
} as const;

export type GqlOpcUserTokenType = typeof GqlOpcUserTokenType[keyof typeof GqlOpcUserTokenType];
/** The value of an OPC read */
export type GqlOpcValue = GqlOpcValueBoolean | GqlOpcValueDateTime | GqlOpcValueDouble | GqlOpcValueError | GqlOpcValueFloat | GqlOpcValueInt | GqlOpcValueLong | GqlOpcValueShort | GqlOpcValueString | GqlOpcValueUInt | GqlOpcValueULong | GqlOpcValueUShort;

export type GqlOpcValueBoolean = {
  __typename?: 'OpcValueBoolean';
  value: Scalars['Boolean']['output'];
};

export type GqlOpcValueDateTime = {
  __typename?: 'OpcValueDateTime';
  value: Scalars['DateTime']['output'];
};

export type GqlOpcValueDouble = {
  __typename?: 'OpcValueDouble';
  value: Scalars['Float']['output'];
};

export type GqlOpcValueError = {
  __typename?: 'OpcValueError';
  error: Scalars['String']['output'];
};

export type GqlOpcValueFloat = {
  __typename?: 'OpcValueFloat';
  value: Scalars['Float']['output'];
};

export type GqlOpcValueInt = {
  __typename?: 'OpcValueInt';
  value: Scalars['Int']['output'];
};

export type GqlOpcValueLong = {
  __typename?: 'OpcValueLong';
  value: Scalars['Long']['output'];
};

export type GqlOpcValueShort = {
  __typename?: 'OpcValueShort';
  value: Scalars['Int']['output'];
};

export type GqlOpcValueString = {
  __typename?: 'OpcValueString';
  value: Scalars['String']['output'];
};

export type GqlOpcValueUInt = {
  __typename?: 'OpcValueUInt';
  value: Scalars['UInt']['output'];
};

export type GqlOpcValueULong = {
  __typename?: 'OpcValueULong';
  value: Scalars['ULong']['output'];
};

export type GqlOpcValueUShort = {
  __typename?: 'OpcValueUShort';
  value: Scalars['UInt']['output'];
};

/** Information about pagination in a connection. */
export type GqlPageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A single prescription for a prescriptive model */
export type GqlPrescription = {
  __typename?: 'Prescription';
  /** The forecasts for this prescription */
  forecasts: Array<GqlPrescriptionForecast>;
  /** The time at which the prescription applies */
  predictTime: Scalars['DateTime']['output'];
  /** The recommendations for the controllable tags */
  recommendations: Array<GqlRecommendation>;
};

/** A forecast for a prescription */
export type GqlPrescriptionForecast = {
  __typename?: 'PrescriptionForecast';
  /** The kind of this forecast */
  kind: GqlPrescriptionForecastKind;
  /** The points for this forecast */
  points: Array<GqlForecastPoint>;
  /** The ID of the tag this forecast is for */
  tagId: Scalars['ID']['output'];
};

/** The kind of forecast for a prescription */
export const GqlPrescriptionForecastKind = {
  WithoutRecommendations: 'WITHOUT_RECOMMENDATIONS',
  WithRecommendations: 'WITH_RECOMMENDATIONS'
} as const;

export type GqlPrescriptionForecastKind = typeof GqlPrescriptionForecastKind[keyof typeof GqlPrescriptionForecastKind];
/** A prescriptive model definition for a factory */
export type GqlPrescriptiveModel = GqlModel & GqlNode & GqlStarrable & {
  __typename?: 'PrescriptiveModel';
  activated?: Maybe<Scalars['DateTime']['output']>;
  activeTrainedModel?: Maybe<GqlTrainedModel>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<GqlUser>;
  description: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Get the historical recommendations for a controllable tag in the prescriptive model */
  historicalRecommendations: GqlTimeSeries;
  /** Global node Id */
  id: Scalars['ID']['output'];
  initialInferenceEnd?: Maybe<Scalars['DateTime']['output']>;
  initialInferenceStart?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use modelInputTags */
  inputTags: Array<GqlTag>;
  lastStateChange: Scalars['DateTime']['output'];
  /** Get the latest prescription for the prescriptive model */
  latest?: Maybe<GqlPrescription>;
  method: GqlModelMethod;
  methodId: Scalars['ID']['output'];
  /** The input tags for this model */
  modelInputTags?: Maybe<GqlModelInputTagConnection>;
  name: Scalars['String']['output'];
  state: GqlModelState;
  tag: GqlTag;
  tagId: Scalars['ID']['output'];
  /** The target value for the model */
  targetValue: Scalars['Float']['output'];
  trainedModels: Array<GqlTrainedModel>;
  trainingEnd?: Maybe<Scalars['DateTime']['output']>;
  trainingPeriod?: Maybe<Scalars['Period']['output']>;
  trainingPeriodExclusions: Array<GqlModelTrainingPeriodExclusion>;
  trainingStart?: Maybe<Scalars['DateTime']['output']>;
  type: GqlModelType;
  typeId: Scalars['ID']['output'];
  viewerHasStarred: Scalars['Boolean']['output'];
};


/** A prescriptive model definition for a factory */
export type GqlPrescriptiveModelHistoricalRecommendationsArgs = {
  from: Scalars['DateTime']['input'];
  interval: Scalars['Int']['input'];
  tagId: Scalars['ID']['input'];
  to: Scalars['DateTime']['input'];
};


/** A prescriptive model definition for a factory */
export type GqlPrescriptiveModelModelInputTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlPrescriptiveModelTagInput = {
  /** Whether this input tag is controllable */
  isControllable: Scalars['Boolean']['input'];
  /** The ID of the input Tag */
  tagId: Scalars['ID']['input'];
};

/** The range of event times for the tag */
export type GqlProcessDataEventTimeRange = {
  __typename?: 'ProcessDataEventTimeRange';
  max: Scalars['DateTime']['output'];
  min: Scalars['DateTime']['output'];
};

export type GqlQuery = {
  __typename?: 'Query';
  agentReleases?: Maybe<GqlAgentReleaseConnection>;
  /** @deprecated Use the node query */
  customer?: Maybe<GqlCustomer>;
  dashboardData: GqlDashboardData;
  documentationUrl: GqlDocumentationUrl;
  /** @deprecated Use the node query */
  factory?: Maybe<GqlFactory>;
  me: GqlUser;
  modelTypes: Array<GqlModelType>;
  node?: Maybe<GqlNode>;
};


export type GqlQueryAgentReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryCustomerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type GqlQueryDashboardDataArgs = {
  aggregation: GqlAggregationPeriod;
  periods: Scalars['Int']['input'];
  tagId: Scalars['ID']['input'];
  timezone: Scalars['String']['input'];
};


export type GqlQueryFactoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type GqlQueryNodeArgs = {
  id: Scalars['ID']['input'];
};

/** A recommendation for a controllable tag in a Prescription */
export type GqlRecommendation = {
  __typename?: 'Recommendation';
  /** The tag ID for the controllable tag */
  tagId: Scalars['ID']['output'];
  /** The recommended value for the controllable tag */
  value: Scalars['Float']['output'];
};

export type GqlRemoveCustomerUserInput = {
  /** The ID of the Customer to remove the user from */
  customerId: Scalars['ID']['input'];
  /** The ID of the User to remove */
  userId: Scalars['ID']['input'];
};

export type GqlRemoveCustomerUserPayload = {
  __typename?: 'RemoveCustomerUserPayload';
  /** The customer */
  customer: GqlCustomer;
  /** The removed user edge */
  userEdge: GqlCustomerUserEdge;
};

export type GqlRemoveFactoryUserInput = {
  /** The ID of the Factory to remove the user from */
  factoryId: Scalars['ID']['input'];
  /** The ID of the User to remove */
  userId: Scalars['ID']['input'];
};

export type GqlRemoveFactoryUserPayload = {
  __typename?: 'RemoveFactoryUserPayload';
  /** The factory */
  factory?: Maybe<GqlFactory>;
  /** The removed user edge */
  userEdge?: Maybe<GqlFactoryUserEdge>;
};

export type GqlRemoveInputTagsFromModelInput = {
  /** The ID of the Model */
  id: Scalars['ID']['input'];
  /** The ID of the tags to remove as inputs */
  tagIds: Array<Scalars['ID']['input']>;
};

export type GqlRemoveInputTagsFromModelPayload = {
  __typename?: 'RemoveInputTagsFromModelPayload';
  /** The updated model */
  model: GqlModel;
};

export type GqlRemoveStarInput = {
  /** The Starrable ID to unstar. */
  starrableId: Scalars['ID']['input'];
};

export type GqlRemoveStarPayload = {
  __typename?: 'RemoveStarPayload';
  /** The starrable. */
  starrable?: Maybe<GqlStarrable>;
};

/** Trigger anomaly detection for a model */
export type GqlRunAnomalyDetectionInput = {
  /** The filter to be applied to anomaly generation */
  anomalyGenerationFilter?: InputMaybe<Scalars['String']['input']>;
  /** The anomaly conditions to apply */
  conditions?: InputMaybe<Array<GqlAnomalyConditionInput>>;
  /** The ID of the Model */
  id: Scalars['ID']['input'];
  /** Whether anomaly detection should replace the existing anomalies. This will delete existing anomalies */
  replaceAnomalies?: Scalars['Boolean']['input'];
  /** The threshold for short anomalies */
  shortAnomalyThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** The threshold for spike anomalies */
  spikeAnomalyThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlRunAnomalyDetectionPayload = {
  __typename?: 'RunAnomalyDetectionPayload';
  /** The updated model */
  model: GqlModel;
};

export type GqlSetAnomalyStateInput = {
  /** The ID of the Anomaly */
  anomalyId: Scalars['ID']['input'];
  /** The new state for the Anomaly */
  state: GqlAnomalyState;
};

export type GqlSetAnomalyStatePayload = {
  __typename?: 'SetAnomalyStatePayload';
  /** The updated Anomaly */
  anomaly: GqlAnomaly;
};

export type GqlSetAssetParentInput = {
  /** The ID is the asset to move */
  assetId: Scalars['ID']['input'];
  /** The ID of the factory to move the asset */
  factoryId: Scalars['ID']['input'];
  /** The ID of the parent asset or null to make top level */
  parentAssetId?: InputMaybe<Scalars['ID']['input']>;
  /** The hierarchy in which to move the asset */
  view?: GqlAssetViewType;
};

export type GqlSetAssetParentPayload = {
  __typename?: 'SetAssetParentPayload';
  /** The ID is the asset to move */
  assetId: Scalars['ID']['output'];
  /** The ID of the factory to move the asset */
  factoryId: Scalars['ID']['output'];
  /** The ID of the parent asset or null to make top level */
  parentAssetId?: Maybe<Scalars['ID']['output']>;
  /** The hierarchy in which to move the asset */
  view: GqlAssetViewType;
};

export type GqlSetCustomerUserRoleInput = {
  /** The ID of the Customer to update */
  customerId: Scalars['ID']['input'];
  /** The new role for the user */
  role: GqlCustomerRole;
  /** The ID of the User to update */
  userId: Scalars['ID']['input'];
};

export type GqlSetCustomerUserRolePayload = {
  __typename?: 'SetCustomerUserRolePayload';
  /** The customer */
  customer?: Maybe<GqlCustomer>;
  userEdge?: Maybe<GqlCustomerUserEdge>;
};

export type GqlSetFactoryUserRoleInput = {
  /** The ID of the Factory to update */
  factoryId: Scalars['ID']['input'];
  /** The new role for the user */
  role: GqlFactoryRole;
  /** The ID of the User to update */
  userId: Scalars['ID']['input'];
};

export type GqlSetFactoryUserRolePayload = {
  __typename?: 'SetFactoryUserRolePayload';
  /** The factory */
  factory?: Maybe<GqlFactory>;
  userEdge?: Maybe<GqlFactoryUserEdge>;
};

export type GqlSetModelTrainingConfigurationInput = {
  /** The time ranges to exclude from the training period */
  exclusions: Array<GqlTimeRangeInput>;
  /** The ID of the model to configure training for */
  modelId: Scalars['ID']['input'];
  /** The overall training period */
  trainingPeriod: GqlTrainingPeriodInput;
};

export type GqlSetModelTrainingConfigurationPayload = {
  __typename?: 'SetModelTrainingConfigurationPayload';
  /** The updated model */
  model: GqlModel;
};

export type GqlSetTagsParentInput = {
  /** The ID of the destination Asset */
  assetId: Scalars['ID']['input'];
  /** The ID of the factory */
  factoryId: Scalars['ID']['input'];
  /** The IDs of the Tags to move */
  tagIds: Array<Scalars['ID']['input']>;
  /** The hierarchy in which to move the Tag */
  view?: GqlAssetViewType;
};

export type GqlSetTagsParentPayload = {
  __typename?: 'SetTagsParentPayload';
  /** The ID of the destination Asset */
  assetId: Scalars['ID']['output'];
  /** The ID of the factory */
  factoryId: Scalars['ID']['output'];
  /** The IDs of the Tags to move */
  tagIds: Array<Scalars['ID']['output']>;
  /** The hierarchy in which to move the Tag */
  view: GqlAssetViewType;
};

/** Things that can be starred. */
export type GqlStarrable = {
  viewerHasStarred: Scalars['Boolean']['output'];
};

export type GqlStartModelInput = {
  /** The ID of the Model */
  id: Scalars['ID']['input'];
};

export type GqlStartModelPayload = {
  __typename?: 'StartModelPayload';
  /** The updated model */
  model: GqlModel;
};

export type GqlStopModelInput = {
  /** The ID of the Model */
  id: Scalars['ID']['input'];
};

export type GqlStopModelPayload = {
  __typename?: 'StopModelPayload';
  /** The updated model */
  model: GqlModel;
};

export type GqlStopSyncTaskInput = {
  /** The ID of the OpcUaSyncTask */
  id: Scalars['ID']['input'];
};

export type GqlStopSyncTaskPayload = {
  __typename?: 'StopSyncTaskPayload';
  /** The stopped task */
  task: GqlOpcUaSyncTask;
};

/** A tag in the customer's factory */
export type GqlTag = GqlNode & {
  __typename?: 'Tag';
  automaticLabel?: Maybe<GqlTagClassification>;
  availableDataTimeRange?: Maybe<GqlProcessDataEventTimeRange>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  engUnit?: Maybe<Scalars['String']['output']>;
  hierarchyTag?: Maybe<GqlHierarchyTag>;
  /** Global node Id */
  id: Scalars['ID']['output'];
  metadata?: Maybe<GqlTagMetadata>;
  overriddenLabel?: Maybe<GqlTagClassification>;
  processData?: Maybe<GqlTimeSeries>;
  tagName: Scalars['String']['output'];
  valueType?: Maybe<Scalars['String']['output']>;
};


/** A tag in the customer's factory */
export type GqlTagHierarchyTagArgs = {
  view?: InputMaybe<GqlAssetViewType>;
};


/** A tag in the customer's factory */
export type GqlTagProcessDataArgs = {
  from: Scalars['DateTime']['input'];
  interval: Scalars['Int']['input'];
  to: Scalars['DateTime']['input'];
};

export const GqlTagClassification = {
  Categorical: 'CATEGORICAL',
  Smooth: 'SMOOTH'
} as const;

export type GqlTagClassification = typeof GqlTagClassification[keyof typeof GqlTagClassification];
/** A connection from an object to a list of objects of type `Tag`. */
export type GqlTagConnection = {
  __typename?: 'TagConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlTagEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlTag>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Tag`. */
export type GqlTagEdge = {
  __typename?: 'TagEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlTag>;
};

/** Metadata for a tag */
export type GqlTagMetadata = {
  __typename?: 'TagMetadata';
  label?: Maybe<Scalars['String']['output']>;
};

export const GqlThresholdKind = {
  Lower: 'LOWER',
  Upper: 'UPPER'
} as const;

export type GqlThresholdKind = typeof GqlThresholdKind[keyof typeof GqlThresholdKind];
export type GqlTimeRangeInput = {
  /** The end time of the period */
  end: Scalars['DateTime']['input'];
  /** The start time of the period */
  start: Scalars['DateTime']['input'];
};

/** Representation of various types of time series data */
export type GqlTimeSeries = {
  __typename?: 'TimeSeries';
  data: Array<GqlTimeSeriesData>;
  from: Scalars['DateTime']['output'];
  /** The aggregation series interval in seconds. */
  interval: Scalars['Int']['output'];
  to: Scalars['DateTime']['output'];
};

/** Representation of various types of time series data */
export type GqlTimeSeriesData = {
  __typename?: 'TimeSeriesData';
  avg: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

/** A trained model in the customer's factory */
export type GqlTrainedModel = GqlNode & {
  __typename?: 'TrainedModel';
  anomalyCount?: Maybe<Scalars['Int']['output']>;
  /** The time of trained model creation */
  created: Scalars['DateTime']['output'];
  /** The end time for training data */
  dataEnd: Scalars['DateTime']['output'];
  /** The start time for training data */
  dataStart: Scalars['DateTime']['output'];
  dockerImage: Scalars['String']['output'];
  /** Global node Id */
  id: Scalars['ID']['output'];
  loss?: Maybe<Scalars['Float']['output']>;
  mae?: Maybe<Scalars['Float']['output']>;
  mape?: Maybe<Scalars['Float']['output']>;
  meanLabel?: Maybe<Scalars['Float']['output']>;
  meanPred?: Maybe<Scalars['Float']['output']>;
  modelId: Scalars['ID']['output'];
  rSquare?: Maybe<Scalars['Float']['output']>;
  /** The predicted reduction in MAE when using prescriptions */
  targetMaeReduction?: Maybe<Scalars['Float']['output']>;
  targetMaeReductionHealth?: Maybe<GqlHealth>;
  /** The variation in the target tag */
  targetStd?: Maybe<Scalars['Float']['output']>;
  targetStdHealth?: Maybe<GqlHealth>;
  valAdaptedRSquare?: Maybe<Scalars['Float']['output']>;
  valAdaptedRSquareHealth?: Maybe<GqlHealth>;
  valLoss?: Maybe<Scalars['Float']['output']>;
  /** The Mean Squared Error for the trained model. */
  valMae?: Maybe<Scalars['Float']['output']>;
  valMape?: Maybe<Scalars['Float']['output']>;
  valMeanLabel?: Maybe<Scalars['Float']['output']>;
  valMeanPred?: Maybe<Scalars['Float']['output']>;
  valRSquare?: Maybe<Scalars['Float']['output']>;
  valRSquareHealth?: Maybe<GqlHealth>;
};

export type GqlTrainingPeriodInput =
  /** A training period specified as period until now */
  { period: Scalars['Period']['input']; timeRange?: never; }
  |  /** A training period specified as a start and end date and time */
  { period?: never; timeRange: GqlTimeRangeInput; };

/** A training task */
export type GqlTrainingTask = GqlNode & {
  __typename?: 'TrainingTask';
  /** Global node Id */
  id: Scalars['ID']['output'];
  queueId?: Maybe<Scalars['String']['output']>;
  successful?: Maybe<Scalars['Boolean']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
};

export const GqlTransform = {
  None: 'NONE',
  Smoothed: 'SMOOTHED'
} as const;

export type GqlTransform = typeof GqlTransform[keyof typeof GqlTransform];
/** The configuration for a view in trend */
export type GqlTrendView = GqlNode & GqlStarrable & {
  __typename?: 'TrendView';
  createdAt: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  factoryId: Scalars['ID']['output'];
  /** Global node Id */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shared: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: GqlUser;
  userId: Scalars['ID']['output'];
  viewerHasStarred: Scalars['Boolean']['output'];
};

/** A connection from an object to a list of objects of type `TrendView`. */
export type GqlTrendViewConnection = {
  __typename?: 'TrendViewConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlTrendViewEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlTrendView>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `TrendView`. */
export type GqlTrendViewEdge = {
  __typename?: 'TrendViewEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlTrendView>;
};

export type GqlUnknownOpcNode = GqlOpcNode & {
  __typename?: 'UnknownOpcNode';
  browseName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
};

export type GqlUpdateAssetInput = {
  /** An alias for the asset */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Asset to update */
  id: Scalars['ID']['input'];
};

export type GqlUpdateAssetPayload = {
  __typename?: 'UpdateAssetPayload';
  /** The updated asset */
  asset: GqlAsset;
};

export type GqlUpdateModelAnomalyAnalysisCompleteInput = {
  /** The ID of the Model */
  id: Scalars['ID']['input'];
};

export type GqlUpdateModelAnomalyAnalysisCompletePayload = {
  __typename?: 'UpdateModelAnomalyAnalysisCompletePayload';
  /** The updated model */
  model: GqlModel;
};

export type GqlUpdateModelAnomalyConditionsInput = {
  /** The anomaly conditions to apply */
  conditions: Array<GqlAnomalyConditionInput>;
  /** The ID of the Model */
  modelId: Scalars['ID']['input'];
};

export type GqlUpdateModelAnomalyConditionsPayload = {
  __typename?: 'UpdateModelAnomalyConditionsPayload';
  /** The updated model */
  model: GqlModel;
};

/** Adds a filter to the model */
export type GqlUpdateModelFilterInput = {
  /** The filter to be applied to anomaly generation */
  anomalyGenerationFilter?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Model */
  modelId: Scalars['ID']['input'];
};

export type GqlUpdateModelFilterPayload = {
  __typename?: 'UpdateModelFilterPayload';
  /** The result of adding a filter to the model */
  model: GqlModel;
};

export type GqlUpdateModelInitialAnomalyDetectionCompleteInput = {
  /** The ID of the Model */
  id: Scalars['ID']['input'];
  /** Whether anomaly detection was successful */
  success: Scalars['Boolean']['input'];
};

export type GqlUpdateModelInitialAnomalyDetectionCompletePayload = {
  __typename?: 'UpdateModelInitialAnomalyDetectionCompletePayload';
  /** The updated model */
  model: GqlModel;
};

export type GqlUpdateModelInitialInferenceCompleteInput = {
  /** The ID of the Model */
  id: Scalars['ID']['input'];
  /** Whether inference was successful */
  success: Scalars['Boolean']['input'];
};

export type GqlUpdateModelInitialInferenceCompletePayload = {
  __typename?: 'UpdateModelInitialInferenceCompletePayload';
  /** The updated model */
  model: GqlModel;
};

export type GqlUpdateModelInput = {
  /** A description of the model */
  description?: InputMaybe<Scalars['String']['input']>;
  forecastHorizon?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the Model */
  id: Scalars['ID']['input'];
  /** The IDs of the model's input Tags. If defined, this will replace the existing input tags */
  inputTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The ID of the ModelMethod */
  methodId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the model */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the model's output Tag */
  tagId?: InputMaybe<Scalars['ID']['input']>;
  /** The target value for a prescriptive model */
  targetValue?: InputMaybe<Scalars['Float']['input']>;
  trainingEnd?: InputMaybe<Scalars['DateTime']['input']>;
  trainingPeriod?: InputMaybe<Scalars['Period']['input']>;
  trainingStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** The ID of the ModelType */
  typeId?: InputMaybe<Scalars['ID']['input']>;
};

export type GqlUpdateModelPayload = {
  __typename?: 'UpdateModelPayload';
  /** The updated model */
  model: GqlModel;
};

/** Input data for adding thresholds to an anomaly model */
export type GqlUpdateModelThresholdsInput = {
  /** The ID of the Model */
  modelId: Scalars['ID']['input'];
  /** The threshold for short anomalies */
  shortAnomalyThreshold?: InputMaybe<Scalars['Float']['input']>;
  /** The threshold for spike anomalies */
  spikeAnomalyThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlUpdateModelThresholdsPayload = {
  __typename?: 'UpdateModelThresholdsPayload';
  /** The result of adding thresholds to the model */
  model: GqlModel;
};

export type GqlUpdateOpcConnectionInput = {
  /** The endpoint credentials */
  credentials?: InputMaybe<GqlOpcCredentialsInput>;
  /** The endpoint URL for the connection */
  endpoint: Scalars['Uri']['input'];
  /** Whether to override the endpoint addresses returned by the server */
  ignoreServerEndpoint: Scalars['Boolean']['input'];
  /** The name of the connection connections */
  name: Scalars['String']['input'];
  /** The ID of the OpcConnection */
  opcConnectionId: Scalars['ID']['input'];
  /** The endpoint security mode */
  securityMode?: InputMaybe<GqlOpcSecurityMode>;
  /** The endpoint security policy */
  securityPolicy?: InputMaybe<GqlOpcSecurityPolicy>;
  /** The thumbprint of the agent certificate to use for connections */
  x509Thumbprint?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUpdateOpcConnectionPayload = {
  __typename?: 'UpdateOpcConnectionPayload';
  /** The updated connection */
  connection: GqlOpcConnection;
};

export type GqlUpdateOpcUaJobDefinitionInput = {
  /** The timeout for each node browse request in the OPC-UA Sync. */
  browseTimeout?: InputMaybe<Scalars['Milliseconds']['input']>;
  /** The cron schedule Nomad should use for job orchestration. */
  cronSchedule?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the OPC-UA Sync Job Definiton to update. */
  id: Scalars['ID']['input'];
  /** The starting node for an OPC-UA Sync. */
  startNode?: InputMaybe<Scalars['String']['input']>;
  /** Enable or disable the periodic schedule. */
  syncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The timeout before the OPC-UA Job Orchestrator will stop a sync that hasn't been updated. */
  syncTimeout?: InputMaybe<Scalars['Milliseconds']['input']>;
};

export type GqlUpdateOpcUaJobDefinitionPayload = {
  __typename?: 'UpdateOpcUaJobDefinitionPayload';
  /** The updated OPC-UA Sync Job Definition */
  syncJobDefinition: GqlOpcUaSyncJobDefinition;
};

export type GqlUpdatePrescriptiveModelTagsInput = {
  /** The updated input Tags */
  inputTags: Array<GqlPrescriptiveModelTagInput>;
  /** The ID of the prescriptive model */
  modelId: Scalars['ID']['input'];
};

export type GqlUpdatePrescriptiveModelTagsPayload = {
  __typename?: 'UpdatePrescriptiveModelTagsPayload';
  model: GqlPrescriptiveModel;
};

export type GqlUpdateSubscribedNodesInput = {
  /** The Agent ID */
  agentId: Scalars['ID']['input'];
  /** The Factory ID */
  factoryId: Scalars['ID']['input'];
  /** The OPC Connection ID */
  opcConnectionId: Scalars['ID']['input'];
  /** The list of OPC-UA nodeIds to subscribe to */
  toSubscribe?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The list of OPC-UA nodeIds to unsubscribe to */
  toUnsubscribe?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GqlUpdateSubscribedNodesPayload = {
  __typename?: 'UpdateSubscribedNodesPayload';
  /** The list of nodes that were successfully subscribed */
  subscribed?: Maybe<Array<Scalars['ID']['output']>>;
  /** The list of nodes that were successfully unsubscribed */
  unsubscribed?: Maybe<Array<Scalars['ID']['output']>>;
};

export type GqlUpdateTagInput = {
  /** The description of the Tag */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The display name of the Tag */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The engineering unit of the Tag */
  engUnit?: InputMaybe<Scalars['String']['input']>;
  /** The label of the Tag, overridden by the user */
  overriddenLabel?: InputMaybe<GqlTagClassification>;
  /** The ID of the Tag */
  tagId: Scalars['ID']['input'];
};

export type GqlUpdateTagPayload = {
  __typename?: 'UpdateTagPayload';
  /** The updated Tag */
  tag: GqlTag;
};

export type GqlUpdateTrainedModelInput = {
  /** The ID of the TrainedModel */
  id: Scalars['ID']['input'];
  loss?: InputMaybe<Scalars['Float']['input']>;
  mae?: InputMaybe<Scalars['Float']['input']>;
  mape?: InputMaybe<Scalars['Float']['input']>;
  meanLabel?: InputMaybe<Scalars['Float']['input']>;
  meanPred?: InputMaybe<Scalars['Float']['input']>;
  rSquare?: InputMaybe<Scalars['Float']['input']>;
  /** The predicted reduction in MAE when using prescriptions */
  targetMaeReduction?: InputMaybe<Scalars['Float']['input']>;
  targetMaeReductionHealth?: InputMaybe<GqlHealth>;
  /** The variation in the target tag */
  targetStd?: InputMaybe<Scalars['Float']['input']>;
  targetStdHealth?: InputMaybe<GqlHealth>;
  valAdaptedRSquare?: InputMaybe<Scalars['Float']['input']>;
  valAdaptedRSquareHealth?: InputMaybe<GqlHealth>;
  valLoss?: InputMaybe<Scalars['Float']['input']>;
  /** The Mean Squared Error for the trained model. */
  valMae?: InputMaybe<Scalars['Float']['input']>;
  valMape?: InputMaybe<Scalars['Float']['input']>;
  valMeanLabel?: InputMaybe<Scalars['Float']['input']>;
  valMeanPred?: InputMaybe<Scalars['Float']['input']>;
  valRSquare?: InputMaybe<Scalars['Float']['input']>;
  valRSquareHealth?: InputMaybe<GqlHealth>;
};

export type GqlUpdateTrainedModelPayload = {
  __typename?: 'UpdateTrainedModelPayload';
  /** The updated trained model */
  trainedModel: GqlTrainedModel;
};

export type GqlUpdateTrainingTaskInput = {
  /** The ID of the TrainingTask */
  id: Scalars['ID']['input'];
  /** The queue ID for the training task */
  queueId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the training task was successful */
  successful?: InputMaybe<Scalars['Boolean']['input']>;
  /** The batch task ID for the training task */
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type GqlUpdateTrainingTaskPayload = {
  __typename?: 'UpdateTrainingTaskPayload';
  /** The updated training task */
  trainingTask: GqlTrainingTask;
};

export type GqlUpdateTrendViewInput = {
  /** The configuration for the TrendView */
  data: Scalars['String']['input'];
  /** The name of the new TrendView */
  name: Scalars['String']['input'];
  /** If the TrendView should be shared within the factory */
  shared: Scalars['Boolean']['input'];
  /** The ID of the TrendView to update */
  trendViewId: Scalars['ID']['input'];
};

export type GqlUpdateTrendViewPayload = {
  __typename?: 'UpdateTrendViewPayload';
  /** The updated TrendView */
  trendView: GqlTrendView;
};

export type GqlUpdateUserConsentInput = {
  /** Consent for cookies */
  cookieConsent: Scalars['Boolean']['input'];
  /** Consent for data collection */
  dataCollectionConsent: Scalars['Boolean']['input'];
};

export type GqlUpdateUserConsentPayload = {
  __typename?: 'UpdateUserConsentPayload';
  /** The updated user. */
  user: GqlUser;
};

export type GqlUpdateUserDefaultFactoryInput = {
  /** The new default factory Id */
  factoryId: Scalars['ID']['input'];
};

export type GqlUpdateUserDefaultFactoryPayload = {
  __typename?: 'UpdateUserDefaultFactoryPayload';
  /** The updated user. */
  user: GqlUser;
};

export type GqlUpdateUserNameInput = {
  /** The ID of the User */
  id: Scalars['ID']['input'];
  /** The new name */
  name: Scalars['String']['input'];
};

export type GqlUpdateUserNamePayload = {
  __typename?: 'UpdateUserNamePayload';
  /** The updated user. */
  user: GqlUser;
};

/** An Intelecy user. */
export type GqlUser = GqlNode & {
  __typename?: 'User';
  /** Is the user's access blocked */
  blocked: Scalars['Boolean']['output'];
  /** Whether the user has consented to cookies */
  cookieConsent: Scalars['Boolean']['output'];
  /** When the user was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<GqlUser>;
  /** The customer that the user is assigned to */
  customer?: Maybe<GqlCustomer>;
  /** Lists all customer access for this user */
  customers?: Maybe<GqlUserCustomerConnection>;
  /** Whether the user has consented to data collection */
  dataCollectionConsent: Scalars['Boolean']['output'];
  defaultFactoryId?: Maybe<Scalars['ID']['output']>;
  /** The user's email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Lists all factories for this user */
  factories: Array<GqlFactory>;
  /** Does the user have app access */
  hasAppAccess: Scalars['Boolean']['output'];
  /** Global node Id */
  id: Scalars['ID']['output'];
  invitations?: Maybe<GqlFactoryInvitationConnection>;
  /** The user's name */
  name: Scalars['String']['output'];
  /** The user's status */
  status: GqlUserStatus;
};


/** An Intelecy user. */
export type GqlUserCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Intelecy user. */
export type GqlUserInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection from an object to a list of objects of type `User`. */
export type GqlUserConnection = {
  __typename?: 'UserConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlUserEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlUser>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A connection from an object to a list of objects of type `Customer`. */
export type GqlUserCustomerConnection = {
  __typename?: 'UserCustomerConnection';
  /** A list of all of the edges returned in the connection. */
  edges?: Maybe<Array<Maybe<GqlUserCustomerEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<GqlCustomer>>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Customer`. */
export type GqlUserCustomerEdge = {
  __typename?: 'UserCustomerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlCustomer>;
  /** The user's role in the customer */
  role: GqlCustomerRole;
};

/** An edge in a connection from an object to another object of type `User`. */
export type GqlUserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GqlUser>;
};

export const GqlUserStatus = {
  Disabled: 'DISABLED',
  Enabled: 'ENABLED'
} as const;

export type GqlUserStatus = typeof GqlUserStatus[keyof typeof GqlUserStatus];
export type GqlValidateOpcConnectionInput = {
  /** The endpoint credentials */
  credentials?: InputMaybe<GqlOpcCredentialsInput>;
  /** The endpoint URL for the connection */
  endpoint: Scalars['Uri']['input'];
  /** Whether to override the endpoint addresses returned by the server */
  ignoreServerEndpoint: Scalars['Boolean']['input'];
  /** The endpoint security mode */
  securityMode?: InputMaybe<GqlOpcSecurityMode>;
  /** The endpoint security policy */
  securityPolicy?: InputMaybe<GqlOpcSecurityPolicy>;
  /** The thumbprint of the agent certificate to use for connections */
  x509Thumbprint?: InputMaybe<Scalars['String']['input']>;
};

export type GqlValidateOpcConnectionResponse = {
  __typename?: 'ValidateOpcConnectionResponse';
  /** The error in the case of unsuccessful validation */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether validation was successful */
  success: Scalars['Boolean']['output'];
};

export type GqlVariableOpcNode = GqlOpcNode & {
  __typename?: 'VariableOpcNode';
  browseName: Scalars['String']['output'];
  dataType?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
};

export type GqlMeFragment = { __typename?: 'User', id: string, name: string, email?: string | null, dataCollectionConsent: boolean, cookieConsent: boolean, defaultFactoryId?: string | null, hasAppAccess: boolean, factories: Array<{ __typename?: 'Factory', id: string, name: string, viewerRole?: GqlFactoryRole | null, customer: { __typename?: 'Customer', id: string, name: string } }>, customers?: { __typename?: 'UserCustomerConnection', items?: Array<{ __typename?: 'Customer', name: string, id: string, viewerRole?: GqlCustomerRole | null, userCount: number, factoryCount: number } | null> | null } | null, customer?: { __typename?: 'Customer', id: string } | null };

export type GqlMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlMeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name: string, email?: string | null, dataCollectionConsent: boolean, cookieConsent: boolean, defaultFactoryId?: string | null, hasAppAccess: boolean, factories: Array<{ __typename?: 'Factory', id: string, name: string, viewerRole?: GqlFactoryRole | null, customer: { __typename?: 'Customer', id: string, name: string } }>, customers?: { __typename?: 'UserCustomerConnection', items?: Array<{ __typename?: 'Customer', name: string, id: string, viewerRole?: GqlCustomerRole | null, userCount: number, factoryCount: number } | null> | null } | null, customer?: { __typename?: 'Customer', id: string } | null } };

export type GqlInvitationBaseFragment = { __typename?: 'FactoryInvitation', id: string, role: GqlFactoryRole, createdAt: string, validUntil: string, completedAt?: string | null, state: GqlInvitationState, inviter: { __typename?: 'User', id: string, name: string }, factory: { __typename?: 'Factory', id: string, name: string, customer: { __typename: 'Customer', id: string, name: string } } };

export type GqlFetchUserInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlFetchUserInvitationsQuery = { __typename?: 'Query', me: { __typename?: 'User', invitations?: { __typename?: 'FactoryInvitationConnection', items?: Array<{ __typename?: 'FactoryInvitation', id: string, role: GqlFactoryRole, createdAt: string, validUntil: string, completedAt?: string | null, state: GqlInvitationState, inviter: { __typename?: 'User', id: string, name: string }, factory: { __typename?: 'Factory', id: string, name: string, customer: { __typename: 'Customer', id: string, name: string } } } | null> | null } | null } };

export type GqlTsDataFragment = { __typename: 'TimeSeriesData', timestamp: string, value: number, minValue: number, maxValue: number };

export type GqlFetchModelAnomalyScoreQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  interval: Scalars['Int']['input'];
  errorScoreKind: GqlErrorScoreKind;
  transform: GqlTransform;
}>;


export type GqlFetchModelAnomalyScoreQuery = { __typename?: 'Query', node?: { __typename: 'Agent', id: string } | { __typename: 'Anomaly', id: string } | { __typename: 'AnomalyComment', id: string } | { __typename: 'AnomalyModel', id: string, errorScore2: { __typename: 'TimeSeries', data: Array<{ __typename: 'TimeSeriesData', timestamp: string, value: number, minValue: number, maxValue: number }> } } | { __typename: 'Asset', id: string } | { __typename: 'Customer', id: string } | { __typename: 'Factory', id: string } | { __typename: 'FactoryInvitation', id: string } | { __typename: 'ForecastModel', id: string } | { __typename: 'HierarchyAsset', id: string } | { __typename: 'HierarchyTag', id: string } | { __typename: 'ModelMethod', id: string } | { __typename: 'ModelType', id: string } | { __typename: 'OpcConnection', id: string } | { __typename: 'OpcSubscription', id: string } | { __typename: 'OpcUaSyncJobDefinition', id: string } | { __typename: 'OpcUaSyncTask', id: string } | { __typename: 'PrescriptiveModel', id: string } | { __typename: 'Tag', id: string } | { __typename: 'TrainedModel', id: string } | { __typename: 'TrainingTask', id: string } | { __typename: 'TrendView', id: string } | { __typename: 'User', id: string } | null };

export type GqlProcessDataQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
  tagName: Scalars['String']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  interval: Scalars['Int']['input'];
}>;


export type GqlProcessDataQuery = { __typename?: 'Query', factory?: { __typename: 'Factory', tagByName?: { __typename: 'Tag', processData?: { __typename: 'TimeSeries', data: Array<{ __typename: 'TimeSeriesData', timestamp: string, value: number, minValue: number, maxValue: number }> } | null } | null } | null };

export type GqlPredictionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  interval: Scalars['Int']['input'];
}>;


export type GqlPredictionsQuery = { __typename?: 'Query', node?: { __typename: 'Agent', id: string } | { __typename: 'Anomaly', id: string } | { __typename: 'AnomalyComment', id: string } | { __typename: 'AnomalyModel', id: string, prediction: { __typename: 'TimeSeries', data: Array<{ __typename: 'TimeSeriesData', timestamp: string, value: number, minValue: number, maxValue: number }> } } | { __typename: 'Asset', id: string } | { __typename: 'Customer', id: string } | { __typename: 'Factory', id: string } | { __typename: 'FactoryInvitation', id: string } | { __typename: 'ForecastModel', id: string } | { __typename: 'HierarchyAsset', id: string } | { __typename: 'HierarchyTag', id: string } | { __typename: 'ModelMethod', id: string } | { __typename: 'ModelType', id: string } | { __typename: 'OpcConnection', id: string } | { __typename: 'OpcSubscription', id: string } | { __typename: 'OpcUaSyncJobDefinition', id: string } | { __typename: 'OpcUaSyncTask', id: string } | { __typename: 'PrescriptiveModel', id: string } | { __typename: 'Tag', id: string } | { __typename: 'TrainedModel', id: string } | { __typename: 'TrainingTask', id: string } | { __typename: 'TrendView', id: string } | { __typename: 'User', id: string } | null };

export type GqlModelMethodFragment = { __typename: 'ModelMethod', id: string, name: string };

export type GqlModelTypeFragment = { __typename: 'ModelType', id: string, name: string, methods: Array<{ __typename: 'ModelMethod', id: string, name: string }>, defaultMethod: { __typename: 'ModelMethod', id: string, name: string } };

export type GqlFetchModelTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlFetchModelTypesQuery = { __typename?: 'Query', modelTypes: Array<{ __typename: 'ModelType', id: string, name: string, methods: Array<{ __typename: 'ModelMethod', id: string, name: string }>, defaultMethod: { __typename: 'ModelMethod', id: string, name: string } }> };

export type GqlModelTagBaseTimeRangeFragment = { __typename: 'ProcessDataEventTimeRange', min: string, max: string };

export type GqlModelTagBaseFragment = { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null };

export type GqlActiveTrainedModelFragment = { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string };

export type GqlModelBase_AnomalyModel_Fragment = { __typename: 'AnomalyModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null };

export type GqlModelBase_ForecastModel_Fragment = { __typename: 'ForecastModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null };

export type GqlModelBase_PrescriptiveModel_Fragment = { __typename: 'PrescriptiveModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null };

export type GqlModelBaseFragment = GqlModelBase_AnomalyModel_Fragment | GqlModelBase_ForecastModel_Fragment | GqlModelBase_PrescriptiveModel_Fragment;

export type GqlFetchModelsQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
}>;


export type GqlFetchModelsQuery = { __typename?: 'Query', factory?: { __typename: 'Factory', models?: { __typename: 'ModelInterfaceConnection', items?: Array<{ __typename: 'AnomalyModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'ForecastModel', forecastHorizon?: number | null, id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'PrescriptiveModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | null> | null } | null } | null };

export type GqlFetchHistoricalForecastQueryVariables = Exact<{
  modelId: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  offset: Scalars['Milliseconds']['input'];
}>;


export type GqlFetchHistoricalForecastQuery = { __typename?: 'Query', node?: { __typename: 'Agent', id: string } | { __typename: 'Anomaly', id: string } | { __typename: 'AnomalyComment', id: string } | { __typename: 'AnomalyModel', id: string } | { __typename: 'Asset', id: string } | { __typename: 'Customer', id: string } | { __typename: 'Factory', id: string } | { __typename: 'FactoryInvitation', id: string } | { __typename: 'ForecastModel', id: string, historicalForecast: { __typename?: 'TimeSeries', interval: number, from: string, to: string, data: Array<{ __typename?: 'TimeSeriesData', timestamp: string, min: number, max: number, avg: number }> } } | { __typename: 'HierarchyAsset', id: string } | { __typename: 'HierarchyTag', id: string } | { __typename: 'ModelMethod', id: string } | { __typename: 'ModelType', id: string } | { __typename: 'OpcConnection', id: string } | { __typename: 'OpcSubscription', id: string } | { __typename: 'OpcUaSyncJobDefinition', id: string } | { __typename: 'OpcUaSyncTask', id: string } | { __typename: 'PrescriptiveModel', id: string } | { __typename: 'Tag', id: string } | { __typename: 'TrainedModel', id: string } | { __typename: 'TrainingTask', id: string } | { __typename: 'TrendView', id: string } | { __typename: 'User', id: string } | null };

export type GqlFetchHistoricalRecommendationsQueryVariables = Exact<{
  modelId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  interval: Scalars['Int']['input'];
}>;


export type GqlFetchHistoricalRecommendationsQuery = { __typename?: 'Query', node?: { __typename: 'Agent' } | { __typename: 'Anomaly' } | { __typename: 'AnomalyComment' } | { __typename: 'AnomalyModel' } | { __typename: 'Asset' } | { __typename: 'Customer' } | { __typename: 'Factory' } | { __typename: 'FactoryInvitation' } | { __typename: 'ForecastModel' } | { __typename: 'HierarchyAsset' } | { __typename: 'HierarchyTag' } | { __typename: 'ModelMethod' } | { __typename: 'ModelType' } | { __typename: 'OpcConnection' } | { __typename: 'OpcSubscription' } | { __typename: 'OpcUaSyncJobDefinition' } | { __typename: 'OpcUaSyncTask' } | { __typename: 'PrescriptiveModel', historicalRecommendations: { __typename?: 'TimeSeries', data: Array<{ __typename: 'TimeSeriesData', timestamp: string, value: number, minValue: number, maxValue: number }> } } | { __typename: 'Tag' } | { __typename: 'TrainedModel' } | { __typename: 'TrainingTask' } | { __typename: 'TrendView' } | { __typename: 'User' } | null };

export type GqlModelAnomalyCommentFragment = { __typename?: 'AnomalyComment', at: string, by: string, comment: string };

export type GqlModelAnomalyFragment = { __typename?: 'Anomaly', id: string, restId: number, start: string, end?: string | null, score?: number | null, state: GqlAnomalyState, inProgress: boolean, comments: Array<{ __typename?: 'AnomalyComment', at: string, by: string, comment: string }> };

export type GqlAnomalyConditionsFragment = { __typename?: 'AnomalyCondition', threshold: number, thresholdKind: GqlThresholdKind, errorScore: { __typename?: 'ErrorScore', kind: GqlErrorScoreKind, transform: GqlTransform } };

export type GqlFetchAnomalyModelFragment = { __typename?: 'AnomalyModel', anomalyGenerationFilter?: string | null, availableErrorScores: Array<{ __typename?: 'ErrorScore', kind: GqlErrorScoreKind, transform: GqlTransform }>, anomalyConditions: Array<{ __typename?: 'AnomalyCondition', threshold: number, thresholdKind: GqlThresholdKind, errorScore: { __typename?: 'ErrorScore', kind: GqlErrorScoreKind, transform: GqlTransform } }>, anomalies: Array<{ __typename?: 'Anomaly', id: string, restId: number, start: string, end?: string | null, score?: number | null, state: GqlAnomalyState, inProgress: boolean, comments: Array<{ __typename?: 'AnomalyComment', at: string, by: string, comment: string }> }> };

export type GqlFetchForecastModelFragment = { __typename?: 'ForecastModel', forecastHorizon?: number | null };

export type GqlFetchPrescriptiveModelFragment = { __typename?: 'PrescriptiveModel', targetValue: number };

export type GqlFetchModel_AnomalyModel_Fragment = { __typename: 'AnomalyModel', anomalyGenerationFilter?: string | null, id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, availableErrorScores: Array<{ __typename?: 'ErrorScore', kind: GqlErrorScoreKind, transform: GqlTransform }>, anomalyConditions: Array<{ __typename?: 'AnomalyCondition', threshold: number, thresholdKind: GqlThresholdKind, errorScore: { __typename?: 'ErrorScore', kind: GqlErrorScoreKind, transform: GqlTransform } }>, anomalies: Array<{ __typename?: 'Anomaly', id: string, restId: number, start: string, end?: string | null, score?: number | null, state: GqlAnomalyState, inProgress: boolean, comments: Array<{ __typename?: 'AnomalyComment', at: string, by: string, comment: string }> }>, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null };

export type GqlFetchModel_ForecastModel_Fragment = { __typename: 'ForecastModel', forecastHorizon?: number | null, id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null };

export type GqlFetchModel_PrescriptiveModel_Fragment = { __typename: 'PrescriptiveModel', targetValue: number, id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null };

export type GqlFetchModelFragment = GqlFetchModel_AnomalyModel_Fragment | GqlFetchModel_ForecastModel_Fragment | GqlFetchModel_PrescriptiveModel_Fragment;

export type GqlFetchModelQueryVariables = Exact<{
  modelId: Scalars['ID']['input'];
}>;


export type GqlFetchModelQuery = { __typename?: 'Query', node?: { __typename?: 'Agent' } | { __typename?: 'Anomaly' } | { __typename?: 'AnomalyComment' } | { __typename: 'AnomalyModel', anomalyGenerationFilter?: string | null, id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, availableErrorScores: Array<{ __typename?: 'ErrorScore', kind: GqlErrorScoreKind, transform: GqlTransform }>, anomalyConditions: Array<{ __typename?: 'AnomalyCondition', threshold: number, thresholdKind: GqlThresholdKind, errorScore: { __typename?: 'ErrorScore', kind: GqlErrorScoreKind, transform: GqlTransform } }>, anomalies: Array<{ __typename?: 'Anomaly', id: string, restId: number, start: string, end?: string | null, score?: number | null, state: GqlAnomalyState, inProgress: boolean, comments: Array<{ __typename?: 'AnomalyComment', at: string, by: string, comment: string }> }>, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename?: 'Asset' } | { __typename?: 'Customer' } | { __typename?: 'Factory' } | { __typename?: 'FactoryInvitation' } | { __typename: 'ForecastModel', forecastHorizon?: number | null, id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename?: 'HierarchyAsset' } | { __typename?: 'HierarchyTag' } | { __typename?: 'ModelMethod' } | { __typename?: 'ModelType' } | { __typename?: 'OpcConnection' } | { __typename?: 'OpcSubscription' } | { __typename?: 'OpcUaSyncJobDefinition' } | { __typename?: 'OpcUaSyncTask' } | { __typename: 'PrescriptiveModel', targetValue: number, id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename?: 'Tag' } | { __typename?: 'TrainedModel' } | { __typename?: 'TrainingTask' } | { __typename?: 'TrendView' } | { __typename?: 'User' } | null };

export type GqlLatestRecomendationFragment = { __typename: 'PrescriptiveModel', latest?: { __typename?: 'Prescription', recommendations: Array<{ __typename?: 'Recommendation', tagId: string, value: number }> } | null };

export type GqlFetchLatestRecomendationsQueryVariables = Exact<{
  modelId: Scalars['ID']['input'];
}>;


export type GqlFetchLatestRecomendationsQuery = { __typename?: 'Query', node?: { __typename?: 'Agent' } | { __typename?: 'Anomaly' } | { __typename?: 'AnomalyComment' } | { __typename?: 'AnomalyModel' } | { __typename?: 'Asset' } | { __typename?: 'Customer' } | { __typename?: 'Factory' } | { __typename?: 'FactoryInvitation' } | { __typename?: 'ForecastModel' } | { __typename?: 'HierarchyAsset' } | { __typename?: 'HierarchyTag' } | { __typename?: 'ModelMethod' } | { __typename?: 'ModelType' } | { __typename?: 'OpcConnection' } | { __typename?: 'OpcSubscription' } | { __typename?: 'OpcUaSyncJobDefinition' } | { __typename?: 'OpcUaSyncTask' } | { __typename: 'PrescriptiveModel', latest?: { __typename?: 'Prescription', recommendations: Array<{ __typename?: 'Recommendation', tagId: string, value: number }> } | null } | { __typename?: 'Tag' } | { __typename?: 'TrainedModel' } | { __typename?: 'TrainingTask' } | { __typename?: 'TrendView' } | { __typename?: 'User' } | null };

export type GqlModelInputTagDetailsFragment = { __typename?: 'Tag', id: string, tagName: string, displayName?: string | null, engUnit?: string | null, description?: string | null };

export type GqlModelInputTagFragment = { __typename?: 'ModelInputTagEdge', isControllable: boolean, node?: { __typename?: 'Tag', id: string, tagName: string, displayName?: string | null, engUnit?: string | null, description?: string | null } | null };

export type GqlFetchModelInputTagsQueryVariables = Exact<{
  modelId: Scalars['ID']['input'];
}>;


export type GqlFetchModelInputTagsQuery = { __typename?: 'Query', node?: { __typename?: 'Agent' } | { __typename?: 'Anomaly' } | { __typename?: 'AnomalyComment' } | { __typename: 'AnomalyModel', modelInputTags?: { __typename?: 'ModelInputTagConnection', edges?: Array<{ __typename?: 'ModelInputTagEdge', isControllable: boolean, node?: { __typename?: 'Tag', id: string, tagName: string, displayName?: string | null, engUnit?: string | null, description?: string | null } | null } | null> | null } | null } | { __typename?: 'Asset' } | { __typename?: 'Customer' } | { __typename?: 'Factory' } | { __typename?: 'FactoryInvitation' } | { __typename: 'ForecastModel', modelInputTags?: { __typename?: 'ModelInputTagConnection', edges?: Array<{ __typename?: 'ModelInputTagEdge', isControllable: boolean, node?: { __typename?: 'Tag', id: string, tagName: string, displayName?: string | null, engUnit?: string | null, description?: string | null } | null } | null> | null } | null } | { __typename?: 'HierarchyAsset' } | { __typename?: 'HierarchyTag' } | { __typename?: 'ModelMethod' } | { __typename?: 'ModelType' } | { __typename?: 'OpcConnection' } | { __typename?: 'OpcSubscription' } | { __typename?: 'OpcUaSyncJobDefinition' } | { __typename?: 'OpcUaSyncTask' } | { __typename: 'PrescriptiveModel', modelInputTags?: { __typename?: 'ModelInputTagConnection', edges?: Array<{ __typename?: 'ModelInputTagEdge', isControllable: boolean, node?: { __typename?: 'Tag', id: string, tagName: string, displayName?: string | null, engUnit?: string | null, description?: string | null } | null } | null> | null } | null } | { __typename?: 'Tag' } | { __typename?: 'TrainedModel' } | { __typename?: 'TrainingTask' } | { __typename?: 'TrendView' } | { __typename?: 'User' } | null };

export type GqlModelIdState_AnomalyModel_Fragment = { __typename: 'AnomalyModel', id: string, state: GqlModelState };

export type GqlModelIdState_ForecastModel_Fragment = { __typename: 'ForecastModel', id: string, state: GqlModelState };

export type GqlModelIdState_PrescriptiveModel_Fragment = { __typename: 'PrescriptiveModel', id: string, state: GqlModelState };

export type GqlModelIdStateFragment = GqlModelIdState_AnomalyModel_Fragment | GqlModelIdState_ForecastModel_Fragment | GqlModelIdState_PrescriptiveModel_Fragment;

export type GqlArchiveModelMutationVariables = Exact<{
  input: GqlArchiveModelInput;
}>;


export type GqlArchiveModelMutation = { __typename?: 'Mutation', archiveModel?: { __typename: 'ArchiveModelPayload', model: { __typename: 'AnomalyModel', id: string, state: GqlModelState } | { __typename: 'ForecastModel', id: string, state: GqlModelState } | { __typename: 'PrescriptiveModel', id: string, state: GqlModelState } } | null };

export type GqlDeleteModelMutationVariables = Exact<{
  input: GqlDeleteModelInput;
}>;


export type GqlDeleteModelMutation = { __typename?: 'Mutation', deleteModel?: { __typename: 'DeleteModelPayload', model: { __typename: 'AnomalyModel', id: string, state: GqlModelState } | { __typename: 'ForecastModel', id: string, state: GqlModelState } | { __typename: 'PrescriptiveModel', id: string, state: GqlModelState } } | null };

export type GqlStartModelMutationVariables = Exact<{
  input: GqlStartModelInput;
}>;


export type GqlStartModelMutation = { __typename?: 'Mutation', startModel?: { __typename: 'StartModelPayload', model: { __typename: 'AnomalyModel', id: string, state: GqlModelState } | { __typename: 'ForecastModel', id: string, state: GqlModelState } | { __typename: 'PrescriptiveModel', id: string, state: GqlModelState } } | null };

export type GqlStopModelMutationVariables = Exact<{
  input: GqlStopModelInput;
}>;


export type GqlStopModelMutation = { __typename?: 'Mutation', stopModel?: { __typename: 'StopModelPayload', model: { __typename: 'AnomalyModel', id: string, state: GqlModelState } | { __typename: 'ForecastModel', id: string, state: GqlModelState } | { __typename: 'PrescriptiveModel', id: string, state: GqlModelState } } | null };

export type GqlActivateModelMutationVariables = Exact<{
  input: GqlActivateModelInput;
}>;


export type GqlActivateModelMutation = { __typename?: 'Mutation', activateModel?: { __typename: 'ActivateModelPayload', model: { __typename: 'AnomalyModel', id: string, state: GqlModelState } | { __typename: 'ForecastModel', id: string, state: GqlModelState } | { __typename: 'PrescriptiveModel', id: string, state: GqlModelState } } | null };

export type GqlCopyModelMutationVariables = Exact<{
  input: GqlCopyModelInput;
}>;


export type GqlCopyModelMutation = { __typename?: 'Mutation', copyModel?: { __typename: 'CopyModelPayload', model: { __typename: 'AnomalyModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'ForecastModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'PrescriptiveModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } } | null };

export type GqlRunAnomalyDetectionMutationVariables = Exact<{
  input: GqlRunAnomalyDetectionInput;
}>;


export type GqlRunAnomalyDetectionMutation = { __typename?: 'Mutation', runAnomalyDetection?: { __typename: 'RunAnomalyDetectionPayload', model: { __typename: 'AnomalyModel', id: string, state: GqlModelState } | { __typename: 'ForecastModel', id: string, state: GqlModelState } | { __typename: 'PrescriptiveModel', id: string, state: GqlModelState } } | null };

export type GqlUpdateModelMutationVariables = Exact<{
  input: GqlUpdateModelInput;
}>;


export type GqlUpdateModelMutation = { __typename?: 'Mutation', updateModel?: { __typename: 'UpdateModelPayload', model: { __typename: 'AnomalyModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'ForecastModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'PrescriptiveModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } } | null };

export type GqlUpdateModelTrainingConfigurationMutationVariables = Exact<{
  input: GqlSetModelTrainingConfigurationInput;
}>;


export type GqlUpdateModelTrainingConfigurationMutation = { __typename?: 'Mutation', setModelTrainingConfiguration?: { __typename: 'SetModelTrainingConfigurationPayload', model: { __typename: 'AnomalyModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'ForecastModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'PrescriptiveModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } } | null };

export type GqlRemoveInputTagsFromModelMutationVariables = Exact<{
  input: GqlRemoveInputTagsFromModelInput;
}>;


export type GqlRemoveInputTagsFromModelMutation = { __typename?: 'Mutation', removeInputTagsFromModel?: { __typename: 'RemoveInputTagsFromModelPayload', model: { __typename: 'AnomalyModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'ForecastModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'PrescriptiveModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } } | null };

export type GqlAddInputTagsToModelMutationVariables = Exact<{
  input: GqlAddInputTagsToModelInput;
}>;


export type GqlAddInputTagsToModelMutation = { __typename?: 'Mutation', addInputTagsToModel?: { __typename: 'AddInputTagsToModelPayload', model: { __typename: 'AnomalyModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'ForecastModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'PrescriptiveModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } } | null };

export type GqlUpdatePrescriptiveModelTagsMutationVariables = Exact<{
  input: GqlUpdatePrescriptiveModelTagsInput;
}>;


export type GqlUpdatePrescriptiveModelTagsMutation = { __typename?: 'Mutation', updatePrescriptiveModelTags?: { __typename: 'UpdatePrescriptiveModelTagsPayload', model: { __typename?: 'PrescriptiveModel', targetValue: number } } | null };

export type GqlCreateModelMutationVariables = Exact<{
  input: GqlCreateModelInput;
}>;


export type GqlCreateModelMutation = { __typename?: 'Mutation', createModel?: { __typename: 'CreateModelPayload', model: { __typename: 'AnomalyModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'ForecastModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } | { __typename: 'PrescriptiveModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } } | null };

export type GqlCreatePrescriptiveModelMutationVariables = Exact<{
  input: GqlCreatePrescriptiveModelInput;
}>;


export type GqlCreatePrescriptiveModelMutation = { __typename?: 'Mutation', createPrescriptiveModel?: { __typename: 'CreatePrescriptiveModelPayload', model: { __typename: 'PrescriptiveModel', id: string, name: string, description: string, state: GqlModelState, created: string, trainingStart?: string | null, trainingEnd?: string | null, trainingPeriod?: string | null, initialInferenceStart?: string | null, initialInferenceEnd?: string | null, errorMessage?: string | null, viewerHasStarred: boolean, trainingPeriodExclusions: Array<{ __typename?: 'ModelTrainingPeriodExclusion', start: string, end: string }>, type: { __typename: 'ModelType', id: string, name: string }, method: { __typename: 'ModelMethod', id: string, name: string }, tag: { __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }, inputTags: Array<{ __typename: 'Tag', id: string, tagName: string, engUnit?: string | null, description?: string | null, displayName?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null, availableDataTimeRange?: { __typename: 'ProcessDataEventTimeRange', min: string, max: string } | null }>, activeTrainedModel?: { __typename: 'TrainedModel', valMae?: number | null, valRSquare?: number | null, valRSquareHealth?: GqlHealth | null, targetStd?: number | null, targetStdHealth?: GqlHealth | null, targetMaeReduction?: number | null, targetMaeReductionHealth?: GqlHealth | null, anomalyCount?: number | null, dataEnd: string, dataStart: string } | null, createdBy?: { __typename: 'User', id: string, name: string } | null } } | null };

export type GqlUpdateModelAnomalyConditions_AnomalyModel_Fragment = { __typename: 'AnomalyModel', id: string, anomalyConditions: Array<{ __typename?: 'AnomalyCondition', threshold: number, thresholdKind: GqlThresholdKind, errorScore: { __typename?: 'ErrorScore', kind: GqlErrorScoreKind, transform: GqlTransform } }> };

export type GqlUpdateModelAnomalyConditions_ForecastModel_Fragment = { __typename: 'ForecastModel', id: string };

export type GqlUpdateModelAnomalyConditions_PrescriptiveModel_Fragment = { __typename: 'PrescriptiveModel', id: string };

export type GqlUpdateModelAnomalyConditionsFragment = GqlUpdateModelAnomalyConditions_AnomalyModel_Fragment | GqlUpdateModelAnomalyConditions_ForecastModel_Fragment | GqlUpdateModelAnomalyConditions_PrescriptiveModel_Fragment;

export type GqlUpdateModelAnomalyConditionsMutationVariables = Exact<{
  input: GqlUpdateModelAnomalyConditionsInput;
}>;


export type GqlUpdateModelAnomalyConditionsMutation = { __typename?: 'Mutation', updateModelAnomalyConditions?: { __typename: 'UpdateModelAnomalyConditionsPayload', model: { __typename: 'AnomalyModel', id: string, anomalyConditions: Array<{ __typename?: 'AnomalyCondition', threshold: number, thresholdKind: GqlThresholdKind, errorScore: { __typename?: 'ErrorScore', kind: GqlErrorScoreKind, transform: GqlTransform } }> } | { __typename: 'ForecastModel', id: string } | { __typename: 'PrescriptiveModel', id: string } } | null };

export type GqlUpdateModelThresholds_AnomalyModel_Fragment = { __typename: 'AnomalyModel', spikeAnomalyThreshold?: number | null, shortAnomalyThreshold?: number | null, id: string };

export type GqlUpdateModelThresholds_ForecastModel_Fragment = { __typename: 'ForecastModel', id: string };

export type GqlUpdateModelThresholds_PrescriptiveModel_Fragment = { __typename: 'PrescriptiveModel', id: string };

export type GqlUpdateModelThresholdsFragment = GqlUpdateModelThresholds_AnomalyModel_Fragment | GqlUpdateModelThresholds_ForecastModel_Fragment | GqlUpdateModelThresholds_PrescriptiveModel_Fragment;

export type GqlUpdateModelThresholdsMutationVariables = Exact<{
  input: GqlUpdateModelThresholdsInput;
}>;


export type GqlUpdateModelThresholdsMutation = { __typename?: 'Mutation', updateModelThresholds?: { __typename: 'UpdateModelThresholdsPayload', model: { __typename: 'AnomalyModel', spikeAnomalyThreshold?: number | null, shortAnomalyThreshold?: number | null, id: string } | { __typename: 'ForecastModel', id: string } | { __typename: 'PrescriptiveModel', id: string } } | null };

export type GqlUpdateModelFilter_AnomalyModel_Fragment = { __typename: 'AnomalyModel', anomalyGenerationFilter?: string | null, id: string };

export type GqlUpdateModelFilter_ForecastModel_Fragment = { __typename: 'ForecastModel', id: string };

export type GqlUpdateModelFilter_PrescriptiveModel_Fragment = { __typename: 'PrescriptiveModel', id: string };

export type GqlUpdateModelFilterFragment = GqlUpdateModelFilter_AnomalyModel_Fragment | GqlUpdateModelFilter_ForecastModel_Fragment | GqlUpdateModelFilter_PrescriptiveModel_Fragment;

export type GqlUpdateModelFilterMutationVariables = Exact<{
  input: GqlUpdateModelFilterInput;
}>;


export type GqlUpdateModelFilterMutation = { __typename?: 'Mutation', updateModelFilter?: { __typename: 'UpdateModelFilterPayload', model: { __typename: 'AnomalyModel', anomalyGenerationFilter?: string | null, id: string } | { __typename: 'ForecastModel', id: string } | { __typename: 'PrescriptiveModel', id: string } } | null };

export type GqlStarrableState_AnomalyModel_Fragment = { __typename?: 'AnomalyModel', viewerHasStarred: boolean };

export type GqlStarrableState_ForecastModel_Fragment = { __typename?: 'ForecastModel', viewerHasStarred: boolean };

export type GqlStarrableState_PrescriptiveModel_Fragment = { __typename?: 'PrescriptiveModel', viewerHasStarred: boolean };

export type GqlStarrableState_TrendView_Fragment = { __typename?: 'TrendView', viewerHasStarred: boolean };

export type GqlStarrableStateFragment = GqlStarrableState_AnomalyModel_Fragment | GqlStarrableState_ForecastModel_Fragment | GqlStarrableState_PrescriptiveModel_Fragment | GqlStarrableState_TrendView_Fragment;

export type GqlAddStarMutationVariables = Exact<{
  input: GqlAddStarInput;
}>;


export type GqlAddStarMutation = { __typename?: 'Mutation', addStar?: { __typename: 'AddStarPayload', starrable?: { __typename?: 'AnomalyModel', viewerHasStarred: boolean } | { __typename?: 'ForecastModel', viewerHasStarred: boolean } | { __typename?: 'PrescriptiveModel', viewerHasStarred: boolean } | { __typename?: 'TrendView', viewerHasStarred: boolean } | null } | null };

export type GqlRemoveStarMutationVariables = Exact<{
  input: GqlRemoveStarInput;
}>;


export type GqlRemoveStarMutation = { __typename?: 'Mutation', removeStar?: { __typename: 'RemoveStarPayload', starrable?: { __typename?: 'AnomalyModel', viewerHasStarred: boolean } | { __typename?: 'ForecastModel', viewerHasStarred: boolean } | { __typename?: 'PrescriptiveModel', viewerHasStarred: boolean } | { __typename?: 'TrendView', viewerHasStarred: boolean } | null } | null };

export type GqlFetchFactoryUsersQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
}>;


export type GqlFetchFactoryUsersQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', customer: { __typename?: 'Customer', id: string, name: string }, users?: { __typename?: 'FactoryUserConnection', edges?: Array<{ __typename?: 'FactoryUserEdge', role: GqlFactoryRole, node?: { __typename?: 'User', id: string, name: string, email?: string | null, status: GqlUserStatus, createdBy?: { __typename?: 'User', id: string, name: string } | null, customer?: { __typename?: 'Customer', id: string, name: string } | null } | null } | null> | null } | null } | null };

export type GqlAgentReleaseFragment = { __typename?: 'AgentRelease', id: string, semver: string, release: string, summary: string, isBeta: boolean, fullDescription?: string | null, url: string, tags: Array<string>, sha256Hash: string, fileName: string };

export type GqlFetchAgentReleasesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlFetchAgentReleasesQuery = { __typename?: 'Query', agentReleases?: { __typename?: 'AgentReleaseConnection', items?: Array<{ __typename?: 'AgentRelease', id: string, semver: string, release: string, summary: string, isBeta: boolean, fullDescription?: string | null, url: string, tags: Array<string>, sha256Hash: string, fileName: string } | null> | null } | null };

export type GqlGatewayFragment = { __typename?: 'Agent', id: string, createdOn: string, lastPing?: string | null, version?: string | null, startTime?: string | null, hostname?: string | null, opcConnections?: { __typename?: 'OpcConnectionConnection', items?: Array<{ __typename?: 'OpcConnection', id: string, agentId: string, factoryId: string, name: string, endpoint: string, securityPolicy?: GqlOpcSecurityPolicy | null, securityMode?: GqlOpcSecurityMode | null, username?: string | null, x509Thumbprint?: string | null, ignoreServerEndpoint: boolean, configurationState: GqlOpcConnectionConfigurationState } | null> | null } | null };

export type GqlFetchFactoryAgentsQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
}>;


export type GqlFetchFactoryAgentsQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', agents?: { __typename?: 'AgentConnection', edges?: Array<{ __typename?: 'AgentEdge', node?: { __typename?: 'Agent', id: string, createdOn: string, lastPing?: string | null, version?: string | null, startTime?: string | null, hostname?: string | null, opcConnections?: { __typename?: 'OpcConnectionConnection', items?: Array<{ __typename?: 'OpcConnection', id: string, agentId: string, factoryId: string, name: string, endpoint: string, securityPolicy?: GqlOpcSecurityPolicy | null, securityMode?: GqlOpcSecurityMode | null, username?: string | null, x509Thumbprint?: string | null, ignoreServerEndpoint: boolean, configurationState: GqlOpcConnectionConfigurationState } | null> | null } | null } | null } | null> | null } | null } | null };

export type GqlFetchFactoryAgentQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
  agent: Scalars['ID']['input'];
}>;


export type GqlFetchFactoryAgentQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', agent?: { __typename?: 'Agent', id: string, createdOn: string, lastPing?: string | null, version?: string | null, startTime?: string | null, hostname?: string | null, opcConnections?: { __typename?: 'OpcConnectionConnection', items?: Array<{ __typename?: 'OpcConnection', id: string, agentId: string, factoryId: string, name: string, endpoint: string, securityPolicy?: GqlOpcSecurityPolicy | null, securityMode?: GqlOpcSecurityMode | null, username?: string | null, x509Thumbprint?: string | null, ignoreServerEndpoint: boolean, configurationState: GqlOpcConnectionConfigurationState } | null> | null } | null } | null } | null };

export type GqlFetchFactoryInvitationsQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
}>;


export type GqlFetchFactoryInvitationsQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', invitations?: { __typename?: 'FactoryInvitationConnection', edges?: Array<{ __typename?: 'FactoryInvitationEdge', node?: { __typename?: 'FactoryInvitation', id: string, role: GqlFactoryRole, createdAt: string, validUntil: string, completedAt?: string | null, state: GqlInvitationState, invitee: { __typename?: 'User', id: string, name: string, email?: string | null, customer?: { __typename?: 'Customer', id: string, name: string } | null }, inviter: { __typename?: 'User', id: string, name: string }, factory: { __typename?: 'Factory', id: string, name: string, customer: { __typename: 'Customer', id: string, name: string } } } | null } | null> | null } | null } | null };

export type GqlFetchFactoryCreditsQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
}>;


export type GqlFetchFactoryCreditsQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', activeModelCreditsUsage?: { __typename?: 'ActiveModelCreditsUsage', total: number, batch: { __typename?: 'ActiveModelTypeCreditsUsage', type: GqlActiveModelType, creditsPerModel: number, models: number, total: number }, streaming: { __typename?: 'ActiveModelTypeCreditsUsage', type: GqlActiveModelType, creditsPerModel: number, models: number, total: number } } | null } | null };

export type GqlFetchFactoryDexAccessQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
}>;


export type GqlFetchFactoryDexAccessQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', dexAccess: boolean } | null };

export type GqlTestOpcUaConnectionQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
  agent: Scalars['ID']['input'];
  url: Scalars['String']['input'];
}>;


export type GqlTestOpcUaConnectionQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', agent?: { __typename?: 'Agent', id: string, serverEndpoints: { __typename?: 'AgentOpcEndpointDescriptionsResponse', error?: string | null, endpoints?: Array<{ __typename?: 'OpcEndpointDescription', url: string, securityMode: GqlOpcSecurityMode, securityPolicy: GqlOpcSecurityPolicy, userIdentityTokens: Array<{ __typename?: 'OpcUserIdentityToken', policyId: string, userTokenType: GqlOpcUserTokenType, issuedTokenType: string, issuerEndpointUrl: string, securityPolicy?: GqlOpcSecurityPolicy | null }>, server?: { __typename?: 'OpcApplicationDescription', applicationURI: string, productURI: string, applicationName: string, applicationType: string, gatewayServerURI: string, discoveryProfileURI: string, discoveryUrls: Array<string> } | null }> | null }, listCertificates: { __typename?: 'AgentCertificatesResponse', error?: string | null, certificates?: Array<{ __typename?: 'AgentCertificate', path: string, thumbprint: string, serialNumber: string, createdAt?: string | null, expiresAt?: string | null }> | null } } | null } | null };

export type GqlFetchOpcConnectionsQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
  agent: Scalars['ID']['input'];
}>;


export type GqlFetchOpcConnectionsQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', agent?: { __typename?: 'Agent', id: string, opcConnections?: { __typename?: 'OpcConnectionConnection', items?: Array<{ __typename?: 'OpcConnection', id: string, agentId: string, factoryId: string, name: string, endpoint: string, securityPolicy?: GqlOpcSecurityPolicy | null, securityMode?: GqlOpcSecurityMode | null, username?: string | null, x509Thumbprint?: string | null, ignoreServerEndpoint: boolean, configurationState: GqlOpcConnectionConfigurationState } | null> | null } | null } | null } | null };

export type GqlValidateOpcUaConnectionQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
  agentId: Scalars['ID']['input'];
  connection: GqlValidateOpcConnectionInput;
}>;


export type GqlValidateOpcUaConnectionQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', agent?: { __typename?: 'Agent', validateOpcConnection: { __typename?: 'ValidateOpcConnectionResponse', error?: string | null, success: boolean } } | null } | null };

export type GqlNodeValuesFragment = { __typename?: 'OpcReadResult', nodeId: string, value?: { __typename?: 'OpcDataValue', sourceTimestamp?: string | null, serverTimestamp?: string | null, value: { __typename?: 'OpcValueBoolean', booleanValue: boolean } | { __typename?: 'OpcValueDateTime', dateTimeValue: string } | { __typename?: 'OpcValueDouble', doubleValue: number } | { __typename?: 'OpcValueError', error: string } | { __typename?: 'OpcValueFloat', floatValue: number } | { __typename?: 'OpcValueInt', intValue: number } | { __typename?: 'OpcValueLong', longValue: number } | { __typename?: 'OpcValueShort', shortValue: number } | { __typename?: 'OpcValueString', stringValue: string } | { __typename?: 'OpcValueUInt', uintValue: number } | { __typename?: 'OpcValueULong', ulongValue: number } | { __typename?: 'OpcValueUShort', ushortValue: number }, status: { __typename?: 'OpcStatus', value: number, severity: GqlOpcStatusSeverity } } | null };

export type GqlReadNodeValuesQueryVariables = Exact<{
  connectionId: Scalars['ID']['input'];
  nodeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  timeout: Scalars['Milliseconds']['input'];
}>;


export type GqlReadNodeValuesQuery = { __typename?: 'Query', node?: { __typename: 'Agent', id: string } | { __typename: 'Anomaly', id: string } | { __typename: 'AnomalyComment', id: string } | { __typename: 'AnomalyModel', id: string } | { __typename: 'Asset', id: string } | { __typename: 'Customer', id: string } | { __typename: 'Factory', id: string } | { __typename: 'FactoryInvitation', id: string } | { __typename: 'ForecastModel', id: string } | { __typename: 'HierarchyAsset', id: string } | { __typename: 'HierarchyTag', id: string } | { __typename: 'ModelMethod', id: string } | { __typename: 'ModelType', id: string } | { __typename: 'OpcConnection', id: string, readValues: Array<{ __typename?: 'OpcReadResult', nodeId: string, value?: { __typename?: 'OpcDataValue', sourceTimestamp?: string | null, serverTimestamp?: string | null, value: { __typename?: 'OpcValueBoolean', booleanValue: boolean } | { __typename?: 'OpcValueDateTime', dateTimeValue: string } | { __typename?: 'OpcValueDouble', doubleValue: number } | { __typename?: 'OpcValueError', error: string } | { __typename?: 'OpcValueFloat', floatValue: number } | { __typename?: 'OpcValueInt', intValue: number } | { __typename?: 'OpcValueLong', longValue: number } | { __typename?: 'OpcValueShort', shortValue: number } | { __typename?: 'OpcValueString', stringValue: string } | { __typename?: 'OpcValueUInt', uintValue: number } | { __typename?: 'OpcValueULong', ulongValue: number } | { __typename?: 'OpcValueUShort', ushortValue: number }, status: { __typename?: 'OpcStatus', value: number, severity: GqlOpcStatusSeverity } } | null }> } | { __typename: 'OpcSubscription', id: string } | { __typename: 'OpcUaSyncJobDefinition', id: string } | { __typename: 'OpcUaSyncTask', id: string } | { __typename: 'PrescriptiveModel', id: string } | { __typename: 'Tag', id: string } | { __typename: 'TrainedModel', id: string } | { __typename: 'TrainingTask', id: string } | { __typename: 'TrendView', id: string } | { __typename: 'User', id: string } | null };

export type GqlBrowseNodeFragment = { __typename?: 'OpcBrowseResponse', node: { __typename: 'ObjectOpcNode', nodeId: string, browseName: string, displayName: string, description: string } | { __typename: 'UnknownOpcNode', nodeId: string, browseName: string, displayName: string, description: string } | { __typename: 'VariableOpcNode', dataType?: string | null, nodeId: string, browseName: string, displayName: string, description: string }, children: Array<{ __typename: 'ObjectOpcNode', nodeId: string, browseName: string, displayName: string, description: string } | { __typename: 'UnknownOpcNode', nodeId: string, browseName: string, displayName: string, description: string } | { __typename: 'VariableOpcNode', dataType?: string | null, nodeId: string, browseName: string, displayName: string, description: string }> };

export type GqlOpcNode_ObjectOpcNode_Fragment = { __typename: 'ObjectOpcNode', nodeId: string, browseName: string, displayName: string, description: string };

export type GqlOpcNode_UnknownOpcNode_Fragment = { __typename: 'UnknownOpcNode', nodeId: string, browseName: string, displayName: string, description: string };

export type GqlOpcNode_VariableOpcNode_Fragment = { __typename: 'VariableOpcNode', dataType?: string | null, nodeId: string, browseName: string, displayName: string, description: string };

export type GqlOpcNodeFragment = GqlOpcNode_ObjectOpcNode_Fragment | GqlOpcNode_UnknownOpcNode_Fragment | GqlOpcNode_VariableOpcNode_Fragment;

export type GqlOpcBrowseQueryVariables = Exact<{
  connectionId: Scalars['ID']['input'];
  nodeId: Scalars['String']['input'];
  timeout: Scalars['Milliseconds']['input'];
}>;


export type GqlOpcBrowseQuery = { __typename?: 'Query', node?: { __typename: 'Agent', id: string } | { __typename: 'Anomaly', id: string } | { __typename: 'AnomalyComment', id: string } | { __typename: 'AnomalyModel', id: string } | { __typename: 'Asset', id: string } | { __typename: 'Customer', id: string } | { __typename: 'Factory', id: string } | { __typename: 'FactoryInvitation', id: string } | { __typename: 'ForecastModel', id: string } | { __typename: 'HierarchyAsset', id: string } | { __typename: 'HierarchyTag', id: string } | { __typename: 'ModelMethod', id: string } | { __typename: 'ModelType', id: string } | { __typename: 'OpcConnection', name: string, id: string, browse: { __typename?: 'OpcBrowseResponse', node: { __typename: 'ObjectOpcNode', nodeId: string, browseName: string, displayName: string, description: string } | { __typename: 'UnknownOpcNode', nodeId: string, browseName: string, displayName: string, description: string } | { __typename: 'VariableOpcNode', dataType?: string | null, nodeId: string, browseName: string, displayName: string, description: string }, children: Array<{ __typename: 'ObjectOpcNode', nodeId: string, browseName: string, displayName: string, description: string } | { __typename: 'UnknownOpcNode', nodeId: string, browseName: string, displayName: string, description: string } | { __typename: 'VariableOpcNode', dataType?: string | null, nodeId: string, browseName: string, displayName: string, description: string }> } } | { __typename: 'OpcSubscription', id: string } | { __typename: 'OpcUaSyncJobDefinition', id: string } | { __typename: 'OpcUaSyncTask', id: string } | { __typename: 'PrescriptiveModel', id: string } | { __typename: 'Tag', id: string } | { __typename: 'TrainedModel', id: string } | { __typename: 'TrainingTask', id: string } | { __typename: 'TrendView', id: string } | { __typename: 'User', id: string } | null };

export type GqlOpcSubscriptionFragment = { __typename?: 'OpcSubscription', id: string, agentId: string, lastUpdated: string, revision: number, opcConnectionId: string, autoStart: boolean, batchInterval: number, heartbeatNode: string, heartbeatInterval: number, nodes?: { __typename?: 'OpcSubscriptionNodeConnection', totalCount?: number | null } | null };

export type GqlGetSubscriptionsQueryVariables = Exact<{
  agentId: Scalars['ID']['input'];
}>;


export type GqlGetSubscriptionsQuery = { __typename?: 'Query', node?: { __typename: 'Agent', opcSubscriptions?: { __typename?: 'OpcSubscriptionConnection', items?: Array<{ __typename?: 'OpcSubscription', id: string, agentId: string, lastUpdated: string, revision: number, opcConnectionId: string, autoStart: boolean, batchInterval: number, heartbeatNode: string, heartbeatInterval: number, nodes?: { __typename?: 'OpcSubscriptionNodeConnection', totalCount?: number | null } | null } | null> | null } | null } | { __typename?: 'Anomaly' } | { __typename?: 'AnomalyComment' } | { __typename?: 'AnomalyModel' } | { __typename?: 'Asset' } | { __typename?: 'Customer' } | { __typename?: 'Factory' } | { __typename?: 'FactoryInvitation' } | { __typename?: 'ForecastModel' } | { __typename?: 'HierarchyAsset' } | { __typename?: 'HierarchyTag' } | { __typename?: 'ModelMethod' } | { __typename?: 'ModelType' } | { __typename?: 'OpcConnection' } | { __typename?: 'OpcSubscription' } | { __typename?: 'OpcUaSyncJobDefinition' } | { __typename?: 'OpcUaSyncTask' } | { __typename?: 'PrescriptiveModel' } | { __typename?: 'Tag' } | { __typename?: 'TrainedModel' } | { __typename?: 'TrainingTask' } | { __typename?: 'TrendView' } | { __typename?: 'User' } | null };

export type GqlGetSubscriptionQueryVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
}>;


export type GqlGetSubscriptionQuery = { __typename?: 'Query', node?: { __typename?: 'Agent' } | { __typename?: 'Anomaly' } | { __typename?: 'AnomalyComment' } | { __typename?: 'AnomalyModel' } | { __typename?: 'Asset' } | { __typename?: 'Customer' } | { __typename?: 'Factory' } | { __typename?: 'FactoryInvitation' } | { __typename?: 'ForecastModel' } | { __typename?: 'HierarchyAsset' } | { __typename?: 'HierarchyTag' } | { __typename?: 'ModelMethod' } | { __typename?: 'ModelType' } | { __typename?: 'OpcConnection' } | { __typename: 'OpcSubscription', id: string, agentId: string, lastUpdated: string, revision: number, opcConnectionId: string, autoStart: boolean, batchInterval: number, heartbeatNode: string, heartbeatInterval: number, nodes?: { __typename?: 'OpcSubscriptionNodeConnection', totalCount?: number | null } | null } | { __typename?: 'OpcUaSyncJobDefinition' } | { __typename?: 'OpcUaSyncTask' } | { __typename?: 'PrescriptiveModel' } | { __typename?: 'Tag' } | { __typename?: 'TrainedModel' } | { __typename?: 'TrainingTask' } | { __typename?: 'TrendView' } | { __typename?: 'User' } | null };

export type GqlGetSubscriptionNodesQueryVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GqlGetSubscriptionNodesQuery = { __typename?: 'Query', node?: { __typename?: 'Agent' } | { __typename?: 'Anomaly' } | { __typename?: 'AnomalyComment' } | { __typename?: 'AnomalyModel' } | { __typename?: 'Asset' } | { __typename?: 'Customer' } | { __typename?: 'Factory' } | { __typename?: 'FactoryInvitation' } | { __typename?: 'ForecastModel' } | { __typename?: 'HierarchyAsset' } | { __typename?: 'HierarchyTag' } | { __typename?: 'ModelMethod' } | { __typename?: 'ModelType' } | { __typename?: 'OpcConnection' } | { __typename: 'OpcSubscription', id: string, nodes?: { __typename?: 'OpcSubscriptionNodeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, items?: Array<{ __typename?: 'OpcSubscriptionNode', nodeId: string } | null> | null } | null } | { __typename?: 'OpcUaSyncJobDefinition' } | { __typename?: 'OpcUaSyncTask' } | { __typename?: 'PrescriptiveModel' } | { __typename?: 'Tag' } | { __typename?: 'TrainedModel' } | { __typename?: 'TrainingTask' } | { __typename?: 'TrendView' } | { __typename?: 'User' } | null };

export type GqlOpcUaTaskFragment = { __typename?: 'OpcUaSyncTask', id: string, startTime: string, endTime?: string | null, startNode: string, lastUpdate: string, nodesSeen: number, referencesSeen: number, nodesBrowsed: number, nodesQueued: number, browseErrors: number, error?: string | null, state: GqlOpcUaSyncTaskState, arrowUriNodes?: string | null, arrowUriReferences?: string | null };

export type GqlOpcUaSyncTasksFragment = { __typename: 'OpcConnection', lastHierarchySyncTask?: { __typename?: 'OpcUaSyncTask', id: string, startTime: string, endTime?: string | null, startNode: string, lastUpdate: string, nodesSeen: number, referencesSeen: number, nodesBrowsed: number, nodesQueued: number, browseErrors: number, error?: string | null, state: GqlOpcUaSyncTaskState, arrowUriNodes?: string | null, arrowUriReferences?: string | null } | null, lastSuccessfulHierarchySyncTask?: { __typename?: 'OpcUaSyncTask', id: string, startTime: string, endTime?: string | null, startNode: string, lastUpdate: string, nodesSeen: number, referencesSeen: number, nodesBrowsed: number, nodesQueued: number, browseErrors: number, error?: string | null, state: GqlOpcUaSyncTaskState, arrowUriNodes?: string | null, arrowUriReferences?: string | null } | null };

export type GqlGetSubscriptionSyncTasksQueryVariables = Exact<{
  connectionId: Scalars['ID']['input'];
}>;


export type GqlGetSubscriptionSyncTasksQuery = { __typename?: 'Query', node?: { __typename?: 'Agent' } | { __typename?: 'Anomaly' } | { __typename?: 'AnomalyComment' } | { __typename?: 'AnomalyModel' } | { __typename?: 'Asset' } | { __typename?: 'Customer' } | { __typename?: 'Factory' } | { __typename?: 'FactoryInvitation' } | { __typename?: 'ForecastModel' } | { __typename?: 'HierarchyAsset' } | { __typename?: 'HierarchyTag' } | { __typename?: 'ModelMethod' } | { __typename?: 'ModelType' } | { __typename: 'OpcConnection', lastHierarchySyncTask?: { __typename?: 'OpcUaSyncTask', id: string, startTime: string, endTime?: string | null, startNode: string, lastUpdate: string, nodesSeen: number, referencesSeen: number, nodesBrowsed: number, nodesQueued: number, browseErrors: number, error?: string | null, state: GqlOpcUaSyncTaskState, arrowUriNodes?: string | null, arrowUriReferences?: string | null } | null, lastSuccessfulHierarchySyncTask?: { __typename?: 'OpcUaSyncTask', id: string, startTime: string, endTime?: string | null, startNode: string, lastUpdate: string, nodesSeen: number, referencesSeen: number, nodesBrowsed: number, nodesQueued: number, browseErrors: number, error?: string | null, state: GqlOpcUaSyncTaskState, arrowUriNodes?: string | null, arrowUriReferences?: string | null } | null } | { __typename?: 'OpcSubscription' } | { __typename?: 'OpcUaSyncJobDefinition' } | { __typename?: 'OpcUaSyncTask' } | { __typename?: 'PrescriptiveModel' } | { __typename?: 'Tag' } | { __typename?: 'TrainedModel' } | { __typename?: 'TrainingTask' } | { __typename?: 'TrendView' } | { __typename?: 'User' } | null };

export type GqlSetFactoryUserRoleMutationVariables = Exact<{
  input: GqlSetFactoryUserRoleInput;
}>;


export type GqlSetFactoryUserRoleMutation = { __typename?: 'Mutation', setFactoryUserRole?: { __typename: 'SetFactoryUserRolePayload', factory?: { __typename?: 'Factory', id: string } | null, userEdge?: { __typename?: 'FactoryUserEdge', role: GqlFactoryRole, node?: { __typename?: 'User', id: string, name: string } | null } | null } | null };

export type GqlRemoveFactoryUserMutationVariables = Exact<{
  input: GqlRemoveFactoryUserInput;
}>;


export type GqlRemoveFactoryUserMutation = { __typename?: 'Mutation', removeFactoryUser?: { __typename: 'RemoveFactoryUserPayload', factory?: { __typename?: 'Factory', id: string } | null, userEdge?: { __typename?: 'FactoryUserEdge', role: GqlFactoryRole, node?: { __typename?: 'User', id: string, name: string } | null } | null } | null };

export type GqlRemoveCustomerUserMutationVariables = Exact<{
  input: GqlRemoveCustomerUserInput;
}>;


export type GqlRemoveCustomerUserMutation = { __typename?: 'Mutation', removeCustomerUser?: { __typename: 'RemoveCustomerUserPayload', customer: { __typename?: 'Customer', id: string }, userEdge: { __typename?: 'CustomerUserEdge', role: GqlCustomerRole, node?: { __typename?: 'User', id: string, name: string } | null } } | null };

export type GqlUpdateUserConsentMutationVariables = Exact<{
  input: GqlUpdateUserConsentInput;
}>;


export type GqlUpdateUserConsentMutation = { __typename?: 'Mutation', updateUserConsent?: { __typename: 'UpdateUserConsentPayload', user: { __typename?: 'User', id: string, cookieConsent: boolean, dataCollectionConsent: boolean, name: string } } | null };

export type GqlUpdateUserDefaultFactoryMutationVariables = Exact<{
  input: GqlUpdateUserDefaultFactoryInput;
}>;


export type GqlUpdateUserDefaultFactoryMutation = { __typename?: 'Mutation', updateUserDefaultFactory?: { __typename: 'UpdateUserDefaultFactoryPayload', user: { __typename?: 'User', id: string, defaultFactoryId?: string | null } } | null };

export type GqlFetchFactoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GqlFetchFactoryQuery = { __typename?: 'Query', factory?: { __typename: 'Factory', id: string, name: string, dexAccess: boolean, viewerRole?: GqlFactoryRole | null, userCount: number, customer: { __typename?: 'Customer', id: string, name: string }, agents?: { __typename?: 'AgentConnection', items?: Array<{ __typename: 'Agent', id: string } | null> | null } | null } | null };

export type GqlFetchMyFactoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlFetchMyFactoriesQuery = { __typename?: 'Query', me: { __typename?: 'User', factories: Array<{ __typename?: 'Factory', id: string, name: string, viewerRole?: GqlFactoryRole | null, customer: { __typename?: 'Customer', id: string, name: string }, users?: { __typename?: 'FactoryUserConnection', items?: Array<{ __typename?: 'User', id: string } | null> | null } | null, agents?: { __typename?: 'AgentConnection', items?: Array<{ __typename?: 'Agent', id: string } | null> | null } | null }> } };

export type GqlFetchCustomerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  status?: InputMaybe<GqlUserStatus>;
}>;


export type GqlFetchCustomerQuery = { __typename?: 'Query', me: { __typename?: 'User', customer?: { __typename?: 'Customer', id: string } | null }, customer?: { __typename?: 'Customer', id: string, name: string, viewerRole?: GqlCustomerRole | null, factoryCount: number, factories?: { __typename?: 'FactoryConnection', items?: Array<{ __typename?: 'Factory', id: string, name: string, viewerRole?: GqlFactoryRole | null, userCount: number, agents?: { __typename?: 'AgentConnection', items?: Array<{ __typename?: 'Agent', id: string } | null> | null } | null } | null> | null } | null, users?: { __typename?: 'CustomerUserConnection', edges?: Array<{ __typename?: 'CustomerUserEdge', role: GqlCustomerRole, node?: { __typename?: 'User', id: string, name: string, email?: string | null, status: GqlUserStatus, customer?: { __typename?: 'Customer', id: string, name: string } | null } | null } | null> | null } | null } | null };

export type GqlDisableUserMutationVariables = Exact<{
  input: GqlDisableUserInput;
}>;


export type GqlDisableUserMutation = { __typename?: 'Mutation', disableUser?: { __typename: 'DisableUserPayload', user: { __typename?: 'User', id: string, cookieConsent: boolean, dataCollectionConsent: boolean, name: string } } | null };

export type GqlEnableUserMutationVariables = Exact<{
  input: GqlEnableUserInput;
}>;


export type GqlEnableUserMutation = { __typename?: 'Mutation', enableUser?: { __typename: 'EnableUserPayload', user: { __typename?: 'User', id: string } } | null };

export type GqlAddUserMutationVariables = Exact<{
  input: GqlAddUserInput;
}>;


export type GqlAddUserMutation = { __typename?: 'Mutation', addUser?: { __typename: 'AddUserPayload', user: { __typename?: 'User', id: string, cookieConsent: boolean, dataCollectionConsent: boolean, name: string } } | null };

export type GqlSetCustomerUserRoleMutationVariables = Exact<{
  input: GqlSetCustomerUserRoleInput;
}>;


export type GqlSetCustomerUserRoleMutation = { __typename?: 'Mutation', setCustomerUserRole?: { __typename: 'SetCustomerUserRolePayload', customer?: { __typename?: 'Customer', id: string } | null, userEdge?: { __typename?: 'CustomerUserEdge', role: GqlCustomerRole, node?: { __typename?: 'User', id: string, name: string } | null } | null } | null };

export type GqlInviteFactoryUserMutationVariables = Exact<{
  input: GqlInviteFactoryUserInput;
}>;


export type GqlInviteFactoryUserMutation = { __typename?: 'Mutation', inviteFactoryUser?: { __typename: 'InviteFactoryUserPayload', invitation: { __typename?: 'FactoryInvitation', id: string, state: GqlInvitationState } } | null };

export type GqlAcceptFactoryInvitationMutationVariables = Exact<{
  input: GqlAcceptFactoryInvitationInput;
}>;


export type GqlAcceptFactoryInvitationMutation = { __typename?: 'Mutation', acceptFactoryInvitation?: { __typename?: 'AcceptFactoryInvitationPayload', invitation: { __typename?: 'FactoryInvitation', id: string, state: GqlInvitationState } } | null };

export type GqlDeclineFactoryInvitationMutationVariables = Exact<{
  input: GqlDeclineFactoryInvitationInput;
}>;


export type GqlDeclineFactoryInvitationMutation = { __typename?: 'Mutation', declineFactoryInvitation?: { __typename?: 'DeclineFactoryInvitationPayload', invitation: { __typename?: 'FactoryInvitation', id: string, state: GqlInvitationState } } | null };

export type GqlCancelFactoryInvitationMutationVariables = Exact<{
  input: GqlCancelFactoryInvitationInput;
}>;


export type GqlCancelFactoryInvitationMutation = { __typename?: 'Mutation', cancelFactoryInvitation?: { __typename?: 'CancelFactoryInvitationPayload', invitation: { __typename?: 'FactoryInvitation', id: string, state: GqlInvitationState } } | null };

export type GqlAnomalyCountByStateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GqlAnomalyCountByStateQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', anomalyCountByState: Array<{ __typename?: 'AnomalyStateCount', state: GqlAnomalyState, count: number }> } | null };

export type GqlUpdatedTagFragment = { __typename?: 'Tag', id: string, tagName: string, description?: string | null, displayName?: string | null, engUnit?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null };

export type GqlUpdateTagMutationVariables = Exact<{
  input: GqlUpdateTagInput;
}>;


export type GqlUpdateTagMutation = { __typename?: 'Mutation', updateTag?: { __typename: 'UpdateTagPayload', tag: { __typename?: 'Tag', id: string, tagName: string, description?: string | null, displayName?: string | null, engUnit?: string | null, automaticLabel?: GqlTagClassification | null, overriddenLabel?: GqlTagClassification | null } } | null };

export type GqlTagDetailsFragment = { __typename?: 'Tag', id: string, tagName: string, description?: string | null, valueType?: string | null, engUnit?: string | null, displayName?: string | null, availableDataTimeRange?: { __typename?: 'ProcessDataEventTimeRange', min: string, max: string } | null };

export type GqlFetchTagQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
  tagName: Scalars['String']['input'];
}>;


export type GqlFetchTagQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', tagByName?: { __typename?: 'Tag', id: string, tagName: string, description?: string | null, valueType?: string | null, engUnit?: string | null, displayName?: string | null, availableDataTimeRange?: { __typename?: 'ProcessDataEventTimeRange', min: string, max: string } | null } | null } | null };

export type GqlAnomalyCommentBaseFragment = { __typename?: 'AnomalyComment', id: string, comment: string, by: string, at: string };

export type GqlAnomalyBaseFragment = { __typename?: 'Anomaly', id: string, start: string, score?: number | null, state: GqlAnomalyState, end?: string | null, inProgress: boolean, restId: number, comments: Array<{ __typename?: 'AnomalyComment', id: string, comment: string, by: string, at: string }>, model: { __typename?: 'AnomalyModel', id: string, name: string, typeId: string, state: GqlModelState, tag: { __typename?: 'Tag', tagName: string, displayName?: string | null, id: string, hierarchyTag?: { __typename?: 'HierarchyTag', id: string, asset: { __typename?: 'Asset', id: string, name: string, alias?: string | null } } | null } } };

export type GqlFetchAnomaliesQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type GqlFetchAnomaliesQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', anomalies?: { __typename?: 'AnomalyConnection', edges?: Array<{ __typename?: 'AnomalyEdge', node?: { __typename?: 'Anomaly', id: string, start: string, score?: number | null, state: GqlAnomalyState, end?: string | null, inProgress: boolean, restId: number, comments: Array<{ __typename?: 'AnomalyComment', id: string, comment: string, by: string, at: string }>, model: { __typename?: 'AnomalyModel', id: string, name: string, typeId: string, state: GqlModelState, tag: { __typename?: 'Tag', tagName: string, displayName?: string | null, id: string, hierarchyTag?: { __typename?: 'HierarchyTag', id: string, asset: { __typename?: 'Asset', id: string, name: string, alias?: string | null } } | null } } } | null } | null> | null } | null } | null };

export type GqlNavigationAnomalyFragment = { __typename?: 'Anomaly', id: string, start: string, end?: string | null, score?: number | null };

export type GqlFetchAnomalyFragment = { __typename?: 'Anomaly', id: string, start: string, score?: number | null, state: GqlAnomalyState, end?: string | null, inProgress: boolean, restId: number, previous?: { __typename?: 'Anomaly', id: string, start: string, end?: string | null, score?: number | null } | null, next?: { __typename?: 'Anomaly', id: string, start: string, end?: string | null, score?: number | null } | null, comments: Array<{ __typename?: 'AnomalyComment', id: string, comment: string, by: string, at: string }>, model: { __typename?: 'AnomalyModel', id: string, name: string, typeId: string, state: GqlModelState, tag: { __typename?: 'Tag', tagName: string, displayName?: string | null, id: string, hierarchyTag?: { __typename?: 'HierarchyTag', id: string, asset: { __typename?: 'Asset', id: string, name: string, alias?: string | null } } | null } } };

export type GqlFetchAnomalyQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
  anomaly: Scalars['ID']['input'];
}>;


export type GqlFetchAnomalyQuery = { __typename?: 'Query', factory?: { __typename: 'Factory', anomaly?: { __typename?: 'Anomaly', id: string, start: string, score?: number | null, state: GqlAnomalyState, end?: string | null, inProgress: boolean, restId: number, previous?: { __typename?: 'Anomaly', id: string, start: string, end?: string | null, score?: number | null } | null, next?: { __typename?: 'Anomaly', id: string, start: string, end?: string | null, score?: number | null } | null, comments: Array<{ __typename?: 'AnomalyComment', id: string, comment: string, by: string, at: string }>, model: { __typename?: 'AnomalyModel', id: string, name: string, typeId: string, state: GqlModelState, tag: { __typename?: 'Tag', tagName: string, displayName?: string | null, id: string, hierarchyTag?: { __typename?: 'HierarchyTag', id: string, asset: { __typename?: 'Asset', id: string, name: string, alias?: string | null } } | null } } } | null } | null };

export type GqlLatestCommentAnomalyFragment = { __typename?: 'Anomaly', id: string, start: string, model: { __typename?: 'AnomalyModel', id: string, name: string } };

export type GqlLatestCommentFragment = { __typename?: 'AnomalyComment', id: string, comment: string, by: string, at: string, anomaly: { __typename?: 'Anomaly', id: string, start: string, model: { __typename?: 'AnomalyModel', id: string, name: string } } };

export type GqlFetchLatestCommentsQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
}>;


export type GqlFetchLatestCommentsQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', latestAnomalyComments: Array<{ __typename?: 'AnomalyComment', id: string, comment: string, by: string, at: string, anomaly: { __typename?: 'Anomaly', id: string, start: string, model: { __typename?: 'AnomalyModel', id: string, name: string } } }> } | null };

export type GqlAddAnomalyCommentMutationVariables = Exact<{
  input: GqlAddAnomalyCommentInput;
}>;


export type GqlAddAnomalyCommentMutation = { __typename?: 'Mutation', addAnomalyComment?: { __typename: 'AddAnomalyCommentPayload', comment: { __typename?: 'AnomalyComment', id: string, comment: string, by: string, at: string } } | null };

export type GqlSetAnomalyStateMutationVariables = Exact<{
  input: GqlSetAnomalyStateInput;
}>;


export type GqlSetAnomalyStateMutation = { __typename?: 'Mutation', setAnomalyState?: { __typename: 'SetAnomalyStatePayload', anomaly: { __typename?: 'Anomaly', id: string, start: string, score?: number | null, state: GqlAnomalyState, end?: string | null, inProgress: boolean, restId: number, previous?: { __typename?: 'Anomaly', id: string, start: string, end?: string | null, score?: number | null } | null, next?: { __typename?: 'Anomaly', id: string, start: string, end?: string | null, score?: number | null } | null, comments: Array<{ __typename?: 'AnomalyComment', id: string, comment: string, by: string, at: string }>, model: { __typename?: 'AnomalyModel', id: string, name: string, typeId: string, state: GqlModelState, tag: { __typename?: 'Tag', tagName: string, displayName?: string | null, id: string, hierarchyTag?: { __typename?: 'HierarchyTag', id: string, asset: { __typename?: 'Asset', id: string, name: string, alias?: string | null } } | null } } } } | null };

export type GqlDocumentationUrlFragment = { __typename?: 'DocumentationUrl', url: string, token: string, expiry: string };

export type GqlFetchDocsLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlFetchDocsLinkQuery = { __typename?: 'Query', documentationUrl: { __typename?: 'DocumentationUrl', url: string, token: string, expiry: string } };

export type GqlFactoryTrendViewFragment = { __typename?: 'TrendView', id: string, name: string, data: string, shared: boolean, createdAt: string, factoryId: string, updatedAt: string, viewerHasStarred: boolean, user: { __typename?: 'User', id: string, name: string } };

export type GqlFetchFactoryTrendViewsQueryVariables = Exact<{
  factory: Scalars['ID']['input'];
}>;


export type GqlFetchFactoryTrendViewsQuery = { __typename?: 'Query', factory?: { __typename?: 'Factory', trendViews?: { __typename?: 'TrendViewConnection', items?: Array<{ __typename?: 'TrendView', id: string, name: string, data: string, shared: boolean, createdAt: string, factoryId: string, updatedAt: string, viewerHasStarred: boolean, user: { __typename?: 'User', id: string, name: string } } | null> | null } | null } | null };

export type GqlCreateTrendViewMutationVariables = Exact<{
  input: GqlCreateTrendViewInput;
}>;


export type GqlCreateTrendViewMutation = { __typename?: 'Mutation', createTrendView?: { __typename?: 'CreateTrendViewPayload', trendView: { __typename?: 'TrendView', id: string, name: string, data: string, shared: boolean, createdAt: string, factoryId: string, updatedAt: string, viewerHasStarred: boolean, user: { __typename?: 'User', id: string, name: string } } } | null };

export type GqlUpdateTrendViewMutationVariables = Exact<{
  input: GqlUpdateTrendViewInput;
}>;


export type GqlUpdateTrendViewMutation = { __typename?: 'Mutation', updateTrendView?: { __typename?: 'UpdateTrendViewPayload', trendView: { __typename?: 'TrendView', id: string, name: string, data: string, shared: boolean, createdAt: string, factoryId: string, updatedAt: string, viewerHasStarred: boolean, user: { __typename?: 'User', id: string, name: string } } } | null };

export type GqlDeleteTrendViewMutationVariables = Exact<{
  input: GqlDeleteTrendViewInput;
}>;


export type GqlDeleteTrendViewMutation = { __typename?: 'Mutation', deleteTrendView?: { __typename?: 'DeleteTrendViewPayload', trendView: { __typename?: 'TrendView', id: string, name: string, data: string, shared: boolean, createdAt: string, factoryId: string, updatedAt: string, viewerHasStarred: boolean, user: { __typename?: 'User', id: string, name: string } } } | null };

export type GqlOpcConnectionFragment = { __typename?: 'OpcConnection', id: string, agentId: string, factoryId: string, name: string, endpoint: string, securityPolicy?: GqlOpcSecurityPolicy | null, securityMode?: GqlOpcSecurityMode | null, username?: string | null, x509Thumbprint?: string | null, ignoreServerEndpoint: boolean, configurationState: GqlOpcConnectionConfigurationState };

export type GqlCreateOpcConnectionMutationVariables = Exact<{
  input: GqlCreateOpcConnectionInput;
}>;


export type GqlCreateOpcConnectionMutation = { __typename?: 'Mutation', createOpcConnection?: { __typename?: 'CreateOpcConnectionPayload', connection: { __typename?: 'OpcConnection', id: string, agentId: string, factoryId: string, name: string, endpoint: string, securityPolicy?: GqlOpcSecurityPolicy | null, securityMode?: GqlOpcSecurityMode | null, username?: string | null, x509Thumbprint?: string | null, ignoreServerEndpoint: boolean, configurationState: GqlOpcConnectionConfigurationState } } | null };

export type GqlUpdateOpcConnectionMutationVariables = Exact<{
  input: GqlUpdateOpcConnectionInput;
}>;


export type GqlUpdateOpcConnectionMutation = { __typename?: 'Mutation', updateOpcConnection?: { __typename?: 'UpdateOpcConnectionPayload', connection: { __typename?: 'OpcConnection', id: string, agentId: string, factoryId: string, name: string, endpoint: string, securityPolicy?: GqlOpcSecurityPolicy | null, securityMode?: GqlOpcSecurityMode | null, username?: string | null, x509Thumbprint?: string | null, ignoreServerEndpoint: boolean, configurationState: GqlOpcConnectionConfigurationState } } | null };

export type GqlUpdateSubscribedNodesMutationVariables = Exact<{
  input: GqlUpdateSubscribedNodesInput;
}>;


export type GqlUpdateSubscribedNodesMutation = { __typename?: 'Mutation', updateSubscribedNodes?: { __typename?: 'UpdateSubscribedNodesPayload', subscribed?: Array<string> | null, unsubscribed?: Array<string> | null } | null };

export const MeFragmentDoc = gql`
    fragment Me on User {
  id
  name
  email
  dataCollectionConsent
  cookieConsent
  factories {
    id
    name
    customer {
      id
      name
    }
    viewerRole
  }
  customers {
    items {
      name
      id
      viewerRole
      userCount
      factoryCount
    }
  }
  customer {
    id
  }
  defaultFactoryId
  hasAppAccess
}
    `;
export const InvitationBaseFragmentDoc = gql`
    fragment InvitationBase on FactoryInvitation {
  id
  role
  createdAt
  validUntil
  completedAt
  state
  inviter {
    id
    name
  }
  factory {
    id
    name
    customer {
      __typename
      id
      name
    }
  }
}
    `;
export const TsDataFragmentDoc = gql`
    fragment TsData on TimeSeriesData {
  __typename
  timestamp
  value: avg
  minValue: min
  maxValue: max
}
    `;
export const ModelMethodFragmentDoc = gql`
    fragment ModelMethod on ModelMethod {
  __typename
  id
  name
}
    `;
export const ModelTypeFragmentDoc = gql`
    fragment ModelType on ModelType {
  __typename
  id
  name
  methods {
    ...ModelMethod
  }
  defaultMethod {
    ...ModelMethod
  }
}
    ${ModelMethodFragmentDoc}`;
export const ModelTagBaseTimeRangeFragmentDoc = gql`
    fragment ModelTagBaseTimeRange on ProcessDataEventTimeRange {
  __typename
  min
  max
}
    `;
export const ModelTagBaseFragmentDoc = gql`
    fragment ModelTagBase on Tag {
  __typename
  id
  tagName
  engUnit
  description
  displayName
  availableDataTimeRange {
    ...ModelTagBaseTimeRange
  }
  automaticLabel
  overriddenLabel
}
    ${ModelTagBaseTimeRangeFragmentDoc}`;
export const ActiveTrainedModelFragmentDoc = gql`
    fragment ActiveTrainedModel on TrainedModel {
  __typename
  valMae
  valRSquare
  valRSquareHealth
  targetStd
  targetStdHealth
  targetMaeReduction
  targetMaeReductionHealth
  anomalyCount
  dataEnd
  dataStart
}
    `;
export const ModelBaseFragmentDoc = gql`
    fragment ModelBase on Model {
  __typename
  id
  name
  description
  state
  created
  trainingStart
  trainingEnd
  trainingPeriod
  trainingPeriodExclusions {
    start
    end
  }
  initialInferenceStart
  initialInferenceEnd
  errorMessage
  type {
    __typename
    id
    name
  }
  method {
    __typename
    id
    name
  }
  tag {
    ...ModelTagBase
  }
  inputTags {
    ...ModelTagBase
  }
  activeTrainedModel {
    ...ActiveTrainedModel
  }
  createdBy {
    __typename
    id
    name
  }
  viewerHasStarred
}
    ${ModelTagBaseFragmentDoc}
${ActiveTrainedModelFragmentDoc}`;
export const AnomalyConditionsFragmentDoc = gql`
    fragment AnomalyConditions on AnomalyCondition {
  errorScore {
    kind
    transform
  }
  threshold
  thresholdKind
}
    `;
export const ModelAnomalyCommentFragmentDoc = gql`
    fragment ModelAnomalyComment on AnomalyComment {
  at
  by
  comment
}
    `;
export const ModelAnomalyFragmentDoc = gql`
    fragment ModelAnomaly on Anomaly {
  id
  restId
  start
  end
  score
  state
  inProgress
  comments {
    ...ModelAnomalyComment
  }
}
    ${ModelAnomalyCommentFragmentDoc}`;
export const FetchAnomalyModelFragmentDoc = gql`
    fragment FetchAnomalyModel on AnomalyModel {
  anomalyGenerationFilter
  availableErrorScores {
    kind
    transform
  }
  anomalyConditions {
    ...AnomalyConditions
  }
  anomalies {
    ...ModelAnomaly
  }
}
    ${AnomalyConditionsFragmentDoc}
${ModelAnomalyFragmentDoc}`;
export const FetchForecastModelFragmentDoc = gql`
    fragment FetchForecastModel on ForecastModel {
  forecastHorizon
}
    `;
export const FetchPrescriptiveModelFragmentDoc = gql`
    fragment FetchPrescriptiveModel on PrescriptiveModel {
  targetValue
}
    `;
export const FetchModelFragmentDoc = gql`
    fragment FetchModel on Model {
  ...ModelBase
  ... on AnomalyModel {
    ...FetchAnomalyModel
  }
  ... on ForecastModel {
    ...FetchForecastModel
  }
  ... on PrescriptiveModel {
    ...FetchPrescriptiveModel
  }
}
    ${ModelBaseFragmentDoc}
${FetchAnomalyModelFragmentDoc}
${FetchForecastModelFragmentDoc}
${FetchPrescriptiveModelFragmentDoc}`;
export const LatestRecomendationFragmentDoc = gql`
    fragment LatestRecomendation on PrescriptiveModel {
  __typename
  latest {
    recommendations {
      tagId
      value
    }
  }
}
    `;
export const ModelInputTagDetailsFragmentDoc = gql`
    fragment ModelInputTagDetails on Tag {
  id
  tagName
  displayName
  engUnit
  description
}
    `;
export const ModelInputTagFragmentDoc = gql`
    fragment ModelInputTag on ModelInputTagEdge {
  node {
    ...ModelInputTagDetails
  }
  isControllable
}
    ${ModelInputTagDetailsFragmentDoc}`;
export const ModelIdStateFragmentDoc = gql`
    fragment ModelIdState on Model {
  __typename
  id
  state
}
    `;
export const UpdateModelAnomalyConditionsFragmentDoc = gql`
    fragment UpdateModelAnomalyConditions on Model {
  __typename
  id
  ... on AnomalyModel {
    anomalyConditions {
      ...AnomalyConditions
    }
  }
}
    ${AnomalyConditionsFragmentDoc}`;
export const UpdateModelThresholdsFragmentDoc = gql`
    fragment UpdateModelThresholds on Model {
  __typename
  id
  ... on AnomalyModel {
    spikeAnomalyThreshold
    shortAnomalyThreshold
  }
}
    `;
export const UpdateModelFilterFragmentDoc = gql`
    fragment UpdateModelFilter on Model {
  __typename
  id
  ... on AnomalyModel {
    anomalyGenerationFilter
  }
}
    `;
export const StarrableStateFragmentDoc = gql`
    fragment StarrableState on Starrable {
  viewerHasStarred
}
    `;
export const AgentReleaseFragmentDoc = gql`
    fragment AgentRelease on AgentRelease {
  id
  semver
  release
  summary
  isBeta
  fullDescription
  url
  tags
  sha256Hash
  fileName
}
    `;
export const OpcConnectionFragmentDoc = gql`
    fragment OpcConnection on OpcConnection {
  id
  agentId
  factoryId
  name
  endpoint
  securityPolicy
  securityMode
  username
  x509Thumbprint
  ignoreServerEndpoint
  configurationState
}
    `;
export const GatewayFragmentDoc = gql`
    fragment Gateway on Agent {
  id
  createdOn
  lastPing
  version
  startTime
  hostname
  opcConnections {
    items {
      ...OpcConnection
    }
  }
}
    ${OpcConnectionFragmentDoc}`;
export const NodeValuesFragmentDoc = gql`
    fragment NodeValues on OpcReadResult {
  nodeId
  value {
    value {
      ... on OpcValueBoolean {
        booleanValue: value
      }
      ... on OpcValueShort {
        shortValue: value
      }
      ... on OpcValueInt {
        intValue: value
      }
      ... on OpcValueLong {
        longValue: value
      }
      ... on OpcValueUShort {
        ushortValue: value
      }
      ... on OpcValueUInt {
        uintValue: value
      }
      ... on OpcValueULong {
        ulongValue: value
      }
      ... on OpcValueFloat {
        floatValue: value
      }
      ... on OpcValueDouble {
        doubleValue: value
      }
      ... on OpcValueString {
        stringValue: value
      }
      ... on OpcValueDateTime {
        dateTimeValue: value
      }
      ... on OpcValueError {
        error
      }
    }
    status {
      value
      severity
    }
    sourceTimestamp
    serverTimestamp
  }
}
    `;
export const OpcNodeFragmentDoc = gql`
    fragment OpcNode on OpcNode {
  __typename
  nodeId
  browseName
  displayName
  description
  ... on VariableOpcNode {
    dataType
  }
}
    `;
export const BrowseNodeFragmentDoc = gql`
    fragment BrowseNode on OpcBrowseResponse {
  node {
    ...OpcNode
  }
  children {
    ...OpcNode
  }
}
    ${OpcNodeFragmentDoc}`;
export const OpcSubscriptionFragmentDoc = gql`
    fragment OpcSubscription on OpcSubscription {
  id
  agentId
  lastUpdated
  revision
  opcConnectionId
  autoStart
  batchInterval
  heartbeatNode
  heartbeatInterval
  nodes {
    totalCount
  }
}
    `;
export const OpcUaTaskFragmentDoc = gql`
    fragment OpcUaTask on OpcUaSyncTask {
  id
  startTime
  endTime
  startNode
  lastUpdate
  nodesSeen
  referencesSeen
  nodesBrowsed
  nodesQueued
  browseErrors
  error
  state
  arrowUriNodes
  arrowUriReferences
}
    `;
export const OpcUaSyncTasksFragmentDoc = gql`
    fragment OpcUaSyncTasks on OpcConnection {
  __typename
  lastHierarchySyncTask {
    ...OpcUaTask
  }
  lastSuccessfulHierarchySyncTask {
    ...OpcUaTask
  }
}
    ${OpcUaTaskFragmentDoc}`;
export const UpdatedTagFragmentDoc = gql`
    fragment UpdatedTag on Tag {
  id
  tagName
  description
  displayName
  engUnit
  automaticLabel
  overriddenLabel
}
    `;
export const TagDetailsFragmentDoc = gql`
    fragment TagDetails on Tag {
  id
  tagName
  description
  valueType
  engUnit
  displayName
  availableDataTimeRange {
    min
    max
  }
}
    `;
export const AnomalyCommentBaseFragmentDoc = gql`
    fragment AnomalyCommentBase on AnomalyComment {
  id
  comment
  by
  at
}
    `;
export const AnomalyBaseFragmentDoc = gql`
    fragment AnomalyBase on Anomaly {
  id
  start
  score
  state
  end
  inProgress
  restId
  comments {
    ...AnomalyCommentBase
  }
  model {
    id
    name
    typeId
    state
    tag {
      tagName
      displayName
      id
      hierarchyTag {
        id
        asset {
          id
          name
          alias
        }
      }
    }
  }
}
    ${AnomalyCommentBaseFragmentDoc}`;
export const NavigationAnomalyFragmentDoc = gql`
    fragment NavigationAnomaly on Anomaly {
  id
  start
  end
  score
}
    `;
export const FetchAnomalyFragmentDoc = gql`
    fragment FetchAnomaly on Anomaly {
  ...AnomalyBase
  previous {
    ...NavigationAnomaly
  }
  next {
    ...NavigationAnomaly
  }
}
    ${AnomalyBaseFragmentDoc}
${NavigationAnomalyFragmentDoc}`;
export const LatestCommentAnomalyFragmentDoc = gql`
    fragment LatestCommentAnomaly on Anomaly {
  id
  start
  model {
    id
    name
  }
}
    `;
export const LatestCommentFragmentDoc = gql`
    fragment LatestComment on AnomalyComment {
  id
  comment
  by
  at
  anomaly {
    ...LatestCommentAnomaly
  }
}
    ${LatestCommentAnomalyFragmentDoc}`;
export const DocumentationUrlFragmentDoc = gql`
    fragment DocumentationUrl on DocumentationUrl {
  url
  token
  expiry
}
    `;
export const FactoryTrendViewFragmentDoc = gql`
    fragment FactoryTrendView on TrendView {
  id
  name
  data
  shared
  createdAt
  factoryId
  updatedAt
  user {
    id
    name
  }
  viewerHasStarred
}
    `;
export const MeDocument = gql`
    query Me {
  me {
    ...Me
  }
}
    ${MeFragmentDoc}`;
export const FetchUserInvitationsDocument = gql`
    query FetchUserInvitations {
  me {
    invitations {
      items {
        ...InvitationBase
      }
    }
  }
}
    ${InvitationBaseFragmentDoc}`;
export const FetchModelAnomalyScoreDocument = gql`
    query FetchModelAnomalyScore($id: ID!, $from: DateTime!, $to: DateTime!, $interval: Int!, $errorScoreKind: ErrorScoreKind!, $transform: Transform!) {
  node(id: $id) {
    __typename
    id
    ... on AnomalyModel {
      errorScore2(
        from: $from
        to: $to
        interval: $interval
        errorScoreKind: $errorScoreKind
        transform: $transform
      ) {
        __typename
        data {
          ...TsData
        }
      }
    }
  }
}
    ${TsDataFragmentDoc}`;
export const ProcessDataDocument = gql`
    query ProcessData($factory: ID!, $tagName: String!, $from: DateTime!, $to: DateTime!, $interval: Int!) {
  factory(id: $factory) {
    __typename
    tagByName(tagname: $tagName) {
      __typename
      processData(from: $from, to: $to, interval: $interval) {
        __typename
        data {
          ...TsData
        }
      }
    }
  }
}
    ${TsDataFragmentDoc}`;
export const PredictionsDocument = gql`
    query Predictions($id: ID!, $from: DateTime!, $to: DateTime!, $interval: Int!) {
  node(id: $id) {
    __typename
    id
    ... on AnomalyModel {
      prediction(from: $from, to: $to, interval: $interval) {
        __typename
        data {
          ...TsData
        }
      }
    }
  }
}
    ${TsDataFragmentDoc}`;
export const FetchModelTypesDocument = gql`
    query FetchModelTypes {
  modelTypes {
    ...ModelType
  }
}
    ${ModelTypeFragmentDoc}`;
export const FetchModelsDocument = gql`
    query FetchModels($factory: ID!) {
  factory(id: $factory) {
    __typename
    models {
      __typename
      items {
        ...ModelBase
        ... on ForecastModel {
          forecastHorizon
        }
      }
    }
  }
}
    ${ModelBaseFragmentDoc}`;
export const FetchHistoricalForecastDocument = gql`
    query FetchHistoricalForecast($modelId: ID!, $from: DateTime!, $to: DateTime!, $offset: Milliseconds!) {
  node(id: $modelId) {
    id
    __typename
    ... on ForecastModel {
      historicalForecast(from: $from, to: $to, offset: $offset) {
        interval
        from
        to
        data {
          timestamp
          min
          max
          avg
        }
      }
    }
  }
}
    `;
export const FetchHistoricalRecommendationsDocument = gql`
    query FetchHistoricalRecommendations($modelId: ID!, $tagId: ID!, $from: DateTime!, $to: DateTime!, $interval: Int!) {
  node(id: $modelId) {
    __typename
    ... on PrescriptiveModel {
      historicalRecommendations(
        tagId: $tagId
        from: $from
        to: $to
        interval: $interval
      ) {
        data {
          ...TsData
        }
      }
    }
  }
}
    ${TsDataFragmentDoc}`;
export const FetchModelDocument = gql`
    query FetchModel($modelId: ID!) {
  node(id: $modelId) {
    ...FetchModel
  }
}
    ${FetchModelFragmentDoc}`;
export const FetchLatestRecomendationsDocument = gql`
    query FetchLatestRecomendations($modelId: ID!) {
  node(id: $modelId) {
    ... on PrescriptiveModel {
      ...LatestRecomendation
    }
  }
}
    ${LatestRecomendationFragmentDoc}`;
export const FetchModelInputTagsDocument = gql`
    query fetchModelInputTags($modelId: ID!) {
  node(id: $modelId) {
    ... on Model {
      __typename
      modelInputTags {
        edges {
          ...ModelInputTag
        }
      }
    }
  }
}
    ${ModelInputTagFragmentDoc}`;
export const ArchiveModelDocument = gql`
    mutation ArchiveModel($input: ArchiveModelInput!) {
  archiveModel(input: $input) {
    __typename
    model {
      ...ModelIdState
    }
  }
}
    ${ModelIdStateFragmentDoc}`;
export const DeleteModelDocument = gql`
    mutation DeleteModel($input: DeleteModelInput!) {
  deleteModel(input: $input) {
    __typename
    model {
      ...ModelIdState
    }
  }
}
    ${ModelIdStateFragmentDoc}`;
export const StartModelDocument = gql`
    mutation StartModel($input: StartModelInput!) {
  startModel(input: $input) {
    __typename
    model {
      ...ModelIdState
    }
  }
}
    ${ModelIdStateFragmentDoc}`;
export const StopModelDocument = gql`
    mutation StopModel($input: StopModelInput!) {
  stopModel(input: $input) {
    __typename
    model {
      ...ModelIdState
    }
  }
}
    ${ModelIdStateFragmentDoc}`;
export const ActivateModelDocument = gql`
    mutation ActivateModel($input: ActivateModelInput!) {
  activateModel(input: $input) {
    __typename
    model {
      ...ModelIdState
    }
  }
}
    ${ModelIdStateFragmentDoc}`;
export const CopyModelDocument = gql`
    mutation CopyModel($input: CopyModelInput!) {
  copyModel(input: $input) {
    __typename
    model {
      ...ModelBase
    }
  }
}
    ${ModelBaseFragmentDoc}`;
export const RunAnomalyDetectionDocument = gql`
    mutation RunAnomalyDetection($input: RunAnomalyDetectionInput!) {
  runAnomalyDetection(input: $input) {
    __typename
    model {
      ...ModelIdState
    }
  }
}
    ${ModelIdStateFragmentDoc}`;
export const UpdateModelDocument = gql`
    mutation UpdateModel($input: UpdateModelInput!) {
  updateModel(input: $input) {
    __typename
    model {
      ...ModelBase
    }
  }
}
    ${ModelBaseFragmentDoc}`;
export const UpdateModelTrainingConfigurationDocument = gql`
    mutation UpdateModelTrainingConfiguration($input: SetModelTrainingConfigurationInput!) {
  setModelTrainingConfiguration(input: $input) {
    __typename
    model {
      ...ModelBase
    }
  }
}
    ${ModelBaseFragmentDoc}`;
export const RemoveInputTagsFromModelDocument = gql`
    mutation RemoveInputTagsFromModel($input: RemoveInputTagsFromModelInput!) {
  removeInputTagsFromModel(input: $input) {
    __typename
    model {
      ...ModelBase
    }
  }
}
    ${ModelBaseFragmentDoc}`;
export const AddInputTagsToModelDocument = gql`
    mutation AddInputTagsToModel($input: AddInputTagsToModelInput!) {
  addInputTagsToModel(input: $input) {
    __typename
    model {
      ...ModelBase
    }
  }
}
    ${ModelBaseFragmentDoc}`;
export const UpdatePrescriptiveModelTagsDocument = gql`
    mutation updatePrescriptiveModelTags($input: UpdatePrescriptiveModelTagsInput!) {
  updatePrescriptiveModelTags(input: $input) {
    __typename
    model {
      ...FetchPrescriptiveModel
    }
  }
}
    ${FetchPrescriptiveModelFragmentDoc}`;
export const CreateModelDocument = gql`
    mutation CreateModel($input: CreateModelInput!) {
  createModel(input: $input) {
    __typename
    model {
      ...ModelBase
    }
  }
}
    ${ModelBaseFragmentDoc}`;
export const CreatePrescriptiveModelDocument = gql`
    mutation CreatePrescriptiveModel($input: CreatePrescriptiveModelInput!) {
  createPrescriptiveModel(input: $input) {
    __typename
    model {
      ...ModelBase
    }
  }
}
    ${ModelBaseFragmentDoc}`;
export const UpdateModelAnomalyConditionsDocument = gql`
    mutation UpdateModelAnomalyConditions($input: UpdateModelAnomalyConditionsInput!) {
  updateModelAnomalyConditions(input: $input) {
    __typename
    model {
      ...UpdateModelAnomalyConditions
    }
  }
}
    ${UpdateModelAnomalyConditionsFragmentDoc}`;
export const UpdateModelThresholdsDocument = gql`
    mutation UpdateModelThresholds($input: UpdateModelThresholdsInput!) {
  updateModelThresholds(input: $input) {
    __typename
    model {
      ...UpdateModelThresholds
    }
  }
}
    ${UpdateModelThresholdsFragmentDoc}`;
export const UpdateModelFilterDocument = gql`
    mutation UpdateModelFilter($input: UpdateModelFilterInput!) {
  updateModelFilter(input: $input) {
    __typename
    model {
      ...UpdateModelFilter
    }
  }
}
    ${UpdateModelFilterFragmentDoc}`;
export const AddStarDocument = gql`
    mutation AddStar($input: AddStarInput!) {
  addStar(input: $input) {
    __typename
    starrable {
      ...StarrableState
    }
  }
}
    ${StarrableStateFragmentDoc}`;
export const RemoveStarDocument = gql`
    mutation RemoveStar($input: RemoveStarInput!) {
  removeStar(input: $input) {
    __typename
    starrable {
      ...StarrableState
    }
  }
}
    ${StarrableStateFragmentDoc}`;
export const FetchFactoryUsersDocument = gql`
    query FetchFactoryUsers($factory: ID!) {
  factory(id: $factory) {
    customer {
      id
      name
    }
    users {
      edges {
        node {
          id
          name
          email
          status
          createdBy {
            id
            name
          }
          customer {
            id
            name
          }
        }
        role
      }
    }
  }
}
    `;
export const FetchAgentReleasesDocument = gql`
    query FetchAgentReleases {
  agentReleases {
    items {
      ...AgentRelease
    }
  }
}
    ${AgentReleaseFragmentDoc}`;
export const FetchFactoryAgentsDocument = gql`
    query FetchFactoryAgents($factory: ID!) {
  factory(id: $factory) {
    agents {
      edges {
        node {
          ...Gateway
        }
      }
    }
  }
}
    ${GatewayFragmentDoc}`;
export const FetchFactoryAgentDocument = gql`
    query FetchFactoryAgent($factory: ID!, $agent: ID!) {
  factory(id: $factory) {
    agent(id: $agent) {
      ...Gateway
    }
  }
}
    ${GatewayFragmentDoc}`;
export const FetchFactoryInvitationsDocument = gql`
    query FetchFactoryInvitations($factory: ID!) {
  factory(id: $factory) {
    invitations {
      edges {
        node {
          ...InvitationBase
          invitee {
            id
            name
            email
            customer {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${InvitationBaseFragmentDoc}`;
export const FetchFactoryCreditsDocument = gql`
    query FetchFactoryCredits($factory: ID!) {
  factory(id: $factory) {
    activeModelCreditsUsage {
      total
      batch {
        type
        creditsPerModel
        models
        total
      }
      streaming {
        type
        creditsPerModel
        models
        total
      }
    }
  }
}
    `;
export const FetchFactoryDexAccessDocument = gql`
    query FetchFactoryDexAccess($factory: ID!) {
  factory(id: $factory) {
    dexAccess
  }
}
    `;
export const TestOpcUaConnectionDocument = gql`
    query TestOpcUaConnection($factory: ID!, $agent: ID!, $url: String!) {
  factory(id: $factory) {
    agent(id: $agent) {
      id
      serverEndpoints(url: $url) {
        error
        endpoints {
          url
          securityMode
          securityPolicy
          userIdentityTokens {
            policyId
            userTokenType
            issuedTokenType
            issuerEndpointUrl
            securityPolicy
          }
          server {
            applicationURI
            productURI
            applicationName
            applicationType
            gatewayServerURI
            discoveryProfileURI
            discoveryUrls
          }
        }
      }
      listCertificates {
        error
        certificates {
          path
          thumbprint
          serialNumber
          createdAt
          expiresAt
        }
      }
    }
  }
}
    `;
export const FetchOpcConnectionsDocument = gql`
    query FetchOpcConnections($factory: ID!, $agent: ID!) {
  factory(id: $factory) {
    agent(id: $agent) {
      id
      opcConnections {
        items {
          ...OpcConnection
        }
      }
    }
  }
}
    ${OpcConnectionFragmentDoc}`;
export const ValidateOpcUaConnectionDocument = gql`
    query ValidateOpcUaConnection($factory: ID!, $agentId: ID!, $connection: ValidateOpcConnectionInput!) {
  factory(id: $factory) {
    agent(id: $agentId) {
      validateOpcConnection(connection: $connection) {
        error
        success
      }
    }
  }
}
    `;
export const ReadNodeValuesDocument = gql`
    query ReadNodeValues($connectionId: ID!, $nodeIds: [String!]!, $timeout: Milliseconds!) {
  node(id: $connectionId) {
    id
    __typename
    ... on OpcConnection {
      readValues(nodeIds: $nodeIds, timeout: $timeout) {
        ...NodeValues
      }
    }
  }
}
    ${NodeValuesFragmentDoc}`;
export const OpcBrowseDocument = gql`
    query OpcBrowse($connectionId: ID!, $nodeId: String!, $timeout: Milliseconds!) {
  node(id: $connectionId) {
    id
    __typename
    ... on OpcConnection {
      name
      browse(nodeId: $nodeId, timeout: $timeout) {
        ...BrowseNode
      }
    }
  }
}
    ${BrowseNodeFragmentDoc}`;
export const GetSubscriptionsDocument = gql`
    query GetSubscriptions($agentId: ID!) {
  node(id: $agentId) {
    ... on Agent {
      __typename
      opcSubscriptions {
        items {
          ...OpcSubscription
        }
      }
    }
  }
}
    ${OpcSubscriptionFragmentDoc}`;
export const GetSubscriptionDocument = gql`
    query GetSubscription($subscriptionId: ID!) {
  node(id: $subscriptionId) {
    ... on OpcSubscription {
      __typename
      ...OpcSubscription
    }
  }
}
    ${OpcSubscriptionFragmentDoc}`;
export const GetSubscriptionNodesDocument = gql`
    query GetSubscriptionNodes($subscriptionId: ID!, $first: Int!, $cursor: String) {
  node(id: $subscriptionId) {
    ... on OpcSubscription {
      __typename
      id
      nodes(first: $first, after: $cursor) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        items {
          nodeId
        }
      }
    }
  }
}
    `;
export const GetSubscriptionSyncTasksDocument = gql`
    query GetSubscriptionSyncTasks($connectionId: ID!) {
  node(id: $connectionId) {
    ...OpcUaSyncTasks
  }
}
    ${OpcUaSyncTasksFragmentDoc}`;
export const SetFactoryUserRoleDocument = gql`
    mutation SetFactoryUserRole($input: SetFactoryUserRoleInput!) {
  setFactoryUserRole(input: $input) {
    __typename
    factory {
      id
    }
    userEdge {
      role
      node {
        id
        name
      }
    }
  }
}
    `;
export const RemoveFactoryUserDocument = gql`
    mutation RemoveFactoryUser($input: RemoveFactoryUserInput!) {
  removeFactoryUser(input: $input) {
    __typename
    factory {
      id
    }
    userEdge {
      role
      node {
        id
        name
      }
    }
  }
}
    `;
export const RemoveCustomerUserDocument = gql`
    mutation RemoveCustomerUser($input: RemoveCustomerUserInput!) {
  removeCustomerUser(input: $input) {
    __typename
    customer {
      id
    }
    userEdge {
      role
      node {
        id
        name
      }
    }
  }
}
    `;
export const UpdateUserConsentDocument = gql`
    mutation UpdateUserConsent($input: UpdateUserConsentInput!) {
  updateUserConsent(input: $input) {
    __typename
    user {
      id
      cookieConsent
      dataCollectionConsent
      name
    }
  }
}
    `;
export const UpdateUserDefaultFactoryDocument = gql`
    mutation UpdateUserDefaultFactory($input: UpdateUserDefaultFactoryInput!) {
  updateUserDefaultFactory(input: $input) {
    __typename
    user {
      id
      defaultFactoryId
    }
  }
}
    `;
export const FetchFactoryDocument = gql`
    query FetchFactory($id: ID!) {
  factory(id: $id) {
    __typename
    id
    name
    customer {
      id
      name
    }
    dexAccess
    viewerRole
    userCount
    agents {
      items {
        __typename
        id
      }
    }
  }
}
    `;
export const FetchMyFactoriesDocument = gql`
    query FetchMyFactories {
  me {
    factories {
      id
      name
      viewerRole
      customer {
        id
        name
      }
      users {
        items {
          id
        }
      }
      agents {
        items {
          id
        }
      }
    }
  }
}
    `;
export const FetchCustomerDocument = gql`
    query FetchCustomer($id: ID!, $status: UserStatus = ENABLED) {
  me {
    customer {
      id
    }
  }
  customer(id: $id) {
    id
    name
    viewerRole
    factoryCount
    factories {
      items {
        id
        name
        viewerRole
        userCount
        agents {
          items {
            id
          }
        }
      }
    }
    users(status: $status) {
      edges {
        node {
          id
          name
          email
          status
          customer {
            id
            name
          }
        }
        role
      }
    }
  }
}
    `;
export const DisableUserDocument = gql`
    mutation DisableUser($input: DisableUserInput!) {
  disableUser(input: $input) {
    __typename
    user {
      id
      cookieConsent
      dataCollectionConsent
      name
    }
  }
}
    `;
export const EnableUserDocument = gql`
    mutation EnableUser($input: EnableUserInput!) {
  enableUser(input: $input) {
    __typename
    user {
      id
    }
  }
}
    `;
export const AddUserDocument = gql`
    mutation AddUser($input: AddUserInput!) {
  addUser(input: $input) {
    __typename
    user {
      id
      cookieConsent
      dataCollectionConsent
      name
    }
  }
}
    `;
export const SetCustomerUserRoleDocument = gql`
    mutation SetCustomerUserRole($input: SetCustomerUserRoleInput!) {
  setCustomerUserRole(input: $input) {
    __typename
    customer {
      id
    }
    userEdge {
      role
      node {
        id
        name
      }
    }
  }
}
    `;
export const InviteFactoryUserDocument = gql`
    mutation InviteFactoryUser($input: InviteFactoryUserInput!) {
  inviteFactoryUser(input: $input) {
    __typename
    invitation {
      id
      state
    }
  }
}
    `;
export const AcceptFactoryInvitationDocument = gql`
    mutation AcceptFactoryInvitation($input: AcceptFactoryInvitationInput!) {
  acceptFactoryInvitation(input: $input) {
    invitation {
      id
      state
    }
  }
}
    `;
export const DeclineFactoryInvitationDocument = gql`
    mutation DeclineFactoryInvitation($input: DeclineFactoryInvitationInput!) {
  declineFactoryInvitation(input: $input) {
    invitation {
      id
      state
    }
  }
}
    `;
export const CancelFactoryInvitationDocument = gql`
    mutation CancelFactoryInvitation($input: CancelFactoryInvitationInput!) {
  cancelFactoryInvitation(input: $input) {
    invitation {
      id
      state
    }
  }
}
    `;
export const AnomalyCountByStateDocument = gql`
    query AnomalyCountByState($id: ID!) {
  factory(id: $id) {
    anomalyCountByState {
      state
      count
    }
  }
}
    `;
export const UpdateTagDocument = gql`
    mutation UpdateTag($input: UpdateTagInput!) {
  updateTag(input: $input) {
    __typename
    tag {
      ...UpdatedTag
    }
  }
}
    ${UpdatedTagFragmentDoc}`;
export const FetchTagDocument = gql`
    query FetchTag($factory: ID!, $tagName: String!) {
  factory(id: $factory) {
    tagByName(tagname: $tagName) {
      ...TagDetails
    }
  }
}
    ${TagDetailsFragmentDoc}`;
export const FetchAnomaliesDocument = gql`
    query FetchAnomalies($factory: ID!, $from: DateTime!, $to: DateTime!) {
  factory(id: $factory) {
    anomalies(from: $from, to: $to) {
      edges {
        node {
          ...AnomalyBase
        }
      }
    }
  }
}
    ${AnomalyBaseFragmentDoc}`;
export const FetchAnomalyDocument = gql`
    query FetchAnomaly($factory: ID!, $anomaly: ID!) {
  factory(id: $factory) {
    __typename
    anomaly(id: $anomaly) {
      ...FetchAnomaly
    }
  }
}
    ${FetchAnomalyFragmentDoc}`;
export const FetchLatestCommentsDocument = gql`
    query FetchLatestComments($factory: ID!) {
  factory(id: $factory) {
    latestAnomalyComments {
      ...LatestComment
    }
  }
}
    ${LatestCommentFragmentDoc}`;
export const AddAnomalyCommentDocument = gql`
    mutation AddAnomalyComment($input: AddAnomalyCommentInput!) {
  addAnomalyComment(input: $input) {
    __typename
    comment {
      ...AnomalyCommentBase
    }
  }
}
    ${AnomalyCommentBaseFragmentDoc}`;
export const SetAnomalyStateDocument = gql`
    mutation SetAnomalyState($input: SetAnomalyStateInput!) {
  setAnomalyState(input: $input) {
    __typename
    anomaly {
      ...FetchAnomaly
    }
  }
}
    ${FetchAnomalyFragmentDoc}`;
export const FetchDocsLinkDocument = gql`
    query FetchDocsLink {
  documentationUrl {
    ...DocumentationUrl
  }
}
    ${DocumentationUrlFragmentDoc}`;
export const FetchFactoryTrendViewsDocument = gql`
    query FetchFactoryTrendViews($factory: ID!) {
  factory(id: $factory) {
    trendViews {
      items {
        ...FactoryTrendView
      }
    }
  }
}
    ${FactoryTrendViewFragmentDoc}`;
export const CreateTrendViewDocument = gql`
    mutation createTrendView($input: CreateTrendViewInput!) {
  createTrendView(input: $input) {
    trendView {
      ...FactoryTrendView
    }
  }
}
    ${FactoryTrendViewFragmentDoc}`;
export const UpdateTrendViewDocument = gql`
    mutation updateTrendView($input: UpdateTrendViewInput!) {
  updateTrendView(input: $input) {
    trendView {
      ...FactoryTrendView
    }
  }
}
    ${FactoryTrendViewFragmentDoc}`;
export const DeleteTrendViewDocument = gql`
    mutation deleteTrendView($input: DeleteTrendViewInput!) {
  deleteTrendView(input: $input) {
    trendView {
      ...FactoryTrendView
    }
  }
}
    ${FactoryTrendViewFragmentDoc}`;
export const CreateOpcConnectionDocument = gql`
    mutation createOpcConnection($input: CreateOpcConnectionInput!) {
  createOpcConnection(input: $input) {
    connection {
      ...OpcConnection
    }
  }
}
    ${OpcConnectionFragmentDoc}`;
export const UpdateOpcConnectionDocument = gql`
    mutation updateOpcConnection($input: UpdateOpcConnectionInput!) {
  updateOpcConnection(input: $input) {
    connection {
      ...OpcConnection
    }
  }
}
    ${OpcConnectionFragmentDoc}`;
export const UpdateSubscribedNodesDocument = gql`
    mutation updateSubscribedNodes($input: UpdateSubscribedNodesInput!) {
  updateSubscribedNodes(input: $input) {
    subscribed
    unsubscribed
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Me(variables?: GqlMeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlMeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlMeQuery>(MeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Me', 'query', variables);
    },
    FetchUserInvitations(variables?: GqlFetchUserInvitationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchUserInvitationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchUserInvitationsQuery>(FetchUserInvitationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchUserInvitations', 'query', variables);
    },
    FetchModelAnomalyScore(variables: GqlFetchModelAnomalyScoreQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchModelAnomalyScoreQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchModelAnomalyScoreQuery>(FetchModelAnomalyScoreDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchModelAnomalyScore', 'query', variables);
    },
    ProcessData(variables: GqlProcessDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlProcessDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlProcessDataQuery>(ProcessDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ProcessData', 'query', variables);
    },
    Predictions(variables: GqlPredictionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlPredictionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlPredictionsQuery>(PredictionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Predictions', 'query', variables);
    },
    FetchModelTypes(variables?: GqlFetchModelTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchModelTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchModelTypesQuery>(FetchModelTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchModelTypes', 'query', variables);
    },
    FetchModels(variables: GqlFetchModelsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchModelsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchModelsQuery>(FetchModelsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchModels', 'query', variables);
    },
    FetchHistoricalForecast(variables: GqlFetchHistoricalForecastQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchHistoricalForecastQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchHistoricalForecastQuery>(FetchHistoricalForecastDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchHistoricalForecast', 'query', variables);
    },
    FetchHistoricalRecommendations(variables: GqlFetchHistoricalRecommendationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchHistoricalRecommendationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchHistoricalRecommendationsQuery>(FetchHistoricalRecommendationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchHistoricalRecommendations', 'query', variables);
    },
    FetchModel(variables: GqlFetchModelQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchModelQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchModelQuery>(FetchModelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchModel', 'query', variables);
    },
    FetchLatestRecomendations(variables: GqlFetchLatestRecomendationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchLatestRecomendationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchLatestRecomendationsQuery>(FetchLatestRecomendationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchLatestRecomendations', 'query', variables);
    },
    fetchModelInputTags(variables: GqlFetchModelInputTagsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchModelInputTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchModelInputTagsQuery>(FetchModelInputTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fetchModelInputTags', 'query', variables);
    },
    ArchiveModel(variables: GqlArchiveModelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlArchiveModelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlArchiveModelMutation>(ArchiveModelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveModel', 'mutation', variables);
    },
    DeleteModel(variables: GqlDeleteModelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlDeleteModelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlDeleteModelMutation>(DeleteModelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteModel', 'mutation', variables);
    },
    StartModel(variables: GqlStartModelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlStartModelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlStartModelMutation>(StartModelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StartModel', 'mutation', variables);
    },
    StopModel(variables: GqlStopModelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlStopModelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlStopModelMutation>(StopModelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'StopModel', 'mutation', variables);
    },
    ActivateModel(variables: GqlActivateModelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlActivateModelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlActivateModelMutation>(ActivateModelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivateModel', 'mutation', variables);
    },
    CopyModel(variables: GqlCopyModelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlCopyModelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlCopyModelMutation>(CopyModelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CopyModel', 'mutation', variables);
    },
    RunAnomalyDetection(variables: GqlRunAnomalyDetectionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlRunAnomalyDetectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlRunAnomalyDetectionMutation>(RunAnomalyDetectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RunAnomalyDetection', 'mutation', variables);
    },
    UpdateModel(variables: GqlUpdateModelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlUpdateModelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlUpdateModelMutation>(UpdateModelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateModel', 'mutation', variables);
    },
    UpdateModelTrainingConfiguration(variables: GqlUpdateModelTrainingConfigurationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlUpdateModelTrainingConfigurationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlUpdateModelTrainingConfigurationMutation>(UpdateModelTrainingConfigurationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateModelTrainingConfiguration', 'mutation', variables);
    },
    RemoveInputTagsFromModel(variables: GqlRemoveInputTagsFromModelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlRemoveInputTagsFromModelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlRemoveInputTagsFromModelMutation>(RemoveInputTagsFromModelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveInputTagsFromModel', 'mutation', variables);
    },
    AddInputTagsToModel(variables: GqlAddInputTagsToModelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlAddInputTagsToModelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlAddInputTagsToModelMutation>(AddInputTagsToModelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddInputTagsToModel', 'mutation', variables);
    },
    updatePrescriptiveModelTags(variables: GqlUpdatePrescriptiveModelTagsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlUpdatePrescriptiveModelTagsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlUpdatePrescriptiveModelTagsMutation>(UpdatePrescriptiveModelTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePrescriptiveModelTags', 'mutation', variables);
    },
    CreateModel(variables: GqlCreateModelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlCreateModelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlCreateModelMutation>(CreateModelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateModel', 'mutation', variables);
    },
    CreatePrescriptiveModel(variables: GqlCreatePrescriptiveModelMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlCreatePrescriptiveModelMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlCreatePrescriptiveModelMutation>(CreatePrescriptiveModelDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreatePrescriptiveModel', 'mutation', variables);
    },
    UpdateModelAnomalyConditions(variables: GqlUpdateModelAnomalyConditionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlUpdateModelAnomalyConditionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlUpdateModelAnomalyConditionsMutation>(UpdateModelAnomalyConditionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateModelAnomalyConditions', 'mutation', variables);
    },
    UpdateModelThresholds(variables: GqlUpdateModelThresholdsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlUpdateModelThresholdsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlUpdateModelThresholdsMutation>(UpdateModelThresholdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateModelThresholds', 'mutation', variables);
    },
    UpdateModelFilter(variables: GqlUpdateModelFilterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlUpdateModelFilterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlUpdateModelFilterMutation>(UpdateModelFilterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateModelFilter', 'mutation', variables);
    },
    AddStar(variables: GqlAddStarMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlAddStarMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlAddStarMutation>(AddStarDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddStar', 'mutation', variables);
    },
    RemoveStar(variables: GqlRemoveStarMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlRemoveStarMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlRemoveStarMutation>(RemoveStarDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveStar', 'mutation', variables);
    },
    FetchFactoryUsers(variables: GqlFetchFactoryUsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchFactoryUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchFactoryUsersQuery>(FetchFactoryUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchFactoryUsers', 'query', variables);
    },
    FetchAgentReleases(variables?: GqlFetchAgentReleasesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchAgentReleasesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchAgentReleasesQuery>(FetchAgentReleasesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchAgentReleases', 'query', variables);
    },
    FetchFactoryAgents(variables: GqlFetchFactoryAgentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchFactoryAgentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchFactoryAgentsQuery>(FetchFactoryAgentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchFactoryAgents', 'query', variables);
    },
    FetchFactoryAgent(variables: GqlFetchFactoryAgentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchFactoryAgentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchFactoryAgentQuery>(FetchFactoryAgentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchFactoryAgent', 'query', variables);
    },
    FetchFactoryInvitations(variables: GqlFetchFactoryInvitationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchFactoryInvitationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchFactoryInvitationsQuery>(FetchFactoryInvitationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchFactoryInvitations', 'query', variables);
    },
    FetchFactoryCredits(variables: GqlFetchFactoryCreditsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchFactoryCreditsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchFactoryCreditsQuery>(FetchFactoryCreditsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchFactoryCredits', 'query', variables);
    },
    FetchFactoryDexAccess(variables: GqlFetchFactoryDexAccessQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchFactoryDexAccessQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchFactoryDexAccessQuery>(FetchFactoryDexAccessDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchFactoryDexAccess', 'query', variables);
    },
    TestOpcUaConnection(variables: GqlTestOpcUaConnectionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlTestOpcUaConnectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlTestOpcUaConnectionQuery>(TestOpcUaConnectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TestOpcUaConnection', 'query', variables);
    },
    FetchOpcConnections(variables: GqlFetchOpcConnectionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchOpcConnectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchOpcConnectionsQuery>(FetchOpcConnectionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchOpcConnections', 'query', variables);
    },
    ValidateOpcUaConnection(variables: GqlValidateOpcUaConnectionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlValidateOpcUaConnectionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlValidateOpcUaConnectionQuery>(ValidateOpcUaConnectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ValidateOpcUaConnection', 'query', variables);
    },
    ReadNodeValues(variables: GqlReadNodeValuesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlReadNodeValuesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlReadNodeValuesQuery>(ReadNodeValuesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ReadNodeValues', 'query', variables);
    },
    OpcBrowse(variables: GqlOpcBrowseQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlOpcBrowseQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlOpcBrowseQuery>(OpcBrowseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OpcBrowse', 'query', variables);
    },
    GetSubscriptions(variables: GqlGetSubscriptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlGetSubscriptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlGetSubscriptionsQuery>(GetSubscriptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSubscriptions', 'query', variables);
    },
    GetSubscription(variables: GqlGetSubscriptionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlGetSubscriptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlGetSubscriptionQuery>(GetSubscriptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSubscription', 'query', variables);
    },
    GetSubscriptionNodes(variables: GqlGetSubscriptionNodesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlGetSubscriptionNodesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlGetSubscriptionNodesQuery>(GetSubscriptionNodesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSubscriptionNodes', 'query', variables);
    },
    GetSubscriptionSyncTasks(variables: GqlGetSubscriptionSyncTasksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlGetSubscriptionSyncTasksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlGetSubscriptionSyncTasksQuery>(GetSubscriptionSyncTasksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSubscriptionSyncTasks', 'query', variables);
    },
    SetFactoryUserRole(variables: GqlSetFactoryUserRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlSetFactoryUserRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlSetFactoryUserRoleMutation>(SetFactoryUserRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetFactoryUserRole', 'mutation', variables);
    },
    RemoveFactoryUser(variables: GqlRemoveFactoryUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlRemoveFactoryUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlRemoveFactoryUserMutation>(RemoveFactoryUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveFactoryUser', 'mutation', variables);
    },
    RemoveCustomerUser(variables: GqlRemoveCustomerUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlRemoveCustomerUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlRemoveCustomerUserMutation>(RemoveCustomerUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveCustomerUser', 'mutation', variables);
    },
    UpdateUserConsent(variables: GqlUpdateUserConsentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlUpdateUserConsentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlUpdateUserConsentMutation>(UpdateUserConsentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUserConsent', 'mutation', variables);
    },
    UpdateUserDefaultFactory(variables: GqlUpdateUserDefaultFactoryMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlUpdateUserDefaultFactoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlUpdateUserDefaultFactoryMutation>(UpdateUserDefaultFactoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUserDefaultFactory', 'mutation', variables);
    },
    FetchFactory(variables: GqlFetchFactoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchFactoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchFactoryQuery>(FetchFactoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchFactory', 'query', variables);
    },
    FetchMyFactories(variables?: GqlFetchMyFactoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchMyFactoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchMyFactoriesQuery>(FetchMyFactoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchMyFactories', 'query', variables);
    },
    FetchCustomer(variables: GqlFetchCustomerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchCustomerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchCustomerQuery>(FetchCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchCustomer', 'query', variables);
    },
    DisableUser(variables: GqlDisableUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlDisableUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlDisableUserMutation>(DisableUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DisableUser', 'mutation', variables);
    },
    EnableUser(variables: GqlEnableUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlEnableUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlEnableUserMutation>(EnableUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EnableUser', 'mutation', variables);
    },
    AddUser(variables: GqlAddUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlAddUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlAddUserMutation>(AddUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddUser', 'mutation', variables);
    },
    SetCustomerUserRole(variables: GqlSetCustomerUserRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlSetCustomerUserRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlSetCustomerUserRoleMutation>(SetCustomerUserRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetCustomerUserRole', 'mutation', variables);
    },
    InviteFactoryUser(variables: GqlInviteFactoryUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlInviteFactoryUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlInviteFactoryUserMutation>(InviteFactoryUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InviteFactoryUser', 'mutation', variables);
    },
    AcceptFactoryInvitation(variables: GqlAcceptFactoryInvitationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlAcceptFactoryInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlAcceptFactoryInvitationMutation>(AcceptFactoryInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AcceptFactoryInvitation', 'mutation', variables);
    },
    DeclineFactoryInvitation(variables: GqlDeclineFactoryInvitationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlDeclineFactoryInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlDeclineFactoryInvitationMutation>(DeclineFactoryInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeclineFactoryInvitation', 'mutation', variables);
    },
    CancelFactoryInvitation(variables: GqlCancelFactoryInvitationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlCancelFactoryInvitationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlCancelFactoryInvitationMutation>(CancelFactoryInvitationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CancelFactoryInvitation', 'mutation', variables);
    },
    AnomalyCountByState(variables: GqlAnomalyCountByStateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlAnomalyCountByStateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlAnomalyCountByStateQuery>(AnomalyCountByStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AnomalyCountByState', 'query', variables);
    },
    UpdateTag(variables: GqlUpdateTagMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlUpdateTagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlUpdateTagMutation>(UpdateTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateTag', 'mutation', variables);
    },
    FetchTag(variables: GqlFetchTagQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchTagQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchTagQuery>(FetchTagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchTag', 'query', variables);
    },
    FetchAnomalies(variables: GqlFetchAnomaliesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchAnomaliesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchAnomaliesQuery>(FetchAnomaliesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchAnomalies', 'query', variables);
    },
    FetchAnomaly(variables: GqlFetchAnomalyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchAnomalyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchAnomalyQuery>(FetchAnomalyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchAnomaly', 'query', variables);
    },
    FetchLatestComments(variables: GqlFetchLatestCommentsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchLatestCommentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchLatestCommentsQuery>(FetchLatestCommentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchLatestComments', 'query', variables);
    },
    AddAnomalyComment(variables: GqlAddAnomalyCommentMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlAddAnomalyCommentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlAddAnomalyCommentMutation>(AddAnomalyCommentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddAnomalyComment', 'mutation', variables);
    },
    SetAnomalyState(variables: GqlSetAnomalyStateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlSetAnomalyStateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlSetAnomalyStateMutation>(SetAnomalyStateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetAnomalyState', 'mutation', variables);
    },
    FetchDocsLink(variables?: GqlFetchDocsLinkQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchDocsLinkQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchDocsLinkQuery>(FetchDocsLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchDocsLink', 'query', variables);
    },
    FetchFactoryTrendViews(variables: GqlFetchFactoryTrendViewsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlFetchFactoryTrendViewsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlFetchFactoryTrendViewsQuery>(FetchFactoryTrendViewsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FetchFactoryTrendViews', 'query', variables);
    },
    createTrendView(variables: GqlCreateTrendViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlCreateTrendViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlCreateTrendViewMutation>(CreateTrendViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTrendView', 'mutation', variables);
    },
    updateTrendView(variables: GqlUpdateTrendViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlUpdateTrendViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlUpdateTrendViewMutation>(UpdateTrendViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateTrendView', 'mutation', variables);
    },
    deleteTrendView(variables: GqlDeleteTrendViewMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlDeleteTrendViewMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlDeleteTrendViewMutation>(DeleteTrendViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTrendView', 'mutation', variables);
    },
    createOpcConnection(variables: GqlCreateOpcConnectionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlCreateOpcConnectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlCreateOpcConnectionMutation>(CreateOpcConnectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOpcConnection', 'mutation', variables);
    },
    updateOpcConnection(variables: GqlUpdateOpcConnectionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlUpdateOpcConnectionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlUpdateOpcConnectionMutation>(UpdateOpcConnectionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOpcConnection', 'mutation', variables);
    },
    updateSubscribedNodes(variables: GqlUpdateSubscribedNodesMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GqlUpdateSubscribedNodesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GqlUpdateSubscribedNodesMutation>(UpdateSubscribedNodesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSubscribedNodes', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;